import React from 'react';
import { createRoot } from 'react-dom/client';
import moment from "moment";
import Swal from "sweetalert2";

import { useTranslation } from "react-i18next";

import * as commonFunc from 'scripts/common';

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Mark from 'mark.js';

import {
    Form, Col,
    Button,
    Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";

import { Menu, Item, useContextMenu } from "react-contexify"
import "react-contexify/dist/ReactContexify.css";

import TakePhoto from "components/TakePhoto"

import ReportTabFrag from "components/generic/ReportTabFrag"
import TabFrag from "components/generic/TabFrag"
import CategoryFrag from "components/generic/CategoryFrag"
import HeaderFrag from "components/generic/HeaderFrag"
import GroupFrag from "components/generic/GroupFrag"
import ItemsContainerFrag from "components/generic/ItemsContainerFrag"
import EditTextFrag from "components/generic/EditTextFrag"
import SpinnerFrag from "components/generic/SpinnerFrag"
import ImageFrag from "components/generic/ImageFrag"
import OpenFileFrag from "components/generic/OpenFileFrag"
import ButtonFrag from "components/generic/ButtonFrag"
import CheckboxFrag from "components/generic/CheckboxFrag"
import RadioButtonsFrag from "components/generic/RadioButtonsFrag"
import PictureFrag from "components/generic/PictureFrag"
import TextViewFrag from "components/generic/TextViewFrag"
import FinderFrag from "components/generic/FinderFrag"
import CanvasFrag from "components/generic/CanvasFrag"
import ProgressBarFrag from "components/generic/ProgressBarFrag"
import ChartFrag from "components/generic/ChartFrag"
import CollapsableFrag from "components/generic/CollapsableFrag"
import PlanningFrag from "components/generic/PlanningFrag"
import TelegestionFrag from "components/generic/TelegestionFrag"
import AutoAddressFrag from "components/generic/AutoAddressFrag"
import CollectionFrag from "components/generic/CollectionFrag"
import GmapsFrag from "components/generic/GmapsFrag"
import AddressUnitFrag from "components/generic/AddressUnitFrag"
import FilesFrag from "components/generic/FilesFrag"

import ChatFrag from "components/generic/ChatFrag"

import SimpleListGeneric from "components/generic/alt/SimpleListGeneric"
import WidgetListGeneric from "components/generic/alt/WidgetListGeneric"

import GridStackFrag from 'components/generic/GridStackFrag';
import FilesCustom from 'components/FilesCustom';
import ToolbarDate from '../ToolbarDate';

import AKeyHelperFrag from 'components/AKeyHelperFrag';

import { sendReport, addReport, ReportModal } from "views/pages/ManageReportsItv";
import CHtmlToOutput from '../CHtmlToOutput';

//Config avec squelette des catégorie
// + data avec attribut=Catégorie
// >> Composant dédié pour afficher le html via config + data
//Voir pour gérer les fonctions du parent dans un objet pour qu'elles soit accessible via string

//Gérer un système de droit (information qui sera récupéré dans le Get de l'objet >> Voir avec Sébastien pour la gueule de l'objet (droit + catégories))


/*
baseValue = defaultValue
propNameType = type
attributes = regex
group = classParent
template = class OU classCollection = class
valueType = type front (Input, Select, TextArea etc…)
required = required
important = champs historique
*/

const tabRules = {
    "Boolean": yup.boolean(),
    "String": yup.string(),
    "Int32": yup.number(),
    "Object": yup.object(),
    "object": yup.object(),
};

var dataCache = {};//Cache Composant
var needingCacheCpt = {};//Composants register sur édition du Cache Component
var forcedCreate = false;
var isUpdateGen = false;

var cpt = 1;

const AGenerateModel = React.forwardRef(({ onSubmit, noButtons, appProps, checkRights, getRoutes, getUser, modelsList, parentProps, keyMode, configModel, loadedData, children, formEditing, showActionBar, searchTag, parentGenArgs, autoSave, isStartDuplicate }, ref) => {
    const { t } = useTranslation();
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    var curGenerateTag = "generate-" + Math.floor(Math.random() * 1000000000);

    if (loadedData) {
        if ((loadedData.custom?.extras && !loadedData.custom.orgExtras) || (loadedData.client?.extras && !loadedData.client.orgExtras) || (loadedData.extras && !loadedData.orgExtras)) {
            loadedData = JSON.parse(JSON.stringify(loadedData));
        }
        if (loadedData.custom?.extras && !loadedData.custom.orgExtras) {
            loadedData.custom.orgExtras = loadedData.custom.extras;
            loadedData.custom.extras = {};
            //console.debug(loadedData.custom.orgExtras);
            loadedData.custom.orgExtras.forEach((extra) => {
                if (!(extra.dataType === "Array" && extra.objType === "collection")) loadedData.custom.extras[extra.name] = extra.value;
            });
        }
        if (loadedData.client?.extras && !loadedData.client.orgExtras) {
            loadedData.client.orgExtras = loadedData.client.extras;
            loadedData.client.extras = {};
            loadedData.client.orgExtras.forEach((extra) => {
                if (!(extra.dataType === "Array" && extra.objType === "collection")) loadedData.client.extras[extra.name] = extra.value;
            });
        }
        if (loadedData.extras && !loadedData.orgExtras) {
            loadedData.orgExtras = loadedData.extras;
            loadedData.extras = {};
            //console.debug(loadedData.orgExtras);
            loadedData.orgExtras.forEach((extra) => {
                if (!(extra.dataType === "Array" && extra.objType === "collection")) loadedData.extras[extra.name] = extra.value;
            });
        }
    }

    if (parentGenArgs?.currentCache) dataCache = parentGenArgs.currentCache;

    var waitingFilesCpt = [];
    var needModuleFiles = false;

    var curElementList = {};
    const [elementList, setElementList] = React.useState({});
    const [genModel] = React.useState(configModel);

    const [curDate, setCurDate] = React.useState(parentGenArgs?.toolbarArgs?.date || (genModel?.toolbarDateConfig ? (() => {
        if (genModel?.toolbarDateConfig.defaultValue) {
            var splitTD = genModel?.toolbarDateConfig.defaultValue.split(":");
            switch (splitTD[0]) {
                case "siteExtras":
                    if (appProps?.getSite) {
                        var site = appProps?.getSite();
                        var filtered = site.extras?.filter(extra => extra.name === splitTD[1]);
                        if (filtered?.length) {
                            return filtered[0].value;
                        }
                        else if (site.parentID > 0 && site.parent?.extras?.length) {
                            var filteredParent = site.parent.extras.filter(extra => extra.name === splitTD[1]);
                            if (filteredParent?.length) {
                                return filteredParent[0].value;
                            }
                        }
                    }
                    break;
                default: break;
            }
        }
        return moment().format();
    })() : null));
    const [minDate, setMinDate] = React.useState(parentGenArgs?.toolbarArgs?.date ? commonFunc.getStartDate(moment(parentGenArgs.toolbarArgs.date), parentGenArgs.toolbarArgs.period) : null);
    const [maxDate, setMaxDate] = React.useState(parentGenArgs?.toolbarArgs?.date ? commonFunc.getEndDate(moment(parentGenArgs.toolbarArgs.date), parentGenArgs.toolbarArgs.period) : null);
    const [curPeriod, setCurPeriod] = React.useState(configModel?.toolbarDateConfig?.period ||parentGenArgs?.toolbarArgs?.period || "L");
    //const [toolbarCpts, setToolbarCpts] = React.useState([]);

    if (genModel && (formEditing === true || formEditing === false)) {
        genModel.disabled = !formEditing;
    }
    isUpdateGen = (loadedData ? !forcedCreate : false);
    forcedCreate = false;

    var modalRoot;
    const showContextMenu = useContextMenu().show;
    const hideAllMenu = useContextMenu().hideAll;

    const modalGenManager = React.createRef();

    
    const modelFctManager = {
        modelProps: parentProps,
        rootCache: dataCache,
        toolbarArgs: { date: curDate, period: curPeriod },
        toolbarFctManager: {
            getFormattedDate: getFormattedDate,
            setCurPeriod: setCurPeriod,
            curPeriod: curPeriod,
            curDate: curDate,
            setCurDate: setCurDate,
            selPreviousPeriod: selPreviousPeriod,
            datepickerChange: datepickerChange,
            selNextPeriod: selNextPeriod,
            minDate: minDate,
            maxDate: maxDate,
        },
        getSrcObject: loadedData,
        getRoutes: getRoutes,
        getUser: getUser ? getUser : (appProps?.getUser ? appProps.getUser : null),
        getModelsList: () => { return modelsList; },
        appProps: appProps,
        rootData: genModel,
        parentGenArgs: parentGenArgs,
        checkRights: checkRights,
        onActionRequired: onActionRequired,
        componentTyped: componentTyped,
        getRgbaFromHex: getRgbaFromHex,
        convertWidthToGrid: convertWidthToGrid,
        prepareMergedDesign: prepareMergedDesign,
        addWaitingFileCpt: (dataCpt, cptNeedModuleFiles) => {
            waitingFilesCpt.push(dataCpt);
            needModuleFiles |= (cptNeedModuleFiles ? true : false);
        },
        addConnectedCache: (dataCpt, cacheTarget) => {
            if (!needingCacheCpt[cacheTarget]) needingCacheCpt[cacheTarget] = [];
            needingCacheCpt[cacheTarget].push(dataCpt);
        },
        setSelected: () => { },
        setCustomBackground: (design, dataCurrCpt) => {
            var styleObject = { backgroundColor: "", backgroundImage: "" };
            if (design.backColor) {
                if (design.backColor.startsWith("#") || design.backColor === "transparent") styleObject.backgroundColor = getRgbaFromHex(design.backColor);
                //else if (design.backColor.startsWith("icon:")) styleObject.background = design.backColor;//TODO : icon fontawesome
                else {
                    if (design.backColor.startsWith("draw:")) {
                        var sysFile = "";
                        try {
                            sysFile = require("assets/img/res/" + design.backColor.replace("draw:", "").replace("mipmap:", "") + ".png");//TEMP PATCH : supprime l'extension pour compatibilité android
                        }
                        catch (e) {
                            sysFile = require("assets/img/res/" + design.backColor.replace("draw:", "").replace("mipmap:", "") + ".jpg");//TEMP PATCH : supprime l'extension pour compatibilité android
                        }
                        styleObject.backgroundImage = `url("${sysFile}")`;
                    }
                    else if (design.backColor.startsWith("../api") || design.backColor.startsWith("http")) {
                        styleObject.backgroundImage = `url("${design.backColor}")`;
                    }
                    else {
                        var site = modelFctManager.appProps?.getSite();
                        if (site.files?.length) {
                            var siteFile = site.files.filter((file => file.name === design.backColor.replace("/", "")));
                            if (siteFile?.length) {
                                var dt = siteFile[0];
                                const file = {
                                    fileId: dt.idFile,
                                    fileName: dt.name,
                                    container: dt.rootContainer,
                                    etag: dt.etag,
                                    accessToken: dt.absoluteUri,
                                    newWindow: false
                                };
                                styleObject.backgroundImage = `url("../api/data/DownloadFileByUri?${commonFunc.toParams(file)}")`;
                            }
                            else {
                                //Not Found
                            }
                        }
                        else {
                            waitingFilesCpt.push(dataCurrCpt);
                        }
                    }
                    if (!commonFunc.isBlank(styleObject.backgroundImage)) {
                        //styleObject.backgroundRepeat = "no-repeat";
                        //styleObject.backgroundSize = "cover";
                        //styleObject.backgroundPosition = "center";
                        styleObject.alpha = design.alpha;
                        styleObject.hasImage = styleObject.backgroundImage;
                        styleObject.backgroundImage = "";
                    }
                }
            }
            if (design.borderColor || design.borderSize) {
                if (design.borderColor) styleObject.borderColor = getRgbaFromHex(design.borderColor);

                if (design.borderSize) styleObject.borderWidth = design.borderSize;
                else styleObject.borderWidth = "1px";

                styleObject.borderStyle = "solid";
            }
            if (design.borderRadius) styleObject.borderRadius = design.borderRadius;

            return styleObject;
        },
        manageBoxSize: (tag, value, data, target) => {
            //frameClass += " w-" + parseInt(parseFloat(design.boxSize) * 100);
            return convertWidthToGrid(parseFloat(value) * 100);
        },
        managePadding: (design, frameClass) => {
            var styleObject = {};
            if (design.padding) {
                styleObject.padding = design.padding;
            }
            if (design.paddingStart) {
                frameClass += " ps-0";
                styleObject.paddingLeft = design.paddingStart;
            }
            if (design.paddingTop) styleObject.paddingTop = design.paddingTop;
            if (design.paddingEnd) {
                frameClass += " pe-0";
                styleObject.paddingRight = design.paddingEnd;
            }
            if (design.paddingBottom) styleObject.paddingBottom = design.paddingBottom;

            return styleObject;
        },
        manageMargin: (design, frameClass) => {
            var styleObject = {};
            //TODO : marginElevation ???
            if (design.margin) {
                frameClass += " p-0";
                styleObject.margin = design.margin;
            }
            if (design.marginStart) {
                frameClass += " ps-0";
                styleObject.marginLeft = design.marginStart;
            }
            if (design.marginTop) styleObject.marginTop = design.marginTop;
            if (design.marginEnd) {
                frameClass += " pe-0";
                styleObject.marginRight = design.marginEnd;
            }
            if (design.marginBottom) styleObject.marginBottom = design.marginBottom;

            return styleObject;
        },
        chainEvents: chainEvents,
        finalizeProcess: finalizeProcess,
        commonRenderProc: commonRenderProc,
        dataCfg: parentProps ? parentProps.dataCfg : {},
        setParentFullHeight: () => {
            if (loadedData?.srcData?.rerender) {
                loadedData.srcData.fullHeight = true;
                loadedData.srcData.rerender();
            }
        },
        applyChildsClone: (dataCpt, childsContainer, parentDisabled) => {
            //TODO : copy AConfigureModel
        }
    };

    var onError = (handleErrors, forced) => {
        var logErrors = handleErrors || errors;
        if (Object.keys(logErrors).length || forced) {
            var prevMsg = "<b>Echec d'enregistrement, données de formulaire invalides</b>";
            var detailsMsg = Object.keys(logErrors).map(keyError => {
                var subMsg = "";
                if (commonFunc.isBlank(logErrors[keyError].message)) {
                    Object.keys(logErrors[keyError]).forEach(keySubError => {
                        subMsg += "<br/>" + keyError + "." + keySubError + " : " + logErrors[keyError][keySubError].message;
                    });
                    return subMsg;
                }
                else {
                    return "<br/>" + keyError + " : " + logErrors[keyError].message;
                }
            });
            Swal.fire({
                //position: "top-end",
                icon: "error",
                title: "Echec",
                html: prevMsg /*+ detailsMsg*/,
                //showConfirmButton: false,
                //timer: 2000
            });
            console.error(detailsMsg);
        }
    };

    var yupLocale = t("validation", { returnObjects: true });//TODO : fusion avec un json fourni par GetSchemaModel
    yup.setLocale(yupLocale);

    var keyArgs = ["min", "max", "length", "moreThan", "lessThan"];
    var customYup = {};
    customYup["phoneFr"] = function (cYup, regex, excludeEmptyString, customMsg) {
        var phoneRegExp = /^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/u;
        return cYup.matches((regex || phoneRegExp), { message: customMsg || t("validation.string.phone"), excludeEmptyString: excludeEmptyString });
    };
    customYup["phone"] = function (cYup, regex, excludeEmptyString, customMsg) {
        var phoneRegExp = /^(?:(?:\+|00)[1-9]{0,3}[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$/u;
        return cYup.matches((regex || phoneRegExp), { message: customMsg || t("validation.string.phone"), excludeEmptyString: excludeEmptyString });
    };
    customYup["regex"] = function (cYup, regex, excludeEmptyString, customMsg) {
        return cYup.matches(regex, { message: customMsg || t("validation.string.regex"), excludeEmptyString: excludeEmptyString });
    };
    customYup["watcher"] = function (cYup, attribute, attrRequired, customMsg) {
        var splitTarget = attribute.split(";");
        return cYup.when(commonFunc.camelize(splitTarget[0], true), {
            is: () => {
                try {
                    var valueWatcher = (getValues ? parseInt(getValues(commonFunc.camelize(splitTarget[0], true))) : 0);
                    if (isNaN(valueWatcher)) {
                        return (getValues ? getValues(commonFunc.camelize(splitTarget[0], true)) : 0) === splitTarget[1];
                    }
                    else return valueWatcher === parseInt(splitTarget[1]);
                }
                catch (e) {
                    return false;
                }
            },
            then: schema => schema.notRequired(),
            otherwise: schema => schema.required(),
        });
    };
    customYup["watcherInverse"] = function (cYup, attribute, attrRequired, customMsg) {
        var splitTarget = attribute.split(";");
        return cYup.when(commonFunc.camelize(splitTarget[0], true), {
            is: () => {
                try {
                    var valueWatcher = (getValues ? parseInt(getValues(commonFunc.camelize(splitTarget[0], true))) : 0);
                    if (isNaN(valueWatcher)) {
                        return (getValues ? getValues(commonFunc.camelize(splitTarget[0], true)) : 0) === splitTarget[1];
                    }
                    else return valueWatcher === parseInt(splitTarget[1]);
                }
                catch (e) {
                    return false;
                }
            },
            then: schema => schema.required(),
            otherwise: schema => schema.notRequired(),
        });
    };


    React.useEffect(() => {
        setElementList(curElementList);

        //Reset des variables globales si changement de user/site
        var user = getUser ? getUser() : (appProps?.getUser ? appProps.getUser() : null);
        //if (location.key !== dataCache.locationKey) {
        if (user && (user.groupSId + "" + user.id) !== dataCache.userKey) {
            //dataCache = { locationKey: location.key };
            dataCache = { userKey: user.groupSId + "" + user.id };
            needingCacheCpt = {};
            forcedCreate = false;
            isUpdateGen = false;
        }

        //Ferme le contextMenu
        const handleClickOutside = () => {
            hideAllMenu();
        };
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            if (autoSave) {
                var dataToSave = getValues();
                prepareDataForSaving(dataToSave);
                dataToSave = commonFunc.mergeDeep({}, loadedData, dataToSave);

                var extrasType = parentProps.subType || parentProps.type;
                var primaryId = commonFunc.camelize("ID" + commonFunc.capitalize(extrasType), true);
                var bindID = loadedData ? loadedData[primaryId] : -1;

                delete dataToSave.orgExtras;
                localStorage.setItem(autoSave + bindID, JSON.stringify(dataToSave));
            }

            document.removeEventListener('mousedown', handleClickOutside);

            //console.debug("unmount");
            if (modalRoot) {
                modalRoot.unmount();
                //modalRoot = null;
            }
        }
    }, []);

    //Evenements après changement de date via ToolbarDate
    React.useEffect(() => {
        if (curDate && genModel.toolbarDateConfig?.triggerList?.length) {
            genModel.toolbarDateConfig?.triggerList.forEach((triggerObj) => {
                onActionRequired("Root", triggerObj, null).then((responseLoad) => {

                });
            });
        }
    }, [curDate]);

    //Récupération de changement d'arguments du parent
    React.useEffect(() => {
        //alert("DATECHANGE");
        if (parentGenArgs) {
            if (parentGenArgs.toolbarArgs?.date) setCurDate(parentGenArgs.toolbarArgs.date);
            if (!configModel?.toolbarDateConfig?.period && parentGenArgs.toolbarArgs?.period) setCurPeriod(parentGenArgs.toolbarArgs.period);

            if (parentGenArgs.toolbarArgs) {
                var curMoment = moment(parentGenArgs.toolbarArgs.date);
                if (configModel?.toolbarDateConfig?.useMinDate === "parent") setMinDate(commonFunc.getStartDate(curMoment, parentGenArgs.toolbarArgs.period));
                else {
                    //TODO : value spec
                }
                if (configModel?.toolbarDateConfig?.useMaxDate === "parent") setMaxDate(commonFunc.getEndDate(curMoment, parentGenArgs.toolbarArgs.period));
                else {
                    //TODO : value spec
                }

            }
        }
    }, [parentGenArgs]);

    React.useImperativeHandle(ref, () => ({
        submitForm: (isUpdate) => {
            handleSubmit((data) => { triggerOnSubmit(data, isUpdate) }, onError)()
        },
        submitNoCheckForm: (isUpdate) => { triggerOnSubmit(getValues(), isUpdate) },
        getValues: () => { return getValues() },
        resetForm: () => { reset(); },
    }));

    function setCacheValue(key, value, exception) {
        //console.debug("SET CACHE VALUE " + key);
        dataCache[key] = value;
        if (needingCacheCpt && Object.keys(needingCacheCpt).length && needingCacheCpt[key]) {
            needingCacheCpt[key].forEach(cpt => {
                if (cpt !== exception && cpt.functionManager?.refreshFromCache) cpt.functionManager?.refreshFromCache();
            });
        }
    }

    function prepareDataForSaving(data, isUpdate) {
        var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;

        //Gestion des extras
        manageExtras(data, isUpdate);
        if (data.client?.extras) manageExtras(data.client, isUpdate, "client");
        if (data.subLead?.extras) manageExtras(data.subLead, isUpdate, "subLead");

        //Vérification validité adresse
        Object.keys(data).forEach((key) => {
            var field = data[key];
            //Reset des valeurs par défaut pour Adresse à -1
            if (field && field.idAddress && field.idAddress === -1) {
                if (!field.avoidReset) {
                    Object.keys(field).forEach((addressKey) => {
                        if (!commonFunc.isBlank(addressKey)) {
                            var child = dataList[commonFunc.camelize(key + "." + addressKey, true)];
                            if (child) {
                                var systemValue = "";
                                data[key][addressKey] = child.modalDefaultValue === undefined ? systemValue : child.modalDefaultValue;
                                //TODoO : check pour pb adresse
                            }
                        }
                    });
                }
                else {
                    Object.keys(field).forEach((addressKey) => {
                        if (!commonFunc.isBlank(addressKey)) {
                            var child = dataList[commonFunc.camelize(key + "." + addressKey, true)];
                            if (child && commonFunc.isBlank(data[key][addressKey]) && data[key][addressKey] !== 0) {
                                var systemValue = "";
                                data[key][addressKey] = child.modalDefaultValue === undefined ? systemValue : child.modalDefaultValue;
                                //TODoO : check pour pb adresse
                            }
                        }
                    });
                    field.idAddress = 0;
                }

                data[key + "ID"] = 0;
            }
            if (field && field.idAddress !== null && field.idAddress !== undefined && field.idAddress !== data[key + "ID"]) {
                data[key + "ID"] = field.idAddress;
            }
        });
    }

    function manageExtras(data, isUpdate, altKey) {
        var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;

        var extras = data.extras;
        data.extras = isUpdate ? (loadedData.custom ? (loadedData.custom.orgExtras || []) : (altKey ? (loadedData[altKey]?.orgExtras || []) : (loadedData.orgExtras || []))) : [];

        var extrasType = altKey || parentProps.subType || parentProps.type;
        var primaryId = commonFunc.camelize("ID" + commonFunc.capitalize(extrasType), true);
        var secondaryId = commonFunc.camelize(extrasType + "ID", true);



        //Exclusion des extras systèmes
        data.extras = data.extras.filter((extra) => {
            var flag = true;
            var cptExtra = dataList[commonFunc.camelize("extras." + extra.name, true)];
            if (cptExtra) {
                flag = !(cptExtra.isExcluded && cptExtra.argumentsObj?.excludeFromExtras);
            }
            return flag;
        });

        if (extras && Object.keys(extras).length) {
            //Gestion sous-objet extras
            var collectionList = [];
            Object.keys(extras).forEach((key) => {
                if (extras[key] !== null && !Array.isArray(extras[key]) && typeof extras[key] === "object" && !commonFunc.isValidDate(extras[key])) {
                    var subChilds = [];
                    Object.keys(extras[key]).forEach((subKey) => {
                        extras[key + "." + subKey] = extras[key][subKey];
                        subChilds.push("extras." + key + "." + subKey);
                    });
                    extras[key] = JSON.stringify(subChilds);
                    collectionList.push(key);
                }
            });

            var flagModifElem = false;
            Object.keys(extras).forEach((key) => {
                if (extras[key] !== null) {
                    if (isUpdate) {
                        var existingExtra = data.extras.filter((extra) => extra.name === key);
                        if (existingExtra.length > 0) {
                            existingExtra.forEach((extra) => {
                                flagModifElem |= (extra.value !== extras[key]);
                                extra.tag = "extras." + key;
                                extra.value = extras[key];
                                if (collectionList.indexOf(key) >= 0) {
                                    extra.dataType = "Array";
                                    extra.objType = "collection";
                                }
                            });
                        }
                        else {
                            var extra = { name: key, tag: "extras." + key, value: extras[key], idExtra: 0 };
                            extra[secondaryId] = data[primaryId];
                            if (collectionList.indexOf(key) >= 0) {
                                extra.dataType = "Array";
                                extra.objType = "collection";
                            }
                            data.extras.push(extra);
                            flagModifElem = true;
                        }
                    }
                    else {
                        var extraAdd = { name: key, tag: "extras." + key, value: extras[key], idExtra: 0 };
                        extraAdd[secondaryId] = data[primaryId];
                        if (collectionList.indexOf(key) >= 0) {
                            extraAdd.dataType = "Array";
                            extraAdd.objType = "collection";
                        }
                        data.extras.push(extraAdd);
                    }
                }
                else {
                    data.extras = data.extras.filter(extra => !(extra.name === key || extra.name.startsWith(key + ".")));
                }
            });
            if (flagModifElem) data.dSysMod = new Date();
        }
    }

    function triggerOnSubmit(data, isUpdate) {
        prepareDataForSaving(data, isUpdate);

        var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;
        if (onSubmit) {
            onSubmit(data, isUpdate).then((dataResult) => {
                if (dataResult && dataResult.idResponse) {
                    Object.keys(dataList).forEach((key) => {
                        var dataElem = dataList[key];
                        if (dataElem.onModelSubmited && dataElem.functionManager.onSubmit) {
                            dataElem.functionManager.onSubmit(dataResult, dataResult.idResponse);
                        }
                    });
                }
            });
        }
    }


    //i18n.addResource('fr', 'translation', "tryit.label", 'hello from namespace 1');

    function createNestedObject(base, names, value) {
        // On récupère le dernier argument
        var lastName = arguments.length >= 3 ? names.pop() : false;
        // parcours de l'arbo, création si besoin
        for (var i = 0; i < names.length; i++) {
            base = base[names[i]] = base[names[i]] || {};
        }
        //on affecte la valeur  
        if (lastName) base = base[lastName] = value;
        return base;
    }

    function setYupToNestedObject(obj) {
        //Appel récursif, a check sur plusieurs niveaux
        for (var propertyName in obj) {
            //console.debug(propertyName);
            //console.debug(typeof (obj[propertyName]));
            if (!(obj[propertyName].conditions)) {
                setYupToNestedObject(obj[propertyName]);
                obj[propertyName] = yup.object(obj[propertyName]).notRequired();
            }

        }
    }


    var nestedObj = {};
    var schemaObject = {};
    if (genModel?.templates) {
        genModel.templates?.forEach((template) => {
            template.categories?.forEach((category) => {
                category.headers?.forEach((header) => {
                    header.groups?.forEach((group, index) => {
                        //Gestion des clé primaires/secondaires
                        if (parentProps?.type && keyMode > 0 && index === 0) {
                            var bindProp = "";
                            switch (keyMode) {
                                case 1: bindProp = "ID" + commonFunc.capitalize(parentProps.type); break;
                                case 2: bindProp = parentProps.type + "ID"; break;
                                default: bindProp = "ID" + parentProps.type; break;
                            }
                            group.items.push({ hidden: true, bindPropResult: bindProp, defaultValue: parentProps.id, objType: "textview" });
                        }

                        group.items?.forEach((child) => {

                            var yupProc = (item) => {
                                var type = item.propNameJsType || "string";
                                if (item.bindPropResult && yup[type] && typeof (yup[type]) === "function" && !item.bindPropResult.startsWith("{array}")) {//TEMP : test sur array en attendant solution pour les contacts de rapport
                                    var elemYup = yup[type]();
                                    if (item.propNameType) elemYup = tabRules[item.propNameType] || elemYup;
                                    elemYup = elemYup.nullable();
                                    if (item.attributes) {
                                        var errorMessage;
                                        if (item.attributes["typeName"] === "FormAttribute") errorMessage = altT(item.attributes["error"]);

                                        var attrRequired = item.attributes["required"];
                                        if (attrRequired?.startsWith("equal:")) attrRequired = null;
                                        Object.keys(item.attributes).forEach((key, value) => {
                                            if (elemYup[key] && typeof (elemYup[key]) === "function") {
                                                try {
                                                    if (errorMessage) {
                                                        if (keyArgs.indexOf(key) >= 0 && (item.attributes[key] || item.attributes[key] === 0)) {
                                                            if (key === "min" && type === "date") {
                                                                elemYup = elemYup[key](item.attributes[key], (ref) => {
                                                                    // eslint-disable-next-line no-template-curly-in-string
                                                                    return errorMessage.replace("${min}", moment(ref.min).utc().format("DD/MM/yyyy"));
                                                                });
                                                            }
                                                            else {
                                                                if ((key === "min" || key === "max") && item.objType === "collection") {
                                                                    //TODO : alternative
                                                                }
                                                                else {
                                                                    var date = item.attributes[key];
                                                                    if (date === "{true}") date = new Date();
                                                                    elemYup = elemYup[key](date, errorMessage);
                                                                }
                                                            }
                                                        }
                                                        else if (key === "oneOf" && (item.attributes[key] || item.attributes[key] === 0)) {
                                                            elemYup = elemYup[key]([yup.ref(commonFunc.camelize(item.attributes[key], true))], errorMessage);
                                                        }
                                                        else if ((key !== "required" || !item.attributes["required"]?.startsWith("equal:")) && item.attributes[key]) {
                                                            elemYup = elemYup.matches(item.attributes[key], { message: errorMessage, excludeEmptyString: (attrRequired ? false : true) });
                                                        }
                                                        else if (key !== "required" || !item.attributes["required"]?.startsWith("equal:")) {
                                                            elemYup = elemYup[key](errorMessage);
                                                        }
                                                    }
                                                    else {
                                                        if (keyArgs.indexOf(key) >= 0 && (item.attributes[key] || item.attributes[key] === 0)) {
                                                            if (key === "min" && type === "date") {
                                                                elemYup = elemYup[key](item.attributes[key], (ref) => {
                                                                // eslint-disable-next-line no-template-curly-in-string
                                                                    return t('validation.date.min').replace("${min}", moment(ref.min).utc().format("DD/MM/yyyy"));
                                                                });
                                                            }
                                                            else {
                                                                if ((key === "min" || key === "max") && item.objType === "collection") {
                                                                    //TODO : alternative
                                                                }
                                                                else {
                                                                    var lDate = item.attributes[key];
                                                                    if (lDate === "{true}") lDate = new Date();
                                                                    elemYup = elemYup[key](lDate);
                                                                }
                                                            }
                                                        }
                                                        else if (key === "oneOf" && (item.attributes[key] || item.attributes[key] === 0)) {
                                                            elemYup = elemYup[key]([yup.ref(commonFunc.camelize(item.attributes[key], true))]);
                                                        }
                                                        else if ((key !== "required" || !item.attributes["required"]?.startsWith("equal:")) && item.attributes[key]) {
                                                            elemYup = elemYup.matches(item.attributes[key], { excludeEmptyString: (attrRequired ? false : true) });
                                                        }
                                                        else if (key !== "required" || !item.attributes["required"]?.startsWith("equal:")) {
                                                            elemYup = elemYup[key]();
                                                        }
                                                    }
                                                }
                                                catch (e) {
                                                    console.debug(t("gal_yupError"));
                                                    console.error(e);
                                                }
                                            }
                                            else if (customYup[key] && typeof (customYup[key]) === "function") {
                                                elemYup = customYup[key](elemYup, item.attributes[key], (attrRequired ? false : true), errorMessage);
                                            } else {

                                                //console.debug("yup function type " + key + " Ignored");
                                            }
                                        });
                                    }

                                    elemYup = elemYup.typeError(t("validation." + type + ".notType"));

                                    if (item.bindPropResult.indexOf(".") >= 0) {
                                        if (!item.isExcluded) {
                                            //On met de côté les objets sous-jacents pour traitement final (propriétés non consécutives)
                                            createNestedObject(nestedObj, commonFunc.camelize(item.bindPropResult, true).split("."), elemYup);
                                        }
                                    } else {
                                        //"attributes": { "required": "equal:StatusID;202" },
                                        /*if (item.attributes && item.attributes["required"]?.startsWith("equal:")) {
                                            var targetEqual = item.attributes["required"].replace("equal:", "");
                                            var splitTarget = targetEqual.split(";");

                                            schemaObject[commonFunc.camelize(item.bindPropResult, true)] = elemYup.when(commonFunc.camelize(splitTarget[0], true), {
                                                is: (value) => value === splitTarget[1],
                                                then: schema => schema.required(),
                                                otherwise: schema => schema
                                            });
                                        }
                                        else {*/
                                            schemaObject[commonFunc.camelize(item.bindPropResult, true)] = elemYup;//.required()
                                        //}
                                    }
                                    /*if (item.bindPropResult === "Address.AddressMain" && item.bindPropResult.indexOf(".") >= 0) {
                                        schemaObject["address"] = {};
                                        schemaObject["address"]["addressMain"] = elemYup;
                                    }*/


                                    //localDataConfig.push({ label: "i18n:" + key + "Label", type: "input", target: key, className: "" });//TEMP
                                    if (!item.baseConfig) item.baseConfig = {};
                                    //localDataConfig.push({ title: "i18n:report_" + elem.propName + ".label", objType: "text", bindPropResult: elem.propName, defaultValue: elem.baseValue, subType: (inputTypes[elem.propNameJsType] || "text"), readOnly: elem.baseConfig.readOnly, hidden: elem.baseConfig.hidden, isInput: elem.baseConfig.isInput });//TEMP
                                } else {

                                    //console.debug("yup base type " + type + " Ignored");
                                }
                            };

                            var itemProc = (item) => {
                                yupProc(item);
                                item.children?.forEach((subChild) => {
                                    itemProc(subChild);
                                });
                                item.options?.forEach((option) => {
                                    option?.children?.forEach((subChild) => {
                                        itemProc(subChild);
                                    });
                                });
                            };

                            itemProc(child);
                        });
                    });
                });
            });
        });
    }

    //On genere le yup pour les objets sous-jacents
    setYupToNestedObject(nestedObj);
    Object.assign(schemaObject, nestedObj);

    //console.debug(nestedObj);
    //console.debug(schemaObject);
    //console.debug("....*****");

    const currSchema = yup.object(schemaObject).required();
    const { control, register, getValues, trigger, setValue, resetField, handleSubmit, reset, formState: { isSubmitted, errors }, clearErrors } = useForm({ resolver: yupResolver(currSchema) });//{ resolver: yupResolver(currSchema), defaultValues: { ClientName: "toto" } }
    const formManager = {
        control: control,
        register: register,
        getValues: getValues,
        setValue: setValue,
        resetField: resetField,
        handleSubmit: handleSubmit,
        reset: reset,
        isSubmitted: isSubmitted,
        errors: errors
    };

    //console.debug("ALERTE RENDER !!");
    //console.debug(elementList);


    function isItemHidden({ props, data, triggerEvent }) {

        if (props?.data) {
            //PictureFrag
            if (props.data.objType !== "picture" && data === "genFilePhoto") return true;
            if (props.data.objType !== "picture" && data === "genFileDel") return true;

            //CollectionFrag
            if (props.data.objType !== "collection" && data === "genItemEdit") return true;

            var values = !commonFunc.isBlank(props?.data.bindPropResult) ? getValues(commonFunc.camelize(props?.data.bindPropResult, true)) : "";
            var collections = {};
            if (!commonFunc.isBlank(values)) {
                collections = JSON.parse(values.toString());
            }
            var collectionsLength = Object.keys(collections).length;
            if ((props.data.objType !== "collection" || props.data.argumentsObj?.collectionArgs?.preventDelete || collectionsLength <= parseInt(props.data.attributes?.min)) && data === "genItemDel") return true;
        }

        return false;
    }

    function filePhoto({ sysEvent, props, triggerEvent, data }) {
        var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;
        var dataElem = (props.data.bindPropResult ? dataList[commonFunc.camelize(props.data.bindPropResult, true)] : null);

        if (dataElem) {

            if (modalRoot) {
                modalRoot.unmount();
                modalRoot = null;
            }

            //Traitement des informations retourné par le Dialog
            var callbackModal = function (data) {
                if (data) {
                    dataElem.functionManager.setValue(data, true);
                }
                else {
                    modalRoot.unmount();
                }
            };

            modalRoot = createRoot(document.createElement('div'));
            modalRoot.render(<TakePhotoModal t={t} parentContext={this} title={t("gal_takePicture")} callback={callbackModal}></TakePhotoModal>);

        }
    }
    function fileDel({ sysEvent, props, triggerEvent, data }) {
        var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;
        var dataElem = (props.data.bindPropResult ? dataList[commonFunc.camelize(props.data.bindPropResult, true)] : null);

        if (dataElem) {

            dataElem.functionManager.setValue(null, true);
        }
    }

    function editItem({ sysEvent, props, triggerEvent, data }) {
        var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;
        var dataElem = (props.data.bindPropResult ? dataList[commonFunc.camelize(props.data.bindPropResult, true)] : null);

        if (dataElem) {
            dataElem.functionManager.performClick(triggerEvent, props.key, props.value);
        }
    }
    function removeItem({ sysEvent, props, triggerEvent, data }) {
        var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;
        var dataElem = (props.data.bindPropResult ? dataList[commonFunc.camelize(props.data.bindPropResult, true)] : null);

        if (dataElem) {
            if (props?.data?.argumentsObj?.collectionArgs?.confirmDelete) {
                //TODO
                Swal.fire({
                    icon: "question",
                    title: "Suppression",
                    html: "Êtes-vous sûr de vouloir supprimer cet élément ?",
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#dc3545",
                    confirmButtonText: "Oui",
                    cancelButtonText: "Non"
                }).then((result) => {
                    if (result.value) {
                        dataElem.functionManager.removeItem(triggerEvent, props.key);
                    }
                });
            }
            else dataElem.functionManager.removeItem(triggerEvent, props.key);
        }
    }

    function onActionRequired(tag, triggerObj, componentData, componentArgs, srcNode) {
        var { id, trigger: actionKey, target, value, useCache, url, targetCache, min, max, contextType, operatorTest, altValue, targetValue, invalidToHide } = triggerObj;
        var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;

        var responseAction = { isSuccess: false };
        //console.debug("log onActionRequired " + actionKey);
        var targetData = !commonFunc.isBlank(target) ? dataList[commonFunc.camelize(target, true)] : (!commonFunc.isBlank(componentData.bindPropResult) ? dataList[commonFunc.camelize(componentData.bindPropResult, true)] : componentData);
        if (!targetData) targetData = componentData;
        //console.debug(target);
        //console.debug(componentData.bindPropResult);
        //console.debug(commonFunc.camelize(componentData.bindPropResult, true));
        //console.debug(Object.keys(dataList).length);
        //console.debug(targetData);
        return new Promise((resolve, reject) => {
            switch (actionKey) {

                //Priority

                case "toggleButtonVisibility":
                    var cFlagV = false;
                    var preventAction = false;

                    var valueTest;
                    switch (targetValue) {
                        case "modelDisabled": valueTest = genModel.disabled; break;
                        case "modelEdition": preventAction = genModel.disabled; valueTest = (isUpdateGen ? true : false); break;
                        default: valueTest = 0; break;
                    }

                    switch (operatorTest) {
                        case "=": cFlagV = (valueTest === value); break;
                        case "<": cFlagV = (valueTest < value); break;
                        case "<=": cFlagV = (valueTest <= value); break;
                        case ">": cFlagV = (valueTest > value); break;
                        case ">=": cFlagV = (valueTest >= value); break;
                        default:
                            break;
                    }
                    if (!preventAction) {
                        if (cFlagV) {
                            targetData.hidden = true;
                            //targetData.functionManager.rerender();
                        }
                        else {
                            targetData.hidden = false;
                            //targetData.functionManager.rerender();
                        }
                    }
                    break;
                case "showUsrBtn":
                    var valueTest2;
                    switch (targetValue) {
                        case "modelDisabled": valueTest2 = genModel.disabled; break;
                        case "modelEdition": /*preventAction = genModel.disabled;*/ valueTest2 = (isUpdateGen ? true : false); break;
                        default: valueTest2 = 0; break;
                    }

                    if (loadedData && valueTest2 === true) {
                        switch (value) {
                            case "infoCreateAccess":
                                targetData.hidden = loadedData.accountID > 0 || !commonFunc.isBlank(loadedData.email);
                                targetData.disabled = targetData.hidden;
                                break;
                            case "createAccess":
                                targetData.hidden = loadedData.accountID > 0 || commonFunc.isBlank(loadedData.email);
                                targetData.disabled = targetData.hidden;
                                break;
                            case "disableAccount":
                            case "generateAccess":
                            case "changePassword":
                            case "resetPassword":
                                targetData.hidden = loadedData.accountID <= 0 || !loadedData.accountUser?.isActive;
                                targetData.disabled = targetData.hidden;
                                break;
                            default: break;
                        }
                    }
                    break;

                case "findFragment":
                    responseAction.isSuccess = true;
                    responseAction.result = targetData;
                    resolve(responseAction);
                    break;

                case "setEnabled":
                    var stateDisabled = targetData.disabled;
                    setTimeout(() => {
                        if (stateDisabled === targetData.disabled) {
                            if (componentArgs.value instanceof Boolean) {
                                //console.debug(componentArgs.value);
                                targetData.disabled = !componentArgs.value;
                            }
                            else if (componentData.objType === "checkbox") {
                                var enabled = !componentData.disabled;
                                //var checked = getValues(commonFunc.camelize(componentData.bindPropResult));
                                var checked = componentData.functionManager?.getValue();

                                targetData.disabled = !(enabled && checked);
                            }
                            else {
                                if (value instanceof Boolean) targetData.disabled = !value;
                                else targetData.disabled = !targetData.disabled;
                            }
                            targetData.functionManager?.rerender();
                        }
                    }, targetData.loaded ? 0 : 1000);
                    break;
                case "enableElement":
                case "disableElement":
                    var cNewValue5 = !(actionKey === "enableElement");

                    var cptTargetDE = targetData;
                    var testValueDE = altValue;
                    if (altValue === "currValue") {
                        if (componentArgs && componentArgs.value) {
                            testValueDE = componentArgs.value;
                        }
                        else {
                            //altValue = componentData.defaultValue;
                            testValueDE = getValues(commonFunc.camelize((componentData.isExcluded ? excludeFrag(componentData.bindPropResult, componentData.subType) : componentData.bindPropResult), true));
                        }
                    }
                    else if (altValue === "targetValue") {
                        testValueDE = targetData.defaultValue;
                        cptTargetDE = componentData;
                        //flagNoRerenderMD = true;
                    }

                    var cFlag5 = false;
                    switch (operatorTest) {
                        case "=": cFlag5 = (value === testValueDE); break;
                        case "!=": cFlag5 = (value !== testValueDE); break;
                        case "<": cFlag5 = (value < testValueDE); break;
                        case "<=": cFlag5 = (value <= testValueDE); break;
                        case ">": cFlag5 = (value > testValueDE); break;
                        case ">=": cFlag5 = (value >= testValueDE); break;
                        default:
                            break;
                    }

                    var orgDisabled = cptTargetDE.disabled;
                    if (cFlag5) {
                        cptTargetDE.disabled = cNewValue5;
                        if (orgDisabled !== cptTargetDE.disabled && cptTargetDE.functionManager?.rerender) cptTargetDE.functionManager.rerender();
                    }
                    else {
                        cptTargetDE.disabled = !cNewValue5;
                        if (orgDisabled !== cptTargetDE.disabled && cptTargetDE.functionManager?.rerender) cptTargetDE.functionManager.rerender();
                    }
                    break;

                case "validateTarget":
                    if (!targetData || targetData === componentData) {
                        targetData = genModel.functionManager.getSelectedTab();
                    }
                    if (targetData) {
                        var binds = [];
                        var getBinds = (childData) => {
                            var childs = childData.functionManager?.getChilds ? childData.functionManager.getChilds() : childData.children;
                            childs?.forEach(child => {
                                if (child) {
                                    if (child.bindPropResult) binds.push(commonFunc.camelize(child.bindPropResult, true));
                                    getBinds(child);
                                }
                            });
                        };
                        getBinds(targetData);

                        console.debug(binds);
                        trigger(binds).then(result => {
                            if (result) {
                                modelFctManager.chainEvents(componentData, value);
                            }
                            else {
                                onError(errors, true);
                            }
                        });
                    }
                    break;

                case "switchTab":
                    var selectedTemplate = genModel.functionManager.getSelectedTab();
                    var newIndex = selectedTemplate.tabIndex;
                    if (altValue) {
                        newIndex = parseInt(altValue);
                    }
                    else {
                        var modif = (operatorTest === "-" ? -1 : 1);
                        newIndex = newIndex + modif;
                        while (genModel.functionManager.getTabFromIndex(newIndex)?.hidden && (newIndex) <= genModel.templates?.length && (newIndex) > 0) {
                            newIndex = newIndex + modif;
                        }
                    }
                    if (newIndex < 1) newIndex = 1;
                    genModel.functionManager.setExtSelectedTab(newIndex);
                    break;

                case "navigateTo":
                case "accessUrl":
                case "accessLink":
                    var urlVal = value;
                    if (value === "listValues") urlVal = dataList?.data;
                    else if (value === "currValue") {
                        if (componentArgs && componentArgs.value) {
                            urlVal = componentArgs.value;
                        }
                        else {
                            urlVal = getValues(commonFunc.camelize((componentData.isExcluded ? excludeFrag(componentData.bindPropResult, componentData.subType) : componentData.bindPropResult), true));
                        }
                    }
                    else if (value.startsWith("pathValue:")) {
                        urlVal = getValues(commonFunc.camelize(value.replace("pathValue:", "")));
                    }
                    var concatValNT = (url ? url : "") + (altValue ? altValue : "") + (urlVal ? urlVal : "");
                    if (!commonFunc.isBlank(concatValNT) && (!targetValue || !concatValNT.endsWith(targetValue))) {
                        window.open("../" + concatValNT, '_newself');
                    }
                    else {
                        chainEvents(componentData, targetCache);
                    }
                    break;


                case "navigateToExternal":
                    var concatValNTE = (url ? url : "") + (altValue ? altValue : "") + (value ? value : "");
                    if (!commonFunc.isBlank(concatValNTE) && (!targetValue || !concatValNTE.endsWith(targetValue))) {
                        window.location.assign("../" + concatValNTE);
                    }
                    else {
                        chainEvents(componentData, targetCache);
                    }
                    break;

                case "navigateToOut":
                    var urlValO = value;
                    if (value === "listValues") urlValO = dataList?.data;
                    else if (value === "currValue") {
                        if (componentArgs && componentArgs.value) {
                            urlValO = componentArgs.value;
                        }
                        else {
                            urlValO = getValues(commonFunc.camelize((componentData.isExcluded ? excludeFrag(componentData.bindPropResult, componentData.subType) : componentData.bindPropResult), true));
                        }
                    }
                    else if (value.startsWith("pathValue:")) {
                        urlValO = getValues(commonFunc.camelize(value.replace("pathValue:", "")));
                    }
                    var concatValNTO = (url ? url : "") + (altValue ? altValue : "") + (urlValO ? urlValO : "");
                    if (!commonFunc.isBlank(concatValNTO) && (!targetValue || !concatValNTO.endsWith(targetValue))) {
                        window.location.assign(concatValNTO);
                    }
                    else {
                        chainEvents(componentData, targetCache);
                    }
                    break;

                case "showActionStatus":
                case "hideActionStatus":

                    //hideOnAction: [{ id: status.idStatus, trigger: "hideActionStatus", target: "", value: status.step, operatorTest: "!=", altValue: curStep, targetValue: (loadedData ? loadedData.statusID : 0) },
                    //{ id: status.idStatus, trigger: "showActionStatus", target: "", value: status.step, operatorTest: "=", altValue: (curStep <= 1 ? -1 : null), targetValue: (loadedData ? loadedData.statusID : 0) }]


                    //{ id: status.idStatus, trigger: "hideActionStatus", target: "", value: status.step, operatorTest: "=", altValue: curStep, targetValue: (loadedData ? loadedData.statusId : 0) }
                    var newValue = !(actionKey === "showActionStatus");
                    //console.debug(targetValue);
                    if (id === targetValue) {
                        targetData.hidden = true;
                        //targetData.functionManager.rerender();
                    }
                    else {
                        var flag = false;
                        switch (operatorTest) {
                            case "=": flag = (value === altValue); break;
                            case "!=": flag = (value !== altValue); break;
                            case "<": flag = (value < altValue); break;
                            case "<=": flag = (value <= altValue); break;
                            case ">": flag = (value > altValue); break;
                            case ">=": flag = (value >= altValue); break;
                            default:
                                break;
                        }
                        if (flag) {
                            targetData.hidden = newValue;
                            //targetData.functionManager.rerender();
                        }
                    }
                    break;

                case "submitElem":
                    //console.debug(value === true);
                    ref.current.submitForm(value === true);
                    break;
                case "refreshElem":
                    if (parentProps && parentProps.loadElem) {
                        parentProps.loadElem(parentProps.id).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'actualiser l'élément";
                        resolve(responseAction);
                    }
                    break;
                case "removeElem":
                    if (parentProps && parentProps.removeElem) {
                        parentProps.removeElem(parentProps.id).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'actualiser l'élément";
                        resolve(responseAction);
                    }
                    break;
                case "switchTabElem":
                    if (parentProps?.switchTab) {
                        parentProps.switchTab(value, null, altValue).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'actualiser l'élément";
                        resolve(responseAction);
                    }
                    break;
                case "updateStatusElem":
                    if (parentProps && parentProps.updateStatusElem) {
                        var statusId;
                        if (value?.startsWith && value.startsWith("prop:")) statusId = (dataList[commonFunc.camelize(value.replace("prop:", ""), true)] || {}).defaultValue;
                        else statusId = value;
                        var stepId;
                        var label = "";
                        if (componentArgs && !altValue) {
                            stepId = componentArgs.value;
                            label = componentArgs.label;
                        }
                        else {
                            if (altValue?.startsWith && altValue.startsWith("prop:")) stepId = (dataList[commonFunc.camelize(altValue.replace("prop:", ""), true)] || {}).defaultValue;
                            else stepId = altValue;
                        }

                        parentProps.updateStatusElem(statusId, stepId, label).then((responseLoad) => {
                            if (!commonFunc.isBlank(stepId)) {
                                if (responseLoad.isSuccess) {
                                    onActionRequired(tag, { trigger: "refreshElem" }, componentData, componentArgs).then((responseLoad) => {
                                        responseAction = responseLoad;
                                        resolve(responseAction);
                                    });
                                }
                                else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: responseLoad.errorMessage
                                    }).then((result) => {
                                        onActionRequired(tag, { trigger: "refreshElem" }, componentData, componentArgs).then((responseLoad) => {
                                            responseAction = responseLoad;
                                            resolve(responseAction);
                                        });
                                    });
                                }
                            }
                            else {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "MAJ impossible";
                        resolve(responseAction);
                    }
                    break;
                case "duplicateFormElem":
                case "editFormElem":
                    if (parentProps && parentProps.setEditingMode) parentProps.setEditingMode(!formEditing, actionKey === "duplicateFormElem");
                    if (actionKey === "duplicateFormElem") {
                        if (targetData && targetData.functionManager?.setValue) targetData.functionManager.setValue(value);
                        prepareDuplicate();
                    }
                    break;

                case "triggerDuplicate":
                    prepareDuplicate();
                    break;

                case "triggerParentFunction":
                    if (parentProps && altValue) {
                        if (altValue.functionKey) {
                            Object.keys(altValue).forEach((key) => {
                                var valueArgs = altValue[key];
                                if (valueArgs?.startsWith) {
                                    if (valueArgs.startsWith("prop:")) altValue[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                                    else if (valueArgs.startsWith("value:")) altValue[key] = getValues(commonFunc.camelize(valueArgs.replace("value:", ""), true));
                                    else if (valueArgs.startsWith("args:")) altValue[key] = componentData.argumentsObj[valueArgs.replace("args:", "")];
                                    else if (valueArgs.startsWith("modelFctManager:")) altValue[key] = commonFunc.getValue(modelFctManager, valueArgs.replace("modelFctManager:", ""));
                                    else altValue[key] = valueArgs;
                                }
                                else altValue[key] = valueArgs;
                            });
                            if (parentProps[altValue.functionKey]) parentProps[altValue.functionKey](altValue.p1, altValue.p2, altValue.p3, altValue.p4, altValue.p5);
                        }
                        else {
                            if (parentProps[altValue]) parentProps[altValue]();
                        }
                    }
                    break;

                case "loadedDataParent":
                    if (isStartDuplicate) {
                        if (loadedData && targetData?.functionManager?.setValue) {
                            targetData.functionManager.setValue(loadedData[altValue]).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        }
                        else {
                            responseAction.errorMessage = "Impossible d'affecter la valeur";
                            resolve(responseAction);
                        }
                    }
                    break;


                case "getModel":
                    var copyConfig;
                    if (altValue) {
                        commonFunc.getMethod("../" + altValue, { id: -1, ...targetValue }).then((response) => {
                            var data = response.data;
                            if (data.isSuccess) {
                                var targetConfig;
                                if (data.result?.models?.length) {
                                    //targetConfig = data.result.models[value];
                                    targetConfig = data.result.models.filter(model => model.extID === value);
                                    copyConfig = targetConfig?.length ? JSON.parse(targetConfig[0].value) : null;
                                }
                                else if (data.result?.length && data.result.filter) {
                                    targetConfig = data.result.filter(model => model.extID === value);
                                    copyConfig = targetConfig?.length ? JSON.parse(targetConfig[0].value) : null;
                                }
                            }

                            if (copyConfig) {
                                responseAction.isSuccess = true;
                                responseAction.result = copyConfig;
                            }
                            else {
                                responseAction.isSuccess = false;
                                responseAction.errorMessage = "Aucun modèle disponible du type : " + value;
                                responseAction.result = "";
                            }
                            resolve(responseAction);
                        });
                        return;
                    }
                    else if (modelsList && Object.keys(modelsList).length) {
                        var targetConfig = modelsList[value];
                        copyConfig = targetConfig ? JSON.parse(JSON.stringify(targetConfig)) : null;
                    }
                    //console.debug(copyConfig);
                    if (copyConfig) {
                        responseAction.isSuccess = true;
                        responseAction.result = copyConfig;
                    }
                    else {
                        responseAction.isSuccess = false;
                        responseAction.errorMessage = "Aucun modèle disponible du type : " + value;
                        responseAction.result = "";
                    }
                    resolve(responseAction);
                    break;
                case "dialogModel":

                    var callbackModal = function (dataElem, valueProc) {
                        return new Promise((resolve, reject) => {
                            if (dataElem && value) {

                                //dataElem correspond aux données du modal > voir si merge à faire

                                if (!componentData.argumentsObj.externalUnmount) {
                                    if (modalRoot) {
                                        modalRoot.unmount();
                                        modalRoot = null;
                                    }
                                }
                                resolve();


                                //Si data défini en source
                                if (componentArgs?.data) {
                                    chainEvents(componentData, value, { value: { key: componentArgs?.key, data: dataElem } });
                                }
                                //valueProc permet d'appeler un processus alternatif au submit paramètré
                                else if (valueProc) {
                                    chainEvents(componentData, valueProc, dataElem);
                                }
                                else {
                                    chainEvents(componentData, value, dataElem);
                                }
                            }
                            else {
                                if (modalRoot) {
                                    modalRoot.unmount();
                                    modalRoot = null;
                                }
                                resolve();
                                if (parentProps.autoClose) ref.current.submitForm("cancel");
                            }
                        });
                    };

                    var argsDlgModel = { trigger: "getModel", value: componentData.argumentsObj.dialogConfig, altValue: componentData.argumentsObj.urlDlgConfig };

                    var valueArgs = componentData.argumentsObj.dialogConfig;
                    if (valueArgs?.startsWith) {
                        if (valueArgs.startsWith("prop:")) argsDlgModel.value = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                        else if (valueArgs.startsWith("value:")) argsDlgModel.value = getValues(commonFunc.camelize(valueArgs.replace("value:", ""), true));
                        else if (valueArgs.startsWith("args:")) argsDlgModel.value = componentData.argumentsObj[valueArgs.replace("args:", "")];
                        else if (valueArgs.startsWith("modelFctManager:")) argsDlgModel.value = commonFunc.getValue(modelFctManager, valueArgs.replace("modelFctManager:", ""));
                        else argsDlgModel.value = valueArgs;
                    }
                    else argsDlgModel.value = valueArgs;

                    argsDlgModel.targetValue = componentData.argumentsObj.dialogModelArgs;

                    modelFctManager.onActionRequired(componentData.name, argsDlgModel, componentData).then(actionResponse => {
                        if (actionResponse.isSuccess) {
                            var type = componentData.argumentsObj.dialogType;
                            var subType = componentData.argumentsObj.dialogSubType;
                            var genId = componentData.argumentsObj.dialogIDLabel;
                            var size = componentData.argumentsObj.dialogSize;

                            var currData = componentArgs?.data || altValue || loadedData;

                            if (componentData.argumentsObj.dlgAutoSave) {
                                var extrasType = subType || type;
                                var bindID = currData["id" + commonFunc.capitalize(extrasType)];
                                var stringSave = localStorage.getItem(componentData.argumentsObj.dlgAutoSave + bindID);
                                if (stringSave) currData = JSON.parse(stringSave);
                            }

                            /*if (systemItem["@@URL_GET@@"] && idElem) {
                                getData(idElem).then((responseData) => {
                                    if (responseData.isSuccess) {
                                        currData = responseData.result;

                                        modalRoot = createRoot(document.createElement('div'));
                                        modalRoot.render(<SubGenModal t={t} configModel={actionResponse.result} checkRights={modelFctManager.checkRights} getRoutes={modelFctManager.getRoutes} genRef={modalGenManager} genId={genId} genType={type} subType={subType} itemData={componentData} title={currData ? t(componentData.subType + "_updTitle") : t(componentData.subType + "_addTitle")} dataElem={currData} callback={callbackModal} />);
                                    }
                                });
                            }
                            else {*/
                            modalRoot = createRoot(document.createElement('div'));
                            modalRoot.render(<SubGenModal t={t} configModel={actionResponse.result} appProps={appProps} checkRights={modelFctManager.checkRights} dataCfg={parentProps.dataCfg} getRoutes={modelFctManager.getRoutes}
                                genRef={modalGenManager} genId={genId} genType={type} subType={subType} itemData={componentData} size={size} title={currData ? t(subType + "_updTitle") : t(subType + "_addTitle")}
                                dataElem={currData} autoSave={componentData.argumentsObj.dlgAutoSave} noSubmit={componentData.argumentsObj.dlgNoSubmit} defaultDisabled={componentData.argumentsObj.dlgDisabled} isSubmitNoCheck={false} callback={callbackModal} />);
                            //}
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_error"),
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                    break;
                case "closeDialog":
                    if (modalRoot) {
                        modalRoot.unmount();
                        modalRoot = null;
                    }
                    break;
                case "printElement":
                    Swal.fire({
                        title: t("gal_processing"),
                        didOpen: () => { Swal.showLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    });

                    //var targets = document.getElementsByClassName(targetValue.targetClass)?.length ? document.getElementsByClassName(targetValue.targetClass)[0] : null;//content
                    var targets = document.getElementsByClassName(targetValue.targetClass)?.length ? Array.from(document.getElementsByClassName(targetValue.targetClass)) : null;//content

                    if (targets) {
                        //if (altValue) target.style["width"] = altValue;
                        setTimeout(() => {
                            modalRoot = createRoot(document.createElement('div'));
                            modalRoot.render(<CHtmlToOutput targets={targets} {...targetValue} callback={() => {
                                Swal.close();
                                if (modalRoot) {
                                    modalRoot.unmount();
                                    modalRoot = null;

                                    //if (altValue) target.style["width"] = null;
                                }
                            }} />);
                        }, 500);
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_error"),
                            html: t("gal_invalidArgs")
                        });
                    }
                    break;
                case "getGeneric":
                    if (url) {
                        var args = {};
                        var cptHasArgs = (componentData.argumentsObj && Object.keys(componentData.argumentsObj).length);
                        var excludeCptArgs = false;
                        if (cptHasArgs) {
                            var filteredTemp = Object.keys(componentData.argumentsObj).filter(key => key === "excludeCptArgs" && componentData.argumentsObj[key] === "getGeneric");
                            excludeCptArgs = (filteredTemp && filteredTemp.length);
                        }
                        if (!excludeCptArgs && componentArgs && Object.keys(componentArgs).length) {
                            Object.keys(componentArgs).forEach((key) => {
                                var valueArgs = componentArgs[key];
                                if (valueArgs?.startsWith) {
                                    if (valueArgs.startsWith("prop:")) args[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;// /!\ il n'y a pas de "else if" à suivre
                                    if (valueArgs.startsWith("value:")) args[key] = getValues(commonFunc.camelize(valueArgs.replace("value:", ""), true));
                                    else if (valueArgs.startsWith("args:")) args[key] = componentArgs[valueArgs.replace("args:", "")];
                                    else if (valueArgs.startsWith("modelFctManager:")) args[key] = commonFunc.getValue(modelFctManager, valueArgs.replace("modelFctManager:", ""));
                                    else if (valueArgs === "curDate") args[key] = curDate;
                                    else args[key] = valueArgs;
                                }
                                else args[key] = valueArgs;

                                if (key === "getCptArgs" && cptHasArgs) {
                                    Object.keys(componentData.argumentsObj).forEach((key) => {
                                        var valueArgs = componentData.argumentsObj[key];
                                        if (valueArgs?.startsWith) {
                                            if (valueArgs.startsWith("prop:")) args[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;// /!\ il n'y a pas de "else if" à suivre
                                            if (valueArgs.startsWith("value:")) args[key] = getValues(commonFunc.camelize(valueArgs.replace("value:", ""), true));
                                            else if (valueArgs.startsWith("args:")) args[key] = componentData.argumentsObj[valueArgs.replace("args:", "")];
                                            else if (valueArgs.startsWith("modelFctManager:")) args[key] = commonFunc.getValue(modelFctManager, valueArgs.replace("modelFctManager:", ""));
                                            else if (valueArgs === "curDate") args[key] = curDate;
                                            else args[key] = valueArgs;
                                        }
                                        else args[key] = valueArgs;
                                    });
                                }
                            });
                        }
                        else if (excludeCptArgs || cptHasArgs) {
                            Object.keys(componentData.argumentsObj).forEach((key) => {
                                var valueArgs = componentData.argumentsObj[key];
                                if (valueArgs?.startsWith) {
                                    if (valueArgs.startsWith("prop:")) args[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;// /!\ il n'y a pas de "else if" à suivre
                                    if (valueArgs.startsWith("value:")) args[key] = getValues(commonFunc.camelize(valueArgs.replace("value:", ""), true));
                                    else if (valueArgs.startsWith("args:")) args[key] = componentData.argumentsObj[valueArgs.replace("args:", "")];
                                    else if (valueArgs.startsWith("modelFctManager:")) args[key] = commonFunc.getValue(modelFctManager, valueArgs.replace("modelFctManager:", ""));
                                    else if (valueArgs === "curDate") args[key] = curDate;
                                    else args[key] = valueArgs;
                                }
                                else args[key] = valueArgs;
                            });
                        }

                        commonFunc.getMethod("../" + url, args).then((response) => {
                            //commonFunc.getMethod("../api/employee/GetWithContractAsKeyItems", args).then((response) => {
                            var data = response.data;
                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue("extra" + targetCache, data.extraInfo);
                                    setCacheValue(targetCache, data.result);
                                }

                                /*var newOptions = data.result.map((employee) => {
                                    return { title: employee.value, value: employee.id };
                                });
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });*/
                                responseAction = data;
                                resolve(responseAction);

                                chainEvents(componentData, value, data.result);
                            }
                            else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = t("gal_invalidArgs");
                        resolve(responseAction);
                    }
                    break;
                case "postGeneric":
                    if (url) {
                        var argsPost = {};
                        var showProcessing = { flag: false };
                        var shouldConfirmProcess = { flag: false };
                        var showResult = { flag: false };
                        if (componentArgs && Object.keys(componentArgs).length) {
                            Object.keys(componentArgs).forEach((key) => {
                                var valueArgs = componentArgs[key];
                                if (valueArgs?.startsWith && valueArgs.startsWith("prop:")) argsPost[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                                else if (valueArgs?.startsWith && valueArgs.startsWith("altValue:")) argsPost[key] = altValue;
                                else argsPost[key] = valueArgs;
                            });
                            showProcessing = { title: componentArgs.processingTitle || "", html: componentArgs.processingHtml || "", flag: (componentArgs.showProcessing ? true : false) };
                            shouldConfirmProcess = { title: componentArgs.confirmTitle || "", html: componentArgs.confirmHtml || "", flag: (componentArgs.confirmProcess ? true : false) };
                            showResult = { title: componentArgs.resultTitle || "", html: componentArgs.resultHtml || "", flag: (componentArgs.showResult ? true : false), errorTitle: componentArgs.resultErrorTitle || "", errorHtml: componentArgs.resultErrorHtml || "" };
                        }
                        var genericProcess = function () {
                            if (showProcessing.flag) {
                                Swal.fire({
                                    title: altT(showProcessing.title, argsPost) || t("gal_processing", argsPost),
                                    html: altT(showProcessing.html, argsPost) || "",
                                    didOpen: () => { Swal.showLoading() },
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    allowEnterKey: false,
                                });
                            }

                            //PostMultipleGeneric classique
                            if (targetValue === "getList") {
                                var extList = [];
                                if (targetData?.functionManager.getTableData) {
                                    extList = targetData.functionManager.getTableData(true)?.data || [];
                                }

                                if (extList?.length) {
                                    var asyncJobs = [];
                                    extList.forEach((elem, index) => {
                                        var elemArgs = {};
                                        if (componentArgs && Object.keys(componentArgs).length) {
                                            Object.keys(componentArgs).forEach((key) => {
                                                var valueArgs = componentArgs[key];
                                                if (valueArgs?.startsWith && valueArgs.startsWith("prop:")) elemArgs[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                                                else if (valueArgs?.startsWith && valueArgs.startsWith("altValue:")) elemArgs[key] = altValue;
                                                else if (valueArgs?.startsWith && valueArgs.startsWith("elem:")) elemArgs[key] = elem[valueArgs.replace("elem:", "")];
                                                else elemArgs[key] = valueArgs;
                                            });
                                        }
                                        asyncJobs[index] = commonFunc.postMethod("../" + url, elemArgs);
                                    });

                                    Promise.all(asyncJobs).then(results => {
                                        console.debug(results);
                                        if (results.length === extList.length) {
                                            var err = 0;
                                            var sum = 0;
                                            //var msgErr = "";
                                            for (var i = 0; i < results.length; i++) {
                                                if (results[i]?.data?.isSuccess) {
                                                    sum += 1;
                                                } else {
                                                    err += 1;
                                                    /*if (results[i]?.data) {
                                                        msgErr += i + " " + results[i].data.errorMessage + "\n";
                                                    } else {
                                                        msgErr += i + "\n";
                                                    }*/
                                                }
                                            }
                                            Swal.close();

                                            if (err === 0) {
                                                responseAction = extList;
                                                resolve(responseAction);

                                                if (showResult.flag) {
                                                    Swal.fire({
                                                        icon: "success",
                                                        title: altT(showResult.title, argsPost) || t("gal_success", argsPost),
                                                        html: altT(showResult.html, argsPost) || "",
                                                        didOpen: () => { Swal.hideLoading() },
                                                    }).then(() => {
                                                        chainEvents(componentData, value);
                                                    });
                                                }
                                                else {
                                                    chainEvents(componentData, value);
                                                }
                                            } else {
                                                var tot = 0;
                                                tot = err + sum;
                                                if (showResult.flag && tot === extList.length) {
                                                    Swal.fire({
                                                        icon: "error",
                                                        title: altT(showResult.errorTitle, argsPost) || t("gal_error", argsPost),
                                                        html: (altT(showResult.errorHtml, argsPost) || "") + ":<br/> (" + t("gal_error") + " : " + err + "/" + tot + ")"
                                                    });
                                                }
                                            }
                                        } else if (showResult.flag) {
                                            Swal.close();
                                            Swal.fire({
                                                icon: "error",
                                                title: altT(showResult.errorTitle, argsPost) || t("gal_error", argsPost),
                                                html: (altT(showResult.errorHtml, argsPost) || "") + ":<br/>"
                                            });
                                        }
                                        responseAction = extList;
                                        //responseAction.forceMessage = true;
                                        resolve(responseAction);
                                    }, rej => {
                                        if (showResult.flag) {
                                            Swal.close();
                                            Swal.fire({
                                                icon: "error",
                                                title: altT(showResult.errorTitle, argsPost) || t("gal_error", argsPost),
                                                html: (altT(showResult.errorHtml, argsPost) || "") + ":<br/>" + rej.message
                                            });
                                        }
                                        responseAction = extList;
                                        //responseAction.forceMessage = true;
                                        resolve(responseAction);
                                    }).catch(error => {
                                        if (showResult.flag) {
                                            Swal.close();
                                            Swal.fire({
                                                icon: "error",
                                                title: altT(showResult.errorTitle, argsPost) || t("gal_error", argsPost),
                                                html: (altT(showResult.errorHtml, argsPost) || "") + ":<br/>" + error.message
                                            });
                                        }
                                        responseAction = extList;
                                        //responseAction.forceMessage = true;
                                        resolve(responseAction);
                                    });
                                }
                                else {
                                    Swal.fire({
                                        icon: "warning",
                                        title: t("gal_warning", argsPost),
                                        html: t("gal_noSelectedElem", argsPost),
                                        didOpen: () => { Swal.hideLoading() },
                                    });
                                }
                            }
                            //PostGeneric classique
                            else {
                                commonFunc.postMethod("../" + url, argsPost).then((response) => {
                                    //commonFunc.getMethod("../api/employee/GetWithContractAsKeyItems", argsPost).then((response) => {
                                    if (showProcessing.flag) Swal.close();

                                    var data = response.data;
                                    if (data.isSuccess) {

                                        /*var newOptions = data.result.map((employee) => {
                                            return { title: employee.value, value: employee.id };
                                        });
                                        targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                            responseAction = responseLoad;
                                            resolve(responseAction);
                                        });*/
                                        responseAction = data;
                                        resolve(responseAction);

                                        if (showResult.flag) {
                                            Swal.fire({
                                                icon: "success",
                                                title: altT(showResult.title, argsPost) || t("gal_success", argsPost),
                                                html: altT(showResult.html, argsPost) || "",
                                                didOpen: () => { Swal.hideLoading() },
                                            }).then(() => {
                                                chainEvents(componentData, value);
                                            });
                                        }
                                        else {
                                            chainEvents(componentData, value);
                                        }
                                    }
                                    else {
                                        responseAction = data;
                                        responseAction.forceMessage = true;
                                        resolve(responseAction);

                                        if (showResult.flag) {
                                            Swal.fire({
                                                icon: "error",
                                                title: altT(showResult.errorTitle, argsPost) || t("gal_error", argsPost),
                                                html: (altT(showResult.errorHtml, argsPost) || "") + ":<br/>" + response.data.errorMessage
                                            });
                                        }
                                    }
                                });
                            }
                        };

                        if (shouldConfirmProcess.flag) {
                            Swal.fire({
                                icon: "question",
                                title: altT(shouldConfirmProcess.title, argsPost) || t("gal_confirmTitle", argsPost),
                                html: altT(shouldConfirmProcess.html, argsPost) || t("gal_confirmAction", argsPost),
                                showCancelButton: true,
                                confirmButtonColor: "#28a745",
                                cancelButtonColor: "#dc3545",
                                confirmButtonText: t("gal_yes"),
                                cancelButtonText: t("gal_no"),
                            }).then((result) => {
                                if (result.value) {
                                    genericProcess();
                                }
                            });
                        }
                        else {
                            genericProcess();
                        }


                    }
                    else {
                        responseAction.errorMessage = t("gal_invalidArgs");
                        resolve(responseAction);
                    }
                    break;

                case "chainAction":
                    var cptTarget = targetData;
                    if (altValue === "currValue") {
                        if (componentArgs && componentArgs.value) {
                            altValue = componentArgs.value;
                        }
                        else {
                            altValue = componentData?.defaultValue;
                        }
                    }
                    else if (altValue === "getValue") {
                        if (componentArgs && componentArgs.value) {
                            altValue = componentArgs.value;
                        }
                        else {
                            altValue = componentData?.functionManager?.getValue ? componentData.functionManager?.getValue() : componentData.defaultValue;
                        }
                    }
                    else if (altValue === "targetValue") {
                        altValue = targetData?.defaultValue;
                        cptTarget = componentData;
                    }
                    else if (altValue === "targetGetValue") {
                        altValue = targetData?.functionManager?.getValue ? targetData.functionManager?.getValue() : targetData.defaultValue;
                        cptTarget = componentData;
                    }

                    //Gestion d'analyse d'une collection
                    var newVal = altValue;
                    if (componentData?.objType === "collection") {
                        var collections = {};
                        if (!commonFunc.isBlank(newVal) && newVal.startsWith) {
                            collections = JSON.parse(newVal.toString());
                            if (Array.isArray(collections)) {
                                if (collections.length) {
                                    var altExtraKey = collections[0].replace("extras.", "");
                                    var extras = getValues("extras");
                                    if (extras) {
                                        //TOCHECK
                                        Object.keys(extras).forEach(keyObj => {
                                            if (keyObj === altExtraKey) {
                                                newVal = extras[keyObj]?.isCollection;
                                            }
                                        });
                                    }
                                    else if (loadedData?.extras && loadedData.extras[altExtraKey + ".isCollection"]) newVal = loadedData.extras[altExtraKey + ".isCollection"] === "true";
                                }
                            }
                            else if (collections && Object.keys(collections).length) {
                                newVal = collections[Object.keys(collections)[0]]?.isCollection;
                            }
                        }
                        else if (newVal) {
                            newVal = newVal.isCollection;
                        }
                    }

                    //console.debug(value);
                    //console.debug(newVal);

                    var cFlag4 = true;
                    if (operatorTest) {
                        cFlag4 = false;
                        switch (operatorTest) {
                            case "=": cFlag4 = (value === newVal); break;
                            case "!=": cFlag4 = (value !== newVal); break;
                            case "<": cFlag4 = (value < newVal); break;
                            case "<=": cFlag4 = (value <= newVal); break;
                            case ">": cFlag4 = (value > newVal); break;
                            case ">=": cFlag4 = (value >= newVal); break;
                            default:
                                break;
                        }
                        //console.debug(cFlag4);
                    }

                    if (cFlag4 && cptTarget) {
                        chainEvents(cptTarget, targetValue, contextType === "chainValue" ? componentArgs?.value : null);
                    }
                    break;
                case "triggerExtraAction":
                    chainEvents(targetData, value, altValue ? altValue : componentArgs);
                    break;
                case "chainFormEditing":
                    chainEvents(targetData, value, formEditing);
                    break;


                case "loadActionStatus":
                    if (url) {
                        var asArgs = {};
                        if (componentArgs && Object.keys(componentArgs).length) {
                            Object.keys(componentArgs).forEach((key) => {
                                var valueArgs = componentArgs[key];
                                if (valueArgs?.startsWith && valueArgs.startsWith("prop:")) asArgs[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                                else asArgs[key] = valueArgs;
                            });
                        }

                        commonFunc.getMethod("../" + url, asArgs).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var newItems = [];
                                var curStep = (loadedData ? data.result.filter((st) => st.idStatus === loadedData.statusID) : []);
                                if (curStep.length) curStep = curStep[0].step;
                                data.result.forEach((status) => {
                                    if (!status.isAutomatic && (!max || status.step < parseInt(max))) {
                                        newItems.push({
                                            name: "ReportItem",
                                            title: "Passer en <" + status.name + ">",
                                            objType: "button",
                                            ignoreParentDisabled: true,
                                            classSup: status.css.replace(/badge/g, "btn").replace("fa-", "untrigger") + " text-white",
                                            onActionEvents: { onClick: [{ trigger: "updateStatusElem", target: "", value: status.idStatus }] },
                                            hideOnAction: [{ id: status.idStatus, trigger: "hideActionStatus", target: "", value: status.step, operatorTest: "=", altValue: curStep, targetValue: (loadedData ? loadedData.statusID : 0) }]
                                        });
                                    }
                                });
                                targetData.items = newItems;
                                if (targetData.functionManager && targetData.functionManager.rerender) targetData.functionManager.rerender();

                                responseAction = data;
                                resolve(responseAction);

                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = t("gal_invalidArgs");
                        resolve(responseAction);
                    }
                    break;
                case "loadStatus":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData && !commonFunc.isBlank(url)) {
                        commonFunc.getMethod("../" + url, null).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var newOptions = [];
                                data.result.forEach((status) => {
                                    if (!status.isAutomatic && (((!min || status.step > parseInt(min)) && (!max || status.step < parseInt(max))) || invalidToHide)) {
                                        newOptions.push({ customDesign: { design: { icon: "fa-circle" } }, title: status.name, value: status.idStatus, hidden: !(!max || status.step < parseInt(max)) });
                                    }
                                });
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });

                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données status";
                        resolve(responseAction);
                    }
                    break;

                case "loadEmployees":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        var argsEmp = { period: "D" };
                        if (componentArgs) {
                            if (componentArgs.type === "date" || componentArgs.type === "dateonly" || componentArgs.type === "time") {
                                argsEmp.startdate = moment(componentArgs.value).format("YYYY-MM-DDTHH:mmZ");//TEMP : voir pour utc
                            }
                            else if (componentArgs.type) {
                                var valueSd = getValues(commonFunc.camelize("Itv.StartDate", true)) ? moment(getValues(commonFunc.camelize("Itv.StartDate", true))) : moment();
                                argsEmp.startdate = moment(valueSd).format("YYYY-MM-DDTHH:mmZ");//TEMP : voir pour utc
                            }
                        }
                        else {
                            argsEmp.startdate = moment().format("YYYY-MM-DDTHH:mmZ");
                        }

                        var flagNoContract = false;
                        var urlEmp = "api/report/GetReportEmployees";
                        var argsUrl = targetData.argumentsObj?.url ? targetData.argumentsObj : (componentData.argumentsObj?.url ? componentData.argumentsObj : null);
                        if (argsUrl && argsUrl.url && !argsUrl.immutableUrl) {
                            urlEmp = argsUrl.url;

                            //Check Config NoContract
                            if (appProps) {
                                var siteLE = appProps.getSite();
                                if (siteLE) {
                                    var siteExtras = siteLE.extras;
                                    if (!(siteExtras && siteExtras.length && siteExtras.filter(extra => extra.name === "withContract").length > 0)) {
                                        urlEmp = urlEmp.replace("employee/GetWithContractAsKeyItems", "employee/GetEmployees");
                                        urlEmp = urlEmp.replace("report/GetReportEmployees", "employee/GetEmployees");
                                        flagNoContract = true;
                                    }
                                }
                            }
                        }

                        var manageEmployees = (employeesAlt) => {
                            if (flagNoContract) {
                                employeesAlt = employeesAlt.map(emp => { return { id: (emp.idEmployee || emp.id), value: emp.idEmployee ? (emp.name + " " + emp.firstName) : emp.title } })
                            }

                            var newOptions = employeesAlt.map((employee) => {
                                return { title: (employee.value || employee.title), value: employee.id };
                            });

                            if (altValue?.sortTitle) {
                                newOptions = newOptions.sort((a, b) => a.title.localeCompare(b.title));
                            }

                            targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        };

                        if (useCache && dataCache && dataCache[targetCache]) {
                            manageEmployees(dataCache[targetCache]);
                        }
                        else {
                            commonFunc.getMethod("../" + urlEmp, argsEmp).then((response) => {
                                //commonFunc.getMethod("../api/employee/GetWithContractAsKeyItems", argsEmp).then((response) => {
                                var data = response.data;
                                if (data.isSuccess) {
                                    if (useCache) {
                                        setCacheValue(targetCache, data.result);
                                    }
                                    manageEmployees(data.result);
                                }
                                else {
                                    responseAction = data;
                                    resolve(responseAction);
                                }
                            });
                        }

                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données salariés";
                        resolve(responseAction);
                    }
                    break;
                case "loadServices":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {

                        var urlSvc = "api/report/GetReportServices";
                        if (componentData.argumentsObj && componentData.argumentsObj.url) {
                            urlSvc = componentData.argumentsObj.url;
                        }

                        var filterContract = (componentData.argumentsObj && componentData.argumentsObj.onlyContract);
                        var filterNoContract = (componentData.argumentsObj && componentData.argumentsObj.noContract);

                        var manageServices = (servicesFiltered) => {
                            if (filterContract) servicesFiltered = servicesFiltered.filter(svc => svc.isContract);
                            else if (filterNoContract) servicesFiltered = servicesFiltered.filter(svc => !svc.isContract);

                            var newOptions = servicesFiltered.map((service) => {//TODO : iscontract
                                return { title: service.name, value: service.idService, srcData: service };
                            });
                            targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        };

                        if (useCache && dataCache && dataCache[targetCache]) {
                            manageServices(dataCache[targetCache]);
                        }
                        else {
                            var argsSvc = null;
                            commonFunc.getMethod("../" + urlSvc, argsSvc).then((response) => {
                                var data = response.data;
                                if (data.isSuccess) {
                                    if (useCache) {
                                        setCacheValue(targetCache, data.result);
                                    }

                                    manageServices(data.result);

                                } else {
                                    responseAction = data;
                                    resolve(responseAction);
                                }
                            });
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données services";
                        resolve(responseAction);
                    }
                    break;
                case "loadClients":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        var argsCli = { period: "D", level: (altValue >= 0 ? altValue : 1), state: 900 };
                        if (componentArgs) {
                            if (componentArgs.type === "date" || componentArgs.type === "dateonly" || componentArgs.type === "time") {
                                argsCli.startdate = moment(componentArgs.value).format("YYYY-MM-DDTHH:mmZ");//TEMP : voir pour utc
                            }
                            else if (componentArgs.type) {
                                var valueSdCli = getValues(commonFunc.camelize("StartDate", true)) ? moment(getValues(commonFunc.camelize("StartDate", true))) : moment();
                                argsCli.startdate = moment(valueSdCli).format("YYYY-MM-DDTHH:mmZ");//TEMP : voir pour utc
                            }
                        }
                        else {
                            argsCli.startdate = moment().format("YYYY-MM-DDTHH:mmZ");
                        }

                        //var flagNoContractLC = false;
                        var urlCli = "../api/client/GetWithAgreement";//AsKeyItems
                        //Check Config NoContract
                        if (appProps && (componentData.argumentsObj == null || !componentData.argumentsObj.immutableUrl)) {
                            var siteLC = appProps.getSite();
                            if (siteLC) {
                                var siteExtrasLC = siteLC.extras;
                                if (!(siteExtrasLC && siteExtrasLC.length && siteExtrasLC.filter(extra => extra.name === "withContract").length > 0)) {
                                    urlCli = urlCli.replace("client/GetWithAgreement", "client/GetClients");//AsKeyItems
                                    //flagNoContractLC = true;
                                }
                            }
                        }

                        var manageClients = (clientsAlt) => {
                            //if (flagNoContractLC) {
                            clientsAlt = clientsAlt.map(emp => { return { ...emp,  id: emp.idClient, value: (emp.name + " " + emp.firstName + (emp.compagny ? (" - " + emp.compagny) : "")), address: emp.address, billingAddress: emp.billingAddress } })
                            //}

                            var newOptions = clientsAlt.filter(cli => cli.id > 0).map((client) => {
                                return { title: client.value, value: client.id, srcData: client };
                            });
                            targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        };

                        if (useCache && dataCache && dataCache[targetCache]) {
                            manageClients(dataCache[targetCache]);
                        }
                        else {
                            commonFunc.getMethod(urlCli, argsCli).then((response) => {
                                var data = response.data;

                                if (data.isSuccess) {
                                    if (useCache) {
                                        setCacheValue(targetCache, data.result);
                                    }
                                    manageClients(data.result);

                                } else {
                                    responseAction = data;
                                    resolve(responseAction);
                                }
                            });
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données clients";
                        resolve(responseAction);
                    }
                    break;
                case "loadSites":
                case "loadSitesNoSelected":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        var manageSites = (rptSites) => {
                            var user = getUser ? getUser() : (appProps?.getUser ? appProps.getUser() : null);
                            var newOptions = rptSites.map((objSite) => {
                                return { title: objSite.localSite.name, value: objSite.localSite.idSite, selected: (actionKey !== "loadSitesNoSelected" && objSite.localSite.idSite === user?.groupSId) };
                            });
                            targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        };

                        if (useCache && dataCache && dataCache[targetCache]) {
                            manageSites(dataCache[targetCache]);
                        }
                        else {
                            var argsSites = null;
                            commonFunc.getMethod("../api/Data/GetAlternativeSites", argsSites).then((response) => {
                                var data = response.data;

                                if (data.isSuccess) {
                                    if (useCache) {
                                        setCacheValue(targetCache, data.result);
                                    }
                                    manageSites(data.result);

                                } else {
                                    responseAction = data;
                                    resolve(responseAction);
                                }
                            });
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données agences";
                        resolve(responseAction);
                    }
                    break;
                case "loadReportTemplates":
                    if (dataCache[targetCache] && targetData && targetData.functionManager && targetData.functionManager.populateData) {

                        var service = dataCache[targetCache].filter((svc) => {
                            return svc.idService === parseInt(componentArgs.value);
                        });

                        if (service.length && service[0].templates) {
                            var newOptions = [];
                            service[0].templates.forEach((template) => {
                                if (template.isActive && ((!altValue && !template.isHtml) || (altValue && template.isHtml))) {
                                    newOptions.push({ title: template.name, value: template.idTemplate });
                                }
                            });
                            if (newOptions.length === 0) newOptions.push({ title: "Aucun", value: -1 });
                            targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        }
                        else {
                            responseAction.errorMessage = "Impossible de charger les données : Aucun modèle";
                            resolve(responseAction);
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données templates";
                        resolve(responseAction);
                    }
                    break;

                case "loadReportGroupTemplates":
                    if (dataCache[targetCache] && targetData && targetData.functionManager && targetData.functionManager.populateData) {

                        var serviceRGT = dataCache[targetCache].filter((svc) => {
                            return svc.idService === parseInt(componentArgs.value);
                        });

                        if (serviceRGT.length && serviceRGT[0].templates) {
                            var newOptionsRGT = [];
                            var selectedValue;

                            var extDef = serviceRGT[0].templates.reduce((extList, template) => {
                                if (template.isActive && ((!altValue && !template.isHtml) || (altValue && template.isHtml))) {
                                    (extList[template.extID] = extList[template.extID] || []).push(template);
                                }
                                return extList;
                            }, {});

                            //Alimentation de la liste de template
                            Object.keys(extDef).forEach((key) => {
                                var templates = extDef[key];
                                var title = key;
                                if (templates && templates.length) {
                                    title = templates[0].name.replace(" - Mobile", "");
                                    if (loadedData && loadedData.appTemplateID && templates.filter(template => template.idTemplate === loadedData.appTemplateID).length) {
                                        selectedValue = key;
                                    }
                                }
                                newOptionsRGT.push({ title: title, value: key });
                            });
                            //Alimentation de la liste de template (valeur rapport)
                            if (!selectedValue && loadedData && loadedData.appTemplate) {
                                newOptionsRGT.push({ title: loadedData.appTemplate.name.replace(" - Mobile", ""), value: loadedData.appTemplate.extID });
                                selectedValue = loadedData.appTemplate.extID;
                            }


                            if (newOptionsRGT.length === 0) newOptionsRGT.push({ title: "Aucun", value: -1 });
                            targetData.functionManager.populateData(newOptionsRGT, true).then((responseLoad) => {
                                if (selectedValue) {
                                    targetData.functionManager.setValue(selectedValue).then((responseLoad) => {
                                        targetData.functionManager.triggerChange(selectedValue);
                                        responseAction = responseLoad;
                                        resolve(responseAction);
                                    });
                                }
                                else {
                                    targetData.functionManager.triggerChange();
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                }
                            });
                        }
                        else {
                            responseAction.errorMessage = "Impossible de charger les données : Aucun modèle";
                            resolve(responseAction);
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données groupTemplates";
                        resolve(responseAction);
                    }
                    break;

                case "setTemplateValue":
                    if (dataCache[targetCache] && targetData?.functionManager?.setValue) {

                        var currServiceComp = dataList[commonFunc.camelize("BenefitID", true)] || dataList[commonFunc.camelize("Itv.ServiceID", true)];
                        var currServiceID = parseInt(currServiceComp.functionManager.getValue()) || parseInt(getValues(commonFunc.camelize("BenefitID", true))) || parseInt(currServiceComp.defaultValue);
                        var serviceSV = dataCache[targetCache].filter((svc) => {
                            return svc.idService === parseInt(currServiceID);
                        });

                        if (currServiceID && serviceSV.length && serviceSV[0].templates) {
                            var groupValue = componentArgs.value || componentData.functionManager.getValue() || getValues(commonFunc.camelize(componentData.bindPropResult, true)) || componentData.defaultValue;
                            var templateFiltered = serviceSV[0].templates.filter(template => template.extID === groupValue && (altValue ? template.isHtml : !template.isHtml));

                            if (templateFiltered.length) {
                                targetData.functionManager.setValue(templateFiltered[0].idTemplate).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });
                            }
                        }
                        else {
                            //responseAction.errorMessage = "Impossible de charger les données : Aucun modèle";
                            //resolve(responseAction);
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données templateValue";
                        resolve(responseAction);
                    }
                    break;


                case "loadReportStatus":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        var manageStatus = (rptStatus) => {
                            var newOptions = [];
                            rptStatus.forEach((status) => {
                                if ((!status.isAutomatic && (!min || status.step > parseInt(min)) && (!max || status.step < parseInt(max))) || loadedData?.statusID === status.idStatus) {
                                    newOptions.push({ customDesign: { design: { icon: "fa-circle" } }, title: altT(status.name), value: status.idStatus, srcData: status });
                                }
                            });
                            targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        };

                        if (useCache && dataCache && dataCache[targetCache]) {
                            manageStatus(dataCache[targetCache]);
                        }
                        else {
                            commonFunc.getMethod("../api/report/GetStatus", null).then((response) => {
                                var data = response.data;

                                if (data.isSuccess) {
                                    if (useCache) {
                                        setCacheValue(targetCache, data.result);
                                    }
                                    manageStatus(data.result);

                                } else {
                                    responseAction = data;
                                    resolve(responseAction);
                                }
                            });
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données statuts";
                        resolve(responseAction);
                    }
                    break;
                case "loadClientStatus":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        commonFunc.getMethod("../api/client/GetStatus", null).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var newOptions = [];
                                data.result.forEach((status) => {
                                    if (!status.isAutomatic && (!max || status.step < parseInt(max))) {
                                        newOptions.push({ customDesign: { design: { icon: "fa-circle" } }, title: status.name, value: status.idStatus });
                                    }
                                });
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });

                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données status";
                        resolve(responseAction);
                    }
                    break;
                case "loadEmployeeStatus":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        commonFunc.getMethod("../api/employee/GetStatus", null).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var newOptions = [];
                                data.result.forEach((status) => {
                                    if (!status.isAutomatic && (!max || status.step < parseInt(max))) {
                                        newOptions.push({ customDesign: { design: { icon: "fa-circle" } }, title: status.name, value: status.idStatus });
                                    }
                                });
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });

                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données status";
                        resolve(responseAction);
                    }
                    break;

                case "loadClientCategories":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        commonFunc.getMethod("../api/client/GetClientCategories", null).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var newOptions = [];
                                data.result.forEach((category) => {
                                    newOptions.push({ title: category.name, value: category.idCateg });
                                });
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });

                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données catégories clients";
                        resolve(responseAction);
                    }
                    break;
                case "loadEmployeeCategories":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        commonFunc.getMethod("../api/employee/GetEmployeeCategories", null).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var newOptions = [];
                                data.result.forEach((category) => {
                                    newOptions.push({ title: category.name, value: category.idCateg });
                                });
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });

                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données catégories salariés";
                        resolve(responseAction);
                    }
                    break;
                case "loadLeadCategories":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        var argsLLC = null;
                        if (altValue) argsLLC = { groupKey: altValue };
                        commonFunc.getMethod("../api/lead/GetLeadCategories", argsLLC).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var newOptions = [];
                                data.result.forEach((category) => {
                                    newOptions.push({ title: category.name, value: category.idCateg });
                                });
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });

                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données catégories leads";
                        resolve(responseAction);
                    }
                    break;
                case "loadMaterialCategories":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        var argsLMC = null;
                        if (altValue) argsLMC = { groupKey: altValue };
                        commonFunc.getMethod("../api/material/GetMaterialCategories", argsLMC).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var newOptions = [];
                                data.result.forEach((category) => {
                                    newOptions.push({ title: category.name, value: category.idCateg });
                                });
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });

                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données catégories matériels";
                        resolve(responseAction);
                    }
                    break;
                case "loadElementCategories":
                    if (targetData?.functionManager?.populateData) {
                        commonFunc.getMethod("../api/" + value + "/Get" + value + "Categories", null).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var idTarget = componentData.argumentsObj?.loadIdTarget;
                                var nameTarget = componentData.argumentsObj?.loadNameTarget;


                                var newOptions = [];
                                data.result.forEach((group) => {
                                    var flagEG2 = true;
                                    if (operatorTest) {
                                        flagEG2 = false;
                                        switch (operatorTest) {
                                            case "=": flagEG2 = (group[idTarget] === altValue); break;
                                            case "!=": flagEG2 = (group[idTarget] !== altValue); break;
                                            case "<": flagEG2 = (group[idTarget] < altValue); break;
                                            case "<=": flagEG2 = (group[idTarget] <= altValue); break;
                                            case ">": flagEG2 = (group[idTarget] > altValue); break;
                                            case ">=": flagEG2 = (group[idTarget] >= altValue); break;
                                            default:
                                                break;
                                        }
                                    }
                                    if (min || min === 0) flagEG2 &= group.idCateg >= min;
                                    if (max || max === 0) flagEG2 &= group.idCateg <= max;
                                    if (flagEG2) newOptions.push({ title: group[nameTarget], value: group[idTarget] });
                                });
                                /*var newOptions = [];
                                data.result.forEach((category) => {
                                    newOptions.push({ title: category.name, value: category.idCateg });
                                });*/
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });


                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données catégories";
                        resolve(responseAction);
                    }
                    break;

                case "loadEmployeeGroups":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        commonFunc.getMethod("../api/employee/GetEmployeeGroups", null).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var newOptions = [];
                                data.result.forEach((group) => {
                                    var flagEG = true;
                                    if (operatorTest) {
                                        flagEG = false;
                                        switch (operatorTest) {
                                            case "=": flagEG = (group.idSegment === altValue); break;
                                            case "!=": flagEG = (group.idSegment !== altValue); break;
                                            case "<": flagEG = (group.idSegment < altValue); break;
                                            case "<=": flagEG = (group.idSegment <= altValue); break;
                                            case ">": flagEG = (group.idSegment > altValue); break;
                                            case ">=": flagEG = (group.idSegment >= altValue); break;
                                            default:
                                                break;
                                        }
                                    }
                                    if (flagEG) newOptions.push({ title: group.title, value: group.idSegment });
                                });
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });

                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données groupes salariés";
                        resolve(responseAction);
                    }
                    break;

                case "loadElementGroups":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData && componentData.argumentsObj) {
                        commonFunc.getMethod("../api/" + value + "/Get" + value + "Groups", null).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var idTarget = componentData.argumentsObj.loadIdTarget;
                                var nameTarget = componentData.argumentsObj.loadNameTarget;


                                var newOptions = [];
                                data.result.forEach((group) => {
                                    var flagEG2 = true;
                                    if (operatorTest) {
                                        flagEG2 = false;
                                        switch (operatorTest) {
                                            case "=": flagEG2 = (group[idTarget] === altValue); break;
                                            case "!=": flagEG2 = (group[idTarget] !== altValue); break;
                                            case "<": flagEG2 = (group[idTarget] < altValue); break;
                                            case "<=": flagEG2 = (group[idTarget] <= altValue); break;
                                            case ">": flagEG2 = (group[idTarget] > altValue); break;
                                            case ">=": flagEG2 = (group[idTarget] >= altValue); break;
                                            default:
                                                break;
                                        }
                                    }
                                    //Gestion groups avec héritage parent Site
                                    if (flagEG2 && group.groupSiteID) {
                                        var uniqueOpts = newOptions.filter(opt => opt.title === group[nameTarget]);
                                        if (uniqueOpts?.length) {
                                            if ((loadedData.idSite && loadedData.idSite === group.groupSiteID) || (!loadedData.idSite && uniqueOpts[0].srcData?.groupSiteID > group.groupSiteID)) {
                                                uniqueOpts[0].value = group[idTarget];
                                                uniqueOpts[0].srcData = group;
                                            }
                                            flagEG2 = false;
                                        }
                                    }
                                    if (flagEG2) newOptions.push({ title: group[nameTarget], value: group[idTarget], srcData: group });
                                });
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });

                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données groupes";
                        resolve(responseAction);
                    }
                    break;

                case "loadAccessRoles":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        commonFunc.getMethod("../api/GetRoles", null).then((response) => {
                            var data = response.data;

                            if (data.isSuccess) {
                                if (useCache) {
                                    setCacheValue(targetCache, data.result);
                                }

                                var newOptions = [];
                                data.result.forEach((role) => {
                                    var flagEG = true;
                                    if (operatorTest) {
                                        flagEG = false;
                                        switch (operatorTest) {
                                            case "=": flagEG = (role.description === altValue); break;
                                            case "!=": flagEG = (role.description !== altValue); break;
                                            case "<": flagEG = (role.description < altValue); break;
                                            case "<=": flagEG = (role.description <= altValue); break;
                                            case ">": flagEG = (role.description > altValue); break;
                                            case ">=": flagEG = (role.description >= altValue); break;
                                            default:
                                                break;
                                        }
                                    }
                                    if (flagEG) newOptions.push({ title: role.name, value: role.name });
                                });
                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });

                            } else {
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les rôles";
                        resolve(responseAction);
                    }
                    break;

                case "populateData":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData && componentData.argumentsObj) {

                        var populateProc = (data) => {
                            var idTarget = componentData.argumentsObj.loadIdTarget;
                            var titleTarget = componentData.argumentsObj.loadTitleTarget;


                            var newOptions = [];
                            data.forEach((group) => {
                                var flagEG2 = true;
                                if (operatorTest) {
                                    flagEG2 = false;
                                    switch (operatorTest) {
                                        case "=": flagEG2 = (group[idTarget] === targetValue); break;
                                        case "!=": flagEG2 = (group[idTarget] !== targetValue); break;
                                        case "<": flagEG2 = (group[idTarget] < targetValue); break;
                                        case "<=": flagEG2 = (group[idTarget] <= targetValue); break;
                                        case ">": flagEG2 = (group[idTarget] > targetValue); break;
                                        case ">=": flagEG2 = (group[idTarget] >= targetValue); break;
                                        default:
                                            break;
                                    }
                                }
                                if (flagEG2) newOptions.push({ title: group[titleTarget], value: group[idTarget] });
                            });
                            targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        };


                        if (componentData.argumentsObj.url) {
                            commonFunc.getMethod("../" + componentData.argumentsObj.url, null).then((response) => {
                                var data = response.data;

                                if (data.isSuccess) {
                                    if (useCache) {
                                        setCacheValue(targetCache, data.result);
                                    }

                                    populateProc(data.result);

                                } else {
                                    responseAction = data;
                                    resolve(responseAction);
                                }
                            });
                        }
                        else {
                            populateProc(altValue);
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données " + target;
                        resolve(responseAction);
                    }
                    break;



                case "loadCountry":
                    var countries = [];
                    var newOptionsCtry = [];
                    countries.forEach((country) => {
                        if (country.isActive) {
                            newOptionsCtry.push({ title: country.name, value: country.id });
                        }
                    });
                    if (newOptionsCtry.length === 0) newOptionsCtry.push({ title: "France", value: "FRANCE" });
                    targetData.functionManager.populateData(newOptionsCtry, true).then((responseLoad) => {
                        responseAction = responseLoad;
                        resolve(responseAction);
                    });
                    break;


                case "rerender":
                    if (targetData && targetData.functionManager && targetData.functionManager.rerender) {
                        targetData.functionManager.rerender();

                        responseAction.isSuccess = true;
                        responseAction.result = true;
                        resolve(responseAction);
                    }
                    break;
                case "refreshList":
                    if (targetData?.functionManager.refreshList) {
                        targetData.functionManager.refreshList();
                    }
                    break;
                case "reajustTable":
                        if (targetData?.functionManager.getTable) {
                            var tableR = targetData.functionManager.getTable();
                            setTimeout(() => {
                                try {
                                    if (tableR) tableR.columns.adjust().draw();
                                }
                                catch (e) {
                                    console.error(e);
                                }
                            }, 1000);
                        }
                    break;
                case "transfereSrcData":
                    if (!componentData.argumentsObj) componentData.argumentsObj = {};
                    componentData.argumentsObj.srcData = altValue;
                    chainEvents(componentData, value);
                    break;

                case "setModelDate":
                    if (targetData?.functionManager?.setValue && value && dataCache[value]) {
                        var alteredCache = false;
                        var cacheValue;
                        if (dataCache[value]?.length) {
                            cacheValue = dataCache[value][0];
                        }
                        else {
                            cacheValue = dataCache[value];
                        }

                        var keyCache = altValue;
                        var curVal;
                        if (altValue.startsWith("extras.")) {
                            var cExtras = cacheValue.extras;
                            if (cExtras?.length) {
                                var extraElem = cExtras.filter(extra => extra.name === altValue.replace("extras.", ""));
                                if (extraElem.length) {
                                    curVal = extraElem[0].value;
                                }
                            }
                        }
                        else {
                            curVal = cacheValue[keyCache];
                        }


                        //SITEINFOS
                        console.debug(curVal);
                        console.debug(cacheValue);
                        dataCache = {};
                        //cacheValue.email = "toto@toto.tst";

                        setCurDate(curVal);
                    }
                    break;

                case "concatValue":
                    targetData[altValue] = value + targetData.defaultValue;
                    if (targetValue === "cleanDefaultValue") targetData.defaultValue = "";
                    else if (targetValue === "setValue" && targetData.functionManager?.setValue) {
                        targetData.functionManager.setValue(targetData[altValue]).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    if (targetData.functionManager?.rerender) targetData.functionManager.rerender();
                    break;
                case "concatValues":
                    var concatValue = "";
                    var splitTargets = altValue.split(";");
                    splitTargets.forEach((key, index) => {
                        var cTarget = dataList[commonFunc.camelize(key.replace("optlabel:", ""), true)];
                        if (cTarget) {
                            if (key.startsWith("optlabel:")) {
                                var opt = cTarget.functionManager.getSelectedOption();
                                if (opt) {
                                    concatValue += (opt.title + (splitTargets.length > (index + 1) ? " - " : "")) || "";
                                }
                                else if (contextType !== 1) {
                                    setTimeout(() => {
                                        triggerObj.contextType = 1;
                                        cTarget.functionManager.triggerChange();
                                    }, 1000);
                                }
                            }
                            else {
                                concatValue += ((cTarget?.functionManager?.getValue ? cTarget.functionManager.getValue() : "") + (splitTargets.length > (index + 1) ? " - " : "")) || "";
                            }
                        }
                    });
                    if (concatValue) {
                        targetData.functionManager.setValue(concatValue).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                        if (targetData.functionManager?.rerender) targetData.functionManager.rerender();
                    }
                    break;
                case "updValue":
                    if (targetData && targetData.functionManager && (targetData.functionManager.triggerChange || targetData.functionManager.setValue) && componentArgs) {
                        var cFlag3 = true;
                        if (operatorTest) {
                            cFlag3 = false;
                            switch (operatorTest) {
                                case "=": cFlag3 = (value === componentArgs.value); break;
                                case "!=": cFlag3 = (value !== componentArgs.value); break;
                                case "<": cFlag3 = (value < componentArgs.value); break;
                                case "<=": cFlag3 = (value <= componentArgs.value); break;
                                case ">": cFlag3 = (value > componentArgs.value); break;
                                case ">=": cFlag3 = (value >= componentArgs.value); break;
                                default:
                                    break;
                            }
                        }

                        var cNewValue3 = getValues(commonFunc.camelize(targetData.bindPropResult, true));
                        if (cFlag3) {
                            if (targetData.functionManager.triggerChange) {
                                targetData.functionManager.triggerChange().then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });
                            }
                            else {
                                targetData.functionManager.setValue(cNewValue3).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });
                            }
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;
                case "setValue":
                case "setValueActive":
                case "setValueCreate":
                case "setValueEncrypted":
                    if (targetData?.functionManager?.setValue) {
                        if ((actionKey !== "setValueActive" || !targetData.functionManager.isDisabled || !targetData.functionManager.isDisabled()) && (actionKey !== "setValueCreate" || !isUpdateGen)) {
                            var cNewValue = componentArgs?.value;
                            if (altValue === "secondValue") cNewValue = componentArgs?.secondValue;
                            else if (altValue?.startsWith && altValue.startsWith("targetValue:")) {
                                cNewValue = getValues(altValue.replace("targetValue:", ""));
                            }
                            else if (altValue?.startsWith && altValue.startsWith("user:")) {
                                var user = getUser ? getUser() : (appProps?.getUser ? appProps.getUser() : null);
                                if (user) cNewValue = user[altValue.replace("user:", "")];
                            }
                            else if (altValue !== null && altValue !== undefined) cNewValue = altValue

                            if (componentArgs?.value && contextType === 'string') componentArgs.value = componentArgs?.value.toString();

                            //Gestion d'un chemin d'accès à la donnée
                            if (contextType?.startsWith && contextType.startsWith("subPath:")) {
                                if (contextType.replace("subPath:", "") === "days") {
                                    var daysList = [];
                                    var mVal = commonFunc.getValue(cNewValue, "value.data.customWMonday");
                                    var tsVal = commonFunc.getValue(cNewValue, "value.data.customWTuesday");
                                    var wVal = commonFunc.getValue(cNewValue, "value.data.customWWednesday");
                                    var tVal = commonFunc.getValue(cNewValue, "value.data.customWThursday");
                                    var fVal = commonFunc.getValue(cNewValue, "value.data.customWFriday");
                                    var sVal = commonFunc.getValue(cNewValue, "value.data.customWSaturday");
                                    var suVal = commonFunc.getValue(cNewValue, "value.data.customWSunday");

                                    daysList.push(mVal === "true" ? "Lundi" : null);
                                    daysList.push(tsVal === "true" ? "Mardi" : null);
                                    daysList.push(wVal === "true" ? "Mercredi" : null);
                                    daysList.push(tVal === "true" ? "Jeudi" : null);
                                    daysList.push(fVal === "true" ? "Vendredi" : null);
                                    daysList.push(sVal === "true" ? "Samedi" : null);
                                    daysList.push(suVal === "true" ? "Dimanche" : null);

                                    cNewValue = daysList.filter(day => day !== null).join(", ");

                                    if (commonFunc.isBlank(cNewValue)) {
                                        responseAction.isSuccess = true;
                                        responseAction.result = true;
                                        resolve(responseAction);
                                        return;
                                    }
                                }
                                else cNewValue = commonFunc.getValue(cNewValue, contextType.replace("subPath:", ""));
                            }


                            //console.debug(componentArgs?.value);
                            //console.debug(value);
                            //console.debug(altValue);

                            var cFlag = true;
                            if (operatorTest) {
                                cFlag = false;
                                switch (operatorTest) {
                                    case "=": cFlag = (value === componentArgs?.value); break;
                                    case "!=": cFlag = (value !== componentArgs?.value); break;
                                    case "<": cFlag = (value < componentArgs?.value); break;
                                    case "<=": cFlag = (value <= componentArgs?.value); break;
                                    case ">": cFlag = (value > componentArgs?.value); break;
                                    case ">=": cFlag = (value >= componentArgs?.value); break;
                                    default:
                                        break;
                                }
                            }
                            if (cFlag) {
                                //Affectation d'une valeur crypté
                                if (actionKey === "setValueEncrypted") {
                                    var orgExtras = loadedData.orgExtras.filter(orgExtra => orgExtra.tag === target);
                                    if (orgExtras?.length) {
                                        orgExtras[0].format = "encrypted";
                                    }
                                }

                                targetData.functionManager.setValue(cNewValue).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);

                                    if ((triggerObj.contextType === "change" || targetValue === "change") && targetData.functionManager.triggerChange) targetData.functionManager.triggerChange();
                                });
                            }
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;
                case "setCalcValue":
                    if (targetData?.functionManager?.setValue) {
                        //if (!targetData.functionManager.isDisabled || !targetData.functionManager.isDisabled()) {
                            var outputObj = {};

                            altValue.forEach((calcObj) => {
                                if (calcObj?.key && calcObj.operator && calcObj?.targets?.indexOf(";") >= 0) {
                                    var splitTargets = calcObj.targets.split(";");
                                    var value1, value2, output;
                                    var cTarget;
                                    if (splitTargets[0].startsWith("key:")) {
                                        value1 = outputObj[splitTargets[0].replace("key:", "")];
                                    }
                                    else {
                                        cTarget = dataList[commonFunc.camelize(splitTargets[0], true)];
                                        value1 = getValues(commonFunc.camelize(splitTargets[0], true)) || cTarget?.defaultValue;
                                    }
                                    if (splitTargets[1].startsWith("key:")) {
                                        value2 = outputObj[splitTargets[1].replace("key:", "")];
                                    }
                                    else {
                                        cTarget = dataList[commonFunc.camelize(splitTargets[1], true)];
                                        value2 = getValues(commonFunc.camelize(splitTargets[1], true)) || cTarget?.defaultValue;
                                    }

                                    //console.debug(value1);
                                    //console.debug(value2);

                                    switch (calcObj.operator) {
                                        case "+": output = (value1 + value2); break;
                                        case "-": output = (value1 - value2); break;
                                        case "/": output = (value1 / value2); break;
                                        case "*": output = (value1 * value2); break;
                                        default:
                                            break;
                                    }
                                    outputObj[calcObj.key] = output;
                                }
                            });

                            //console.debug(outputObj);

                            targetData.functionManager.setValue(outputObj["total"].toFixed(2)).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);

                                if ((triggerObj.contextType === "change" || targetValue === "change") && targetData.functionManager.triggerChange) targetData.functionManager.triggerChange();
                            });
                        //}
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;
                case "setValueFromSrcData":
                    if (targetData && targetData.functionManager && targetData.functionManager.setValue && componentArgs && componentArgs.srcData) {
                        var srcValue = commonFunc.getValue(componentArgs.srcData, value);
                        targetData.functionManager.setValue(srcValue).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;
                case "setStatsValue":
                    if (targetData && targetData.functionManager && targetData.functionManager.setValue && componentArgs && value) {
                        var targetRow = altValue.filter((dataRow) => dataRow.tag === value);
                        if (targetRow.length) {
                            var statsValue = targetRow[0].amount;
                            //console.debug("TOTO " + value);
                            //console.debug(statsValue);
                            targetData.functionManager.setValue(statsValue, true).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        }
                        else {
                            //responseAction.errorMessage = "Champ introuvable";
                            //resolve(responseAction);
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;
                case "setValueTable":
                    if (targetData && targetData.functionManager && targetData.functionManager.setValue) {
                        if (value?.length) {
                            var rowsLength = value.length;
                            rowsLength = value.filter((row) => !row.isActive).length;

                            targetData.functionManager.setValue(altValue.replace("{0}", rowsLength), true).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;
                case "setDateonly":
                    //elementList[target].defaultValue = new Date();
                    //elementList[element.data.bindPropResult].defaultValue = new Date("2001-05-05");
                    if (targetData && targetData.functionManager && targetData.functionManager.setDateonly && componentArgs) {
                        targetData.functionManager.setDateonly(componentArgs.value).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    //setValue(commonFunc.camelize(target, true), new Date());
                    break;

                case "incrementValue":
                    if (targetData?.functionManager?.setValue) {
                        var srcCptValue = componentArgs?.value;
                        if (!srcCptValue) {
                            var cTarget = dataList[commonFunc.camelize(targetData.bindPropResult, true)];
                            srcCptValue = getValues(commonFunc.camelize(targetData.bindPropResult, true)) || cTarget?.defaultValue;
                        }
                        var cIncrValue = parseInt(srcCptValue) + 1;

                        targetData.functionManager.setValue(cIncrValue).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);

                            if ((triggerObj.contextType === "change" || targetValue === "change") && targetData.functionManager.triggerChange) targetData.functionManager.triggerChange();
                        });
                    }
                    break;

                case "fillAddressForm":
                    var address = componentArgs.value;
                    if (address && altValue) {
                        var argsObj = altValue;
                        var addressMainCpt = dataList[commonFunc.camelize((argsObj.addressMainBind || ""), true)];
                        var addressPlusCpt = dataList[commonFunc.camelize((argsObj.addressPlusBind || ""), true)];
                        var pcCpt = dataList[commonFunc.camelize((argsObj.pcBind || ""), true)];
                        var cityCpt = dataList[commonFunc.camelize((argsObj.cityBind || ""), true)];
                        var countryCpt = dataList[commonFunc.camelize((argsObj.countryBind || ""), true)];

                        if (addressMainCpt) addressMainCpt.functionManager.setValue(address.addressMain).then((responseLoad) => {
                            addressMainCpt.functionManager.triggerChange();
                        });
                        if (addressPlusCpt) addressPlusCpt.functionManager.setValue(address.addressPlus ? address.addressPlus : "").then((responseLoad) => {
                            addressPlusCpt.functionManager.triggerChange();
                        });
                        if (pcCpt) pcCpt.functionManager.setValue(address.pc).then((responseLoad) => {
                            pcCpt.functionManager.triggerChange();
                        });
                        if (cityCpt) cityCpt.functionManager.setValue(address.city).then((responseLoad) => {
                            cityCpt.functionManager.triggerChange();
                        });
                        if (countryCpt) countryCpt.functionManager.setValue(address.country).then((responseLoad) => {
                            countryCpt.functionManager.triggerChange();
                        });

                        //SetValue sur addressUnit
                        var addressUnitCpt = dataList[commonFunc.camelize((argsObj.addressUnitBind || ""), true)];
                        if (addressUnitCpt) addressUnitCpt.functionManager.setValue(address).then((responseLoad) => {
                            addressUnitCpt.functionManager.triggerChange();
                        });
                    }
                    break;

                case "manageSvcPrices"://Prospect ADMR
                    //var managerCpt = !commonFunc.isBlank(targetValue) ? dataList[commonFunc.camelize(targetValue, true)] : null;
                    var managerCpt = targetData;
                    if (managerCpt && managerCpt !== componentData) {
                        var srcPricesList = getValues(commonFunc.camelize(managerCpt.bindPropResult, true)) || "[]";
                        srcPricesList = JSON.parse(srcPricesList);

                        var svcID = value;
                        var parentID = altValue;

                        var hours = 0;
                        if (componentData.objType === "checkbox") {
                            var hoursCpt = !commonFunc.isBlank(componentData.bindPropResult + "Hours") ? dataList[commonFunc.camelize(componentData.bindPropResult + "Hours", true)] : null;
                            if (hoursCpt) hours = hoursCpt.functionManager.getValue();

                            if (componentArgs.value) {
                                srcPricesList.push({ id: svcID, extId: parentID, value: "", tag: "", amount: hours });
                                setValue(commonFunc.camelize(managerCpt.bindPropResult, true), JSON.stringify(srcPricesList));
                            }
                            else {
                                setValue(commonFunc.camelize(managerCpt.bindPropResult, true), JSON.stringify(srcPricesList.filter(item => (item.id !== svcID || item.extId !== parentID))));
                            }
                        }
                        else {
                            hours = componentArgs.value;

                            var keyItem = srcPricesList.filter(item => item.id === svcID && item.extId === parentID);
                            if (keyItem?.length) {
                                keyItem[0].amount = hours;
                            }
                            setValue(commonFunc.camelize(managerCpt.bindPropResult, true), JSON.stringify(srcPricesList));
                        }
                    }
                    break;

                case "updateArgs":
                    var selValue = componentArgs ? componentArgs.value : componentData.functionManager.getValue();
                    if (!selValue) selValue = componentData.defaultValue;
                    var isBoolean = false;
                    if (typeof selValue == "boolean") {
                        selValue = value ? (selValue ? value : "") : selValue;
                        isBoolean = true;
                    }
                    if (targetData && targetData.argumentsObj && altValue) {
                        if (Array.isArray(targetData.argumentsObj[altValue])) {
                            if (isBoolean) {
                                if (selValue) {
                                    if (targetValue === "id") {
                                        targetData.argumentsObj[altValue].push({ id: selValue, value: "", tag: "" });
                                    }
                                    else {
                                        targetData.argumentsObj[altValue].push({ id: 0, value: selValue, tag: "" });
                                    }
                                }
                                else {
                                    /*var index = targetData.argumentsObj[altValue].indexOf(value);
                                    if (index >= 0) {
                                        targetData.argumentsObj[altValue].splice(index, 1);
                                    }*/
                                    if (targetValue === "id") {
                                        targetData.argumentsObj[altValue] = targetData.argumentsObj[altValue].filter(keyItem => keyItem.id !== value);
                                    }
                                    else {
                                        targetData.argumentsObj[altValue] = targetData.argumentsObj[altValue].filter(keyItem => keyItem.value !== value);
                                    }
                                }
                            }
                            else {
                                targetData.argumentsObj[altValue] = targetData.argumentsObj[altValue].filter(keyItem => keyItem.tag !== "S");
                                if (targetValue === "id") {
                                    targetData.argumentsObj[altValue].push({ id: selValue, value: "", tag: "S" });
                                }
                                else {
                                    targetData.argumentsObj[altValue].push({ id: 0, value: selValue, tag: "S" });
                                }
                            }
                        }
                        else {
                            targetData.argumentsObj[altValue] = selValue;
                        }
                    }
                    break;
                case "updateGetListArgs":

                    //TODO : CHECK VALIDATE
                    trigger("veilleCustomFilter").then(result => {
                        console.debug(result);
                        console.debug(errors);
                    });
                    console.debug(errors);

                    if (targetData && targetData.functionManager && targetData.functionManager.getGetListCpt) {
                        var selValue2 = componentArgs ? componentArgs.value : "";
                        var isBoolean2 = false;
                        if (typeof selValue2 == "boolean") {
                            selValue2 = value ? (selValue2 ? value : "") : selValue2;
                            isBoolean2 = true;
                        }
                        var getlistItem = targetData.functionManager.getGetListCpt();
                        if (getlistItem && getlistItem.argumentsObj && altValue) {
                            if (Array.isArray(getlistItem.argumentsObj[altValue])) {
                                if (isBoolean2) {
                                    if (selValue2) {
                                        getlistItem.argumentsObj[altValue].push({ id: 0, value: selValue2, tag: "" });
                                    }
                                    else {
                                        /*var index = getlistItem.argumentsObj[altValue].indexOf(value);
                                        if (index >= 0) {
                                            getlistItem.argumentsObj[altValue].splice(index, 1);
                                        }*/
                                        getlistItem.argumentsObj[altValue] = getlistItem.argumentsObj[altValue].filter(keyItem => keyItem.value !== value);
                                    }
                                }
                                else {
                                    getlistItem.argumentsObj[altValue] = getlistItem.argumentsObj[altValue].filter(keyItem => keyItem.tag !== "S");
                                    getlistItem.argumentsObj[altValue].push({ id: 0, value: selValue2, tag: "S" });
                                }
                            }
                            else {
                                getlistItem.argumentsObj[altValue] = selValue2;
                            }
                        }
                        if (targetValue && targetData.functionManager.refreshList) {
                            targetData.functionManager.refreshList();
                        }
                    }
                    break;
                case "updateDataStamp":
                    if (targetData.functionManager.updateDataStamp) targetData.functionManager.updateDataStamp();
                    break;
                case "updateAgreementsFilter":

                    /*App.getUser((user) => {
                        if (user.isSuccess) {*/
                    var userAgreements = getUser();//primaryGroupId
                    if (userAgreements.primaryGroupId === 2) {
                        commonFunc.getMethod("../api/client/GetClient", { id: userAgreements.matchID, level: 2 }).then((response) => {
                            var data = response.data;
                            if (data.isSuccess) {
                                console.debug(data);

                                var agreementSubscriptions = "";//"QSA;ENV;SST;NAL;SPE;INF";//TEMP
                                if (data.result.agreements && data.result.agreements.length) {
                                    agreementSubscriptions = data.result.agreements[0].comments;
                                }

                                var splitSubs = agreementSubscriptions.split(";");
                                splitSubs.forEach((e, i) => {
                                    onActionRequired(tag, { trigger: "showElement", target: (target + e + "Filter"), operatorTest: "=", value: 0, altValue: 0 }, componentData, componentArgs).then((responseLoad) => {
                                        //responseLoad
                                    });
                                });
                                responseAction.isSuccess = true;
                                responseAction.result = true;
                            }
                            else {
                                responseAction.isSuccess = false;
                                responseAction.errorMessage = "Echec de récupération des informations client : " + value;
                                responseAction.result = "";
                            }
                            resolve(responseAction);
                        });
                    }
                    else {
                        var agreementSubscriptions = "QSA;ENV;SST;NAL;SPE;INF";//TEMP
                        var splitSubs = agreementSubscriptions.split(";");
                        splitSubs.forEach((e, i) => {
                            onActionRequired(tag, { trigger: "showElement", target: (target + e + "Filter"), operatorTest: "=", value: 0, altValue: 0 }, componentData, componentArgs).then((responseLoad) => {
                                //responseLoad
                            });
                        });

                        responseAction.isSuccess = true;
                        responseAction.result = true;
                        resolve(responseAction);
                    }
                    /*}
                    else {
                        responseAction.isSuccess = false;
                        responseAction.errorMessage = "Impossible de récupérer le user";
                        responseAction.result = "";
                        resolve(responseAction);
                    }
                })*/





                    break;
                case "moveEndDate":
                    if (targetData && targetData.functionManager && targetData.functionManager.setValue) {
                        var startDateComponent = !commonFunc.isBlank(value) ? dataList[commonFunc.camelize(value, true)] : componentData;
                        var lengthComponent = !commonFunc.isBlank(altValue) ? dataList[commonFunc.camelize(altValue, true)] : null;

                        var startDate = getValues(commonFunc.camelize(startDateComponent.bindPropResult, true));
                        var length = getValues(commonFunc.camelize(lengthComponent.bindPropResult, true));

                        var endDate = commonFunc.addMinutes(startDate, length * 60);
                        var formatEndDate = moment(endDate).format("YYYY-MM-DDTHH:mm:ss");

                        targetData.functionManager.setValue(formatEndDate).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;
                case "calcEndHour":
                    if (targetData && targetData.functionManager && targetData.functionManager.setValue) {
                        var startDateComponent2 = !commonFunc.isBlank(value) ? dataList[commonFunc.camelize(value, true)] : componentData;
                        var lengthComponent2 = !commonFunc.isBlank(altValue) ? dataList[commonFunc.camelize(altValue, true)] : null;

                        //var startDate = getValues(commonFunc.camelize(startDateComponent2.bindPropResult, true));
                        var startDate2 = startDateComponent2.rawValue;
                        var length2 = getValues(commonFunc.camelize(lengthComponent2.bindPropResult, true));

                        if (startDate2 && (length2 || length2 === 0)) {
                            var endDate2 = commonFunc.addMinutes(startDate2, length2 * 60);
                            //var formatEndDate2 = moment(endDate2).format("YYYY-MM-DDTHH:mm:ss");

                            targetData.functionManager.setValue(endDate2).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;
                case "loadConcatValue":
                    var currTargetValue = getValues(commonFunc.camelize(targetData.bindPropResult, true)) || 0;

                    if (loadedData && loadedData[commonFunc.camelize(targetData.bindPropResult, true)]) currTargetValue = loadedData[commonFunc.camelize(targetData.bindPropResult, true)];

                    var childsList = [];
                    componentData.children.forEach((child) => {
                        if (child.onActionEvents && child.onActionEvents.onChange) {
                            var concatChild = child.onActionEvents.onChange.filter((event) => event.trigger.startsWith("concatValue"));
                            if (concatChild.length) {
                                concatChild[0].bindPropResult = child.bindPropResult;
                                childsList.push(concatChild[0]);
                            }
                        }
                    });
                    if (childsList.length) {
                        childsList.sort((a, b) => b.value - a.value);

                        var localValue = currTargetValue;
                        childsList.forEach((child) => {
                            var modValue = (localValue % child.value) || 0;
                            if (modValue !== localValue) {
                                localValue = modValue;
                                var childTarget = dataList[commonFunc.camelize(child.bindPropResult, true)];
                                if (childTarget && childTarget.functionManager) {
                                    childTarget.functionManager.setValue(true).then((responseLoad) => {

                                        //Load OK
                                    });
                                }
                                else {
                                    childTarget.defaultValue = true;
                                }
                            }
                        });
                    }
                    break;
                case "updConcatValue":
                    if (targetData && targetData.functionManager && targetData.functionManager.setValue) {

                        var concatValueUpd = 0;
                        componentData.children.forEach((child) => {
                            if (child.onActionEvents && child.onActionEvents.onChange) {
                                var concatChild = child.onActionEvents.onChange.filter((event) => event.trigger === "concatValue");
                                if (concatChild.length) {
                                    var childValue = getValues(commonFunc.camelize(child.bindPropResult, true)) || 0;
                                    if (childValue) {
                                        concatValueUpd += concatChild[0].value;
                                    }
                                }
                            }
                        });
                        targetData.functionManager.setValue(concatValueUpd).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;
                case "updCountValue":
                    if (targetData && targetData.functionManager && targetData.functionManager.setValue) {

                        var countValueUpd = 0;
                        componentData.children.forEach((child) => {
                            if (child.objType === "checkbox") {
                                var childValue = getValues(commonFunc.camelize(child.bindPropResult, true)) || 0;
                                if (childValue) {
                                    countValueUpd += 1;
                                }
                            }
                        });
                        targetData.functionManager.setValue(countValueUpd || 1).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;
                case "concatValueAlt":
                    if (targetData && targetData.functionManager && targetData.functionManager.setValue) {

                        var currTargetValue2 = getValues(commonFunc.camelize(targetData.bindPropResult, true)) || 0;
                        if (componentArgs.value === true) {
                            currTargetValue2 += value;
                        }
                        else {
                            currTargetValue2 -= value;
                        }
                        targetData.functionManager.setValue(currTargetValue2).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;
                case "resetFields":
                    if (targetValue) {
                        var cptValue = altValue || componentArgs?.value || (componentData.functionManager?.getValue ? componentData.functionManager?.getValue() : componentData.defaultValue);

                        if (cptValue && targetValue[cptValue]) {
                            //Champs 1:idx >> Reset à faire en priorité
                            if (targetValue[cptValue]["1:idx"]) {
                                targetValue[cptValue] = { ...targetValue[cptValue]["1:idx"], ...targetValue[cptValue] }
                                delete targetValue[cptValue]["1:idx"];
                            }
                            //Parcours des champs pour la valeur donnée
                            Object.keys(targetValue[cptValue]).forEach((key) => {
                                var camKey = commonFunc.camelize(key, true);
                                var resetValue = targetValue[cptValue][key];
                                var targetCpt = (!commonFunc.isBlank(key) ? dataList[camKey] : null);
                                var objectToReset;
                                if (!resetValue && targetCpt?.functionManager?.reset) {
                                    targetCpt?.functionManager?.reset();
                                }
                                else if (targetCpt?.functionManager?.setValue) {
                                    //Reset de l'objet non défini
                                    if (JSON.stringify(resetValue) === "{}") {
                                        objectToReset = getValues(camKey);
                                        var preventObjectReset = false;
                                        if (objectToReset) {
                                            Object.keys(objectToReset).forEach((subKey) => {
                                                var subTargetCpt = (!commonFunc.isBlank(key) ? dataList[camKey + "." + commonFunc.camelize(subKey, true)] : null);
                                                if (subTargetCpt && subTargetCpt.objType !== "textview") {
                                                    if (subTargetCpt.functionManager?.setValue) {
                                                        //var dv = (subTargetCpt.defaultValue !== null && subTargetCpt.defaultValue !== undefined) ? subTargetCpt.defaultValue : "";
                                                        var mdv = (subTargetCpt.modalDefaultValue !== null && subTargetCpt.modalDefaultValue !== undefined) ? subTargetCpt.modalDefaultValue : (subTargetCpt.propNameJsType === "number" ? 0 : "")/*dv*/;
                                                        subTargetCpt.functionManager.setValue(mdv).then((responseLoad) => {
                                                            if ((triggerObj.contextType === "change" || targetValue === "change") && subTargetCpt.functionManager.triggerChange) subTargetCpt.functionManager.triggerChange();
                                                        });
                                                    }
                                                    else {
                                                        setValue(camKey + "." + commonFunc.camelize(subKey, true), (commonFunc.camelize(subKey, true) === "address" ? {} : ""));
                                                    }
                                                }
                                                else {
                                                    preventObjectReset = true;
                                                }
                                            });
                                        }
                                        if(!preventObjectReset) {
                                            targetCpt.functionManager.setValue(resetValue).then((responseLoad) => {
                                                if ((triggerObj.contextType === "change" || targetValue === "change") && targetCpt.functionManager.triggerChange) targetCpt.functionManager.triggerChange();
                                            });
                                        }
                                    }
                                    else {
                                        targetCpt.functionManager.setValue(resetValue).then((responseLoad) => {
                                            if ((triggerObj.contextType === "change" || targetValue === "change") && targetCpt.functionManager.triggerChange) targetCpt.functionManager.triggerChange();
                                        });
                                    }
                                }
                                else {
                                    //Reset d'une liste tiré d'un groupe
                                    if (targetCpt?.objType === "group" && JSON.stringify(resetValue) === "[]") {
                                        if (targetCpt.functionManager?.getParent && targetCpt.functionManager.getParent()) {
                                            var header = targetCpt.functionManager.getParent();
                                            header.groups = header.groups?.filter((group) => !group.temporary);
                                            header.functionManager.rerender();
                                        }
                                    }
                                    //Reset de l'objet non défini
                                    if (JSON.stringify(resetValue) === "{}") {
                                        objectToReset = getValues(camKey);
                                        if (objectToReset) {
                                            Object.keys(objectToReset).forEach((subKey) => {
                                                var subTargetCpt = (!commonFunc.isBlank(key) ? dataList[camKey + "." + commonFunc.camelize(subKey, true)] : null);
                                                if (subTargetCpt && subTargetCpt.objType !== "textview") {
                                                    if (subTargetCpt.functionManager?.setValue) {
                                                        //var dv = (subTargetCpt.defaultValue !== null && subTargetCpt.defaultValue !== undefined) ? subTargetCpt.defaultValue : "";
                                                        var mdv = (subTargetCpt.modalDefaultValue !== null && subTargetCpt.modalDefaultValue !== undefined) ? subTargetCpt.modalDefaultValue : (subTargetCpt.propNameJsType === "number" ? 0 : "")/*dv*/;
                                                        subTargetCpt.functionManager.setValue(mdv).then((responseLoad) => {
                                                            if ((triggerObj.contextType === "change" || targetValue === "change") && subTargetCpt.functionManager.triggerChange) subTargetCpt.functionManager.triggerChange();
                                                        });
                                                    }
                                                    else {
                                                        setValue(camKey + "." + commonFunc.camelize(subKey, true), (commonFunc.camelize(subKey, true) === "address" ? {} : ""));
                                                    }
                                                }
                                            });
                                        }
                                    }
                                    else {
                                        setValue(commonFunc.camelize(key, true), resetValue);
                                    }
                                }
                            });

                            responseAction.isSuccess = true;
                            responseAction.result = true;
                            resolve(responseAction);
                        }
                    }
                    break;
                case "resetElement":
                    if (targetData?.functionManager?.reset) {
                        targetData?.functionManager?.reset();

                        responseAction.isSuccess = true;
                        responseAction.result = true;
                        resolve(responseAction);
                    }
                    break;

                case "clearModal":
                    if (targetData && targetData.functionManager && targetData.functionManager.clearModal) {
                        targetData.functionManager.clearModal().then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'effectuer cette action";
                        resolve(responseAction);
                    }
                    break;

                case "manageRadioChild":
                    if (targetData) {
                        var cBindR = commonFunc.camelize(targetData.bindPropResult, true);
                        //var cCurrValue = componentData.functionManager.getValue();
                        var cCurrValueR = componentArgs.value;
                        if (cCurrValueR === parseInt(value)) {
                            var cTargetValueR = targetData.functionManager.getValue();
                            setValue(cBindR, cTargetValueR);
                        }
                        else {
                            setValue(cBindR, 0);
                        }
                    }
                    break;

                case "manageClientID":
                    if (targetData) {
                        var cSubTargetName = dataList[commonFunc.camelize("Client.Name", true)];
                        var cSubTargetFN = dataList[commonFunc.camelize("Client.FirstName", true)];
                        var cSubTargetC = dataList[commonFunc.camelize("Client.Compagny", true)];

                        var cBind = commonFunc.camelize(targetData.bindPropResult, true);
                        //var cCurrValue = componentData.functionManager.getValue();
                        var cCurrValue = componentArgs.value;
                        //console.debug(cCurrValue);
                        //console.debug(value);
                        if (cCurrValue === parseInt(value)) {
                            var cTargetValue = targetData.functionManager.getValue();
                            var selectedOption = targetData.functionManager.getSelectedOption ? targetData.functionManager.getSelectedOption(cTargetValue) : null;
                            setValue(cBind, cTargetValue);

                            var name = selectedOption ? selectedOption.title.split(" ")[0] : "none";
                            var fName = selectedOption ? selectedOption.title.split(" ")[1] : "none";
                            var compagny = selectedOption ? selectedOption.title.split(" ")[selectedOption.title.split(" ").length - 1] : "none";

                            if (selectedOption?.srcData) {
                                name = selectedOption.srcData.name;
                                fName = selectedOption.srcData.firstName;
                                compagny = selectedOption.srcData.compagny;
                            }

                            if (cSubTargetName) {
                                cSubTargetName.hidden = true;
                                setValue(commonFunc.camelize("Client.Name", true), !commonFunc.isBlank(name) ? name : "none");
                                cSubTargetName.functionManager.rerender();
                            }
                            if (cSubTargetFN) {
                                cSubTargetFN.hidden = true;
                                setValue(commonFunc.camelize("Client.FirstName", true), !commonFunc.isBlank(fName) ? fName : "none");
                                cSubTargetFN.functionManager.rerender();
                            }
                            if (cSubTargetC) {
                                cSubTargetC.hidden = true;
                                setValue(commonFunc.camelize("Client.Compagny", true), !commonFunc.isBlank(compagny) ? compagny : "none");
                                cSubTargetC.functionManager.rerender();
                            }

                            if (selectedOption?.srcData?.address) {//Il manque des informations pour les charger dans adresse (ex actuellement : location = LAVAL 53)
                                setValue(commonFunc.camelize("Address.AddressMain", true), selectedOption.srcData.address.addressMain);
                                setValue(commonFunc.camelize("Address.AddressPlus", true), selectedOption.srcData.address.addressPlus);
                                setValue(commonFunc.camelize("Address.AddressPlus2", true), selectedOption.srcData.address.addressPlus2);
                                setValue(commonFunc.camelize("Address.Country", true), selectedOption.srcData.address.country);
                                setValue(commonFunc.camelize("Address.PC", true), selectedOption.srcData.address.pc);
                                setValue(commonFunc.camelize("Address.City", true), selectedOption.srcData.address.city);

                                setValue(commonFunc.camelize("BillAddress.AddressMain", true), selectedOption.srcData.billingAddress.addressMain || selectedOption.srcData.address.addressMain);
                                setValue(commonFunc.camelize("BillAddress.AddressPlus", true), selectedOption.srcData.billingAddress.addressPlus || selectedOption.srcData.address.addressPlus);
                                setValue(commonFunc.camelize("BillAddress.AddressPlus2", true), selectedOption.srcData.billingAddress.addressPlus2 || selectedOption.srcData.address.addressPlus2);
                                setValue(commonFunc.camelize("BillAddress.Country", true), selectedOption.srcData.billingAddress.country || selectedOption.srcData.address.country);
                                setValue(commonFunc.camelize("BillAddress.PC", true), selectedOption.srcData.billingAddress.pc || selectedOption.srcData.address.pc);
                                setValue(commonFunc.camelize("BillAddress.City", true), selectedOption.srcData.billingAddress.city || selectedOption.srcData.address.city);

                                dataList[commonFunc.camelize("Address.AddressMain", true)]?.functionManager.rerender();
                                dataList[commonFunc.camelize("Address.AddressPlus", true)]?.functionManager.rerender();
                                dataList[commonFunc.camelize("Address.AddressPlus2", true)]?.functionManager.rerender();
                                dataList[commonFunc.camelize("Address.Country", true)]?.functionManager.rerender();
                                dataList[commonFunc.camelize("Address.PC", true)]?.functionManager.rerender();
                                dataList[commonFunc.camelize("Address.City", true)]?.functionManager.rerender();

                                dataList[commonFunc.camelize("BillAddress.AddressMain", true)]?.functionManager.rerender();
                                dataList[commonFunc.camelize("BillAddress.AddressPlus", true)]?.functionManager.rerender();
                                dataList[commonFunc.camelize("BillAddress.AddressPlus2", true)]?.functionManager.rerender();
                                dataList[commonFunc.camelize("BillAddress.Country", true)]?.functionManager.rerender();
                                dataList[commonFunc.camelize("BillAddress.PC", true)]?.functionManager.rerender();
                                dataList[commonFunc.camelize("BillAddress.City", true)]?.functionManager.rerender();
                            }
                        }
                        else {
                            setValue(cBind, 0);
                            if (cSubTargetName) {
                                cSubTargetName.hidden = false;
                                setValue(commonFunc.camelize("Client.Name", true), "");
                                cSubTargetName.functionManager.rerender();
                            }
                            if (cSubTargetFN) {
                                cSubTargetFN.hidden = false;
                                setValue(commonFunc.camelize("Client.FirstName", true), "");
                                cSubTargetFN.functionManager.rerender();
                            }
                            if (cSubTargetC) {
                                cSubTargetC.hidden = false;
                                setValue(commonFunc.camelize("Client.Compagny", true), "");
                                cSubTargetC.functionManager.rerender();
                            }
                        }
                    }
                    break;
                case "updateClientID":
                    if (targetData) {
                        var cSubTargetName2 = dataList[commonFunc.camelize("Client.Name", true)];
                        var cSubTargetFN2 = dataList[commonFunc.camelize("Client.FirstName", true)];
                        var cSubTargetC2 = dataList[commonFunc.camelize("Client.Compagny", true)];

                        var cCurrValue2 = componentArgs.value || targetData.functionManager.getValue();
                        var selectedOption2 = targetData.functionManager.getSelectedOption ? targetData.functionManager.getSelectedOption(cCurrValue2) : null;

                        var name2 = selectedOption2 ? selectedOption2.title.split(" ")[0] : "";
                        var fName2 = selectedOption2 ? selectedOption2.title.split(" ")[1] : "";
                        var compagny2 = selectedOption2 ? selectedOption2.title.split(" ")[selectedOption2.title.split(" ").length - 1] : "";

                        if (selectedOption2?.srcData) {
                            name2 = selectedOption2.srcData.name;
                            fName2 = selectedOption2.srcData.firstName;
                            compagny2 = selectedOption2.srcData.compagny;
                        }

                        if (cSubTargetName2?.hidden) {
                            setValue(commonFunc.camelize("Client.Name", true), name2);
                        }
                        if (cSubTargetFN2?.hidden) {
                            setValue(commonFunc.camelize("Client.FirstName", true), !commonFunc.isBlank(fName2) ? fName2 : "none");//Foireux
                        }
                        if (cSubTargetC2?.hidden) {
                            setValue(commonFunc.camelize("Client.Compagny", true), !commonFunc.isBlank(compagny2) ? compagny2 : "none");//Foireux
                        }


                        if (selectedOption2?.srcData?.address) {//Il manque des informations pour les charger dans adresse (ex actuellement : location = LAVAL 53)
                            setValue(commonFunc.camelize("Address.AddressMain", true), selectedOption2.srcData.address.addressMain);
                            setValue(commonFunc.camelize("Address.AddressPlus", true), selectedOption2.srcData.address.addressPlus);
                            setValue(commonFunc.camelize("Address.AddressPlus2", true), selectedOption2.srcData.address.addressPlus2);
                            setValue(commonFunc.camelize("Address.Country", true), selectedOption2.srcData.address.country);
                            setValue(commonFunc.camelize("Address.PC", true), selectedOption2.srcData.address.pc);
                            setValue(commonFunc.camelize("Address.City", true), selectedOption2.srcData.address.city);

                            setValue(commonFunc.camelize("BillAddress.AddressMain", true), selectedOption2.srcData.billingAddress.addressMain || selectedOption2.srcData.address.addressMain);
                            setValue(commonFunc.camelize("BillAddress.AddressPlus", true), selectedOption2.srcData.billingAddress.addressPlus || selectedOption2.srcData.address.addressPlus);
                            setValue(commonFunc.camelize("BillAddress.AddressPlus2", true), selectedOption2.srcData.billingAddress.addressPlus2 || selectedOption2.srcData.address.addressPlus2);
                            setValue(commonFunc.camelize("BillAddress.Country", true), selectedOption2.srcData.billingAddress.country || selectedOption2.srcData.address.country);
                            setValue(commonFunc.camelize("BillAddress.PC", true), selectedOption2.srcData.billingAddress.pc || selectedOption2.srcData.address.pc);
                            setValue(commonFunc.camelize("BillAddress.City", true), selectedOption2.srcData.billingAddress.city || selectedOption2.srcData.address.city);

                            dataList[commonFunc.camelize("Address.AddressMain", true)]?.functionManager.rerender();
                            dataList[commonFunc.camelize("Address.AddressPlus", true)]?.functionManager.rerender();
                            dataList[commonFunc.camelize("Address.AddressPlus2", true)]?.functionManager.rerender();
                            dataList[commonFunc.camelize("Address.Country", true)]?.functionManager.rerender();
                            dataList[commonFunc.camelize("Address.PC", true)]?.functionManager.rerender();
                            dataList[commonFunc.camelize("Address.City", true)]?.functionManager.rerender();

                            dataList[commonFunc.camelize("BillAddress.AddressMain", true)]?.functionManager.rerender();
                            dataList[commonFunc.camelize("BillAddress.AddressPlus", true)]?.functionManager.rerender();
                            dataList[commonFunc.camelize("BillAddress.AddressPlus2", true)]?.functionManager.rerender();
                            dataList[commonFunc.camelize("BillAddress.Country", true)]?.functionManager.rerender();
                            dataList[commonFunc.camelize("BillAddress.PC", true)]?.functionManager.rerender();
                            dataList[commonFunc.camelize("BillAddress.City", true)]?.functionManager.rerender();
                        }
                    }
                    break;


                case "loadInsurances":
                    //TODO : charger via la table de partenaires (Providers)
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        if (parentProps.dataCfg && parentProps.dataCfg.customList) {
                            var insurancesList = parentProps.dataCfg.customList.filter((item) => item.Type === 1);
                            if (insurancesList.length) {


                                var newOptionsInsu = insurancesList.map((item) => {
                                    return { title: item.Name, value: item.Name, srcData: item };
                                });
                                targetData.functionManager.populateData(newOptionsInsu, false).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });
                            }
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données assurances";
                        resolve(responseAction);
                    }
                    break;
                case "loadFilePackages":
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        if (modelsList && Object.keys(modelsList).length) {
                            var newOptionsFP = [{ title: "Aucun", value: -1 }];
                            Object.keys(modelsList).forEach((key) => {
                                var item = modelsList[key];
                                if (item && item.Category && item.Category.endsWith("GENDOC") && item.Name.startsWith("HTML_GENDOC_")) {//PATCH (item.Name.startsWith("HTML_GENDOC_")) pour exclure HTML_BASE
                                    if (!item.Name) item.Name = "";
                                    newOptionsFP.push({ title: item.Name, value: item.Name.startsWith("HTML_GENDOC_") ? item.Name.replace("HTML_GENDOC_", "") : 0, srcData: item });
                                }
                            });
                            targetData.functionManager.populateData(newOptionsFP, false).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données documents";
                        resolve(responseAction);
                    }
                    break;
                case "changeReportFilePackage":
                    if (componentData && componentData.functionManager && componentData.functionManager.findItem && targetData && targetData.functionManager && targetData.functionManager.setValue) {

                        var option = componentData.functionManager.findItem(componentArgs.value);
                        if (option && option.length && option[0].srcData) {
                            targetData.functionManager.setValue(option[0].srcData.Template).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;


                case "loadContactTypes":
                    //TODO : charger différemment ??
                    if (targetData && targetData.functionManager && targetData.functionManager.populateData) {
                        if (parentProps.dataCfg && parentProps.dataCfg.contactTypes) {
                            var newOptionsCT = parentProps.dataCfg.contactTypes.map((item) => {
                                return { title: item.ContactType, value: item.ContactType, selected: item.IsDefault, srcData: item };
                            });
                            targetData.functionManager.populateData(newOptionsCT, false).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible de charger les données contacts";
                        resolve(responseAction);
                    }
                    break;


                case "loadMCycleID"://DEMAND Client
                    if (loadedData) {
                        var cNewValue2 /*= loadedData.value*/;

                        if (loadedData.constraintDmd === 126) {
                            if (loadedData.includeSpecDays) cNewValue2 = 3;
                            else cNewValue2 = 2;
                        }
                        else {
                            cNewValue2 = 1;
                        }


                        targetData.functionManager.setValue(cNewValue2).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    break;
                case "loadFromStep"://DEMAND Client
                    if (loadedData?.stepDmd || loadedData?.stepDmd === 0) {
                        targetData.functionManager.setValue(loadedData.stepDmd).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    break;
                case "loadMConstraint"://DEMAND Client
                    if (loadedData?.constraintDmd !== 16384 && loadedData?.typeDmd === "M") {
                        targetData.functionManager.setValue(2, true).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    break;
                case "loadFromConstraintDmd"://DEMAND Client
                    if (loadedData?.typeDmd === "M") {
                        //console.debug(loadedData.constraintDmd);
                        targetData.functionManager.setValue(loadedData.constraintDmd).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    break;
                case "loadCycleIdx"://DEMAND Client
                    if (loadedData?.constraintIdx && loadedData?.constraintDmd !== 16384 && loadedData?.typeDmd === "M") {
                        //console.debug(loadedData.constraintIdx);
                        targetData.functionManager.setValue(loadedData.constraintIdx).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    break;
                case "loadIdx"://DEMAND Client
                    if (loadedData?.constraintIdx && loadedData?.constraintDmd === 16384 && loadedData?.typeDmd === "M") {
                        targetData.functionManager.setValue(loadedData.constraintIdx).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    break;

                case "copyField":
                    var mainData = dataList[commonFunc.camelize(value, true)];
                    var currTargetData = dataList[commonFunc.camelize(altValue, true)];

                    var flagDBA = (!targetValue || targetValue != componentArgs.value);
                    var changeEvents;
                    if (mainData?.onActionEvents) {
                        changeEvents = mainData.onActionEvents?.onChange?.filter((actionEvent) => (actionEvent.trigger === "setValue" || actionEvent.trigger === "setValue2") && (!altValue || actionEvent.target?.indexOf(altValue) >= 0));
                        changeEvents.forEach(event => event.trigger = (flagDBA ? "setValue2" : "setValue"));

                        if (mainData.functionManager?.getValue && mainData.functionManager.getValue() && currTargetData?.functionManager?.setValue) {
                            currTargetData.functionManager.setValue(mainData.functionManager.getValue()).then((responseLoad) => {
                                responseAction = responseLoad;
                                resolve(responseAction);

                                if ((triggerObj.contextType === "change" || targetValue === "change") && currTargetData.functionManager.triggerChange) currTargetData.functionManager.triggerChange();
                            });
                        }
                    }

                    /*var grpDataAlt = dataList[commonFunc.camelize(altValue, true)];
                    if (grpDataAlt) {
                        if (!targetValue) {
                            componentData.hidden = true;
                            if (componentData.functionManager && componentData.functionManager.rerender) componentData.functionManager.rerender();
                        }

                        grpDataAlt.hidden = !flagDBA;
                        if (grpDataAlt.functionManager && grpDataAlt.functionManager.rerender) grpDataAlt.functionManager.rerender();
                    }*/

                    break;

                case "diffBillAddress":
                    //value = Address
                    //altValue = BillAddress

                    var mainData = dataList[commonFunc.camelize(value, true) + ".addressMain"];
                    var ads2Data = dataList[commonFunc.camelize(value, true) + ".addressPlus"];
                    var ads3Data = dataList[commonFunc.camelize(value, true) + ".addressPlus2"];
                    var countryData = dataList[commonFunc.camelize(value, true) + ".country"];
                    var pcData = dataList[commonFunc.camelize(value, true) + ".pc"];
                    var cityData = dataList[commonFunc.camelize(value, true) + ".city"];

                    var flagDBA = (!targetValue || targetValue != componentArgs.value);
                    var changeEvents;
                    if (mainData?.onActionEvents) {
                        changeEvents = mainData.onActionEvents?.onChange?.filter((actionEvent) => (actionEvent.trigger === "setValue" || actionEvent.trigger === "setValue2") && (!altValue || actionEvent.target?.indexOf(altValue) >= 0));
                        changeEvents.forEach(event => event.trigger = (flagDBA ? "setValue2" : "setValue"));
                    }
                    if (ads2Data?.onActionEvents) {
                        changeEvents = ads2Data.onActionEvents?.onChange?.filter((actionEvent) => (actionEvent.trigger === "setValue" || actionEvent.trigger === "setValue2") && (!altValue || actionEvent.target?.indexOf(altValue) >= 0));
                        changeEvents.forEach(event => event.trigger = (flagDBA ? "setValue2" : "setValue"));
                    }
                    if (ads3Data?.onActionEvents) {
                        changeEvents = ads3Data.onActionEvents?.onChange?.filter((actionEvent) => (actionEvent.trigger === "setValue" || actionEvent.trigger === "setValue2") && (!altValue || actionEvent.target?.indexOf(altValue) >= 0));
                        changeEvents.forEach(event => event.trigger = (flagDBA ? "setValue2" : "setValue"));
                    }
                    if (countryData?.onActionEvents) {
                        changeEvents = countryData.onActionEvents?.onChange?.filter((actionEvent) => (actionEvent.trigger === "setValue" || actionEvent.trigger === "setValue2") && (!altValue || actionEvent.target?.indexOf(altValue) >= 0));
                        changeEvents.forEach(event => event.trigger = (flagDBA ? "setValue2" : "setValue"));
                    }
                    if (pcData?.onActionEvents) {
                        changeEvents = pcData.onActionEvents?.onChange?.filter((actionEvent) => (actionEvent.trigger === "setValue" || actionEvent.trigger === "setValue2") && (!altValue || actionEvent.target?.indexOf(altValue) >= 0));
                        changeEvents.forEach(event => event.trigger = (flagDBA ? "setValue2" : "setValue"));
                    }
                    if (cityData?.onActionEvents) {
                        changeEvents = cityData.onActionEvents?.onChange?.filter((actionEvent) => (actionEvent.trigger === "setValue" || actionEvent.trigger === "setValue2") && (!altValue || actionEvent.target?.indexOf(altValue) >= 0));
                        changeEvents.forEach(event => event.trigger = (flagDBA ? "setValue2" : "setValue"));
                    }

                    var grpDataAlt = dataList[commonFunc.camelize(altValue, true)];
                    if (grpDataAlt) {
                        if (!targetValue) {
                            componentData.hidden = true;
                            if (componentData.functionManager && componentData.functionManager.rerender) componentData.functionManager.rerender();
                        }

                        grpDataAlt.hidden = !flagDBA;
                        if (grpDataAlt.functionManager && grpDataAlt.functionManager.rerender) grpDataAlt.functionManager.rerender();
                    }
                    break;
                case "refAuto":
                    if (targetData && targetData.functionManager && targetData.functionManager.setValue) {
                        var valueRef = "";

                        if (targetData.onActionEvents && targetData.onActionEvents.extrasActionEvent && targetData.onActionEvents.extrasActionEvent[value]) {
                            targetData.onActionEvents.extrasActionEvent[value].forEach((actionTargetEvent) => {
                                var altData = dataList[commonFunc.camelize(actionTargetEvent.target, true)];
                                if (altData && altData.functionManager) {
                                    var valueTarget = actionTargetEvent.target === componentData.bindPropResult ? componentArgs.value : (altData.functionManager.getValue() || getValues(commonFunc.camelize(actionTargetEvent.target, true)) || altData.defaultValue);
                                    if (valueTarget && actionTargetEvent.max > 0) {
                                        valueTarget = valueTarget.toString();
                                        if (actionTargetEvent.target.endsWith("PC")) {
                                            valueRef += valueTarget.substring(0, (actionTargetEvent.max || 2));
                                        }
                                        else if (actionTargetEvent.target.endsWith("City")) {
                                            valueRef += valueTarget.substring(0, (actionTargetEvent.max || 8)) + "-";
                                        }
                                        else {
                                            valueRef += valueTarget.substring(0, (actionTargetEvent.max || 8));
                                        }
                                    }
                                }
                            });
                            valueRef = valueRef.replace(/\//g, "").replace(/'/g, "").replace(/"/g, "");
                        }

                        targetData.functionManager.setValue(valueRef.toUpperCase(), componentArgs?.withRerender).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur : Erreur configuration";
                        resolve(responseAction);
                    }
                    break;
                case "lockRefAuto":
                    if (!commonFunc.isBlank(value) && componentData.onActionEvents && componentData.onActionEvents.extrasActionEvent && componentData.onActionEvents.extrasActionEvent[value] && componentData.onActionEvents.extrasActionEvent[value].length > 0) {
                        componentData.onActionEvents.extrasActionEvent[value].forEach((actionTargetEvent) => {
                            var altData = dataList[commonFunc.camelize(actionTargetEvent.target, true)];
                            if (altData) altData.onActionEvents.onChange = altData.onActionEvents.onChange.filter((actionEvent) => actionEvent.trigger !== actionTargetEvent.value);
                        });
                    }
                    break;

                case "changeReportTemplate"://TODO ???
                    break;
                case "changeReportCategory":
                    if (dataCache[targetCache]) {

                        var serviceCRC = dataCache[targetCache].filter((svc) => {
                            return svc.idService === parseInt(componentArgs.value);
                        });
                        if (serviceCRC.length /*&& serviceCRC[0].templates*/) {
                            if (targetData && targetData.functionManager && targetData.functionManager.setValue) {
                                targetData.functionManager.setValue(serviceCRC[0].reportCategoryID, componentArgs.withRerender).then((responseLoad) => {
                                    responseAction = responseLoad;
                                    resolve(responseAction);
                                });
                            }
                            else {
                                responseAction.errorMessage = "Impossible d'affecter la valeur : Erreur configuration";
                                resolve(responseAction);
                            }
                        }
                        else {
                            responseAction.errorMessage = "Impossible d'affecter la valeur : Aucun modèle";
                            resolve(responseAction);
                        }

                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur : Erreur cache";
                        resolve(responseAction);
                    }
                    break;
                case "changeForm":
                    //TODO : gestion country des adresses

                    break;

                case "sendPlanItv":
                    var argsSend = {};
                    if (componentArgs && Object.keys(componentArgs).length) {
                        Object.keys(componentArgs).forEach((key) => {
                            var valueArgs = componentArgs[key];
                            if (valueArgs?.startsWith && valueArgs.startsWith("prop:")) argsSend[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                            else argsSend[key] = valueArgs;
                        });
                    }

                    var sendProcess = () => {
                        sendReport(argsSend, { translation: t }).then((response) => {//202
                            if (response.isSuccess) {
                                if (parentProps.loadList) {
                                    //Si besoin d'afficher le rapport après envoi
                                    if (componentArgs.showReport) {
                                        parentProps.loadList(argsSend.id, argsSend.newStatus);
                                    }
                                    else {
                                        parentProps.loadList(argsSend.id);
                                    }
                                }
                            }
                            responseAction = response.data;
                            resolve(responseAction);
                        });
                    };

                    if (argsSend.id) {
                        Swal.fire({
                            title: 'Préparation...',
                            didOpen: () => { Swal.showLoading() },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                        });

                        sendProcess();
                        /*commonFunc.getMethod("../api/report/GetReportModel", argsSend).then((response) => {
                            Swal.close();
                            var data = response.data;
                            if (data.isSuccess) {
                                sendProcess();
                            }
                            else if (data.errorCode === 404) {
                                Swal.fire({
                                    title: 'Enregistrement en cours...',
                                    didOpen: () => { Swal.showLoading() },
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    allowEnterKey: false,
                                });
                                commonFunc.postMethod("../api/report/AddReportModel", argsSend).then((response) => {
                                    Swal.close();
                                    if (response.data && response.data.isSuccess) {
                                        sendProcess();
                                    } else {
                                        Swal.fire({
                                            icon: "error",
                                            title: "Echec",
                                            html: "Echec de préparation<br/>" + response.data.errorMessage
                                        });
                                    }
                                    responseAction = response.data;
                                    resolve(responseAction);
                                });
                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Echec",
                                    html: "Echec d'envoi sur la tablette<br/>" + data.errorMessage
                                });
                                responseAction = data;
                                resolve(responseAction);
                            }
                        });*/
                    }
                    else {
                        responseAction.errorMessage = "Arguments invalides";
                        resolve(responseAction);
                    }
                    break;


                case "updateDlgItvStatus":
                    //var cDItvTargetValue = targetData.functionManager.getValue();
                    //var cDItvSelectedSrc = targetData.functionManager.getSrcData ? targetData.functionManager.getSrcData(cDItvTargetValue) : null;
                    var cDItvSelectedSrc = componentArgs ? componentArgs.srcData : null;
                    if (cDItvSelectedSrc) {
                        setValue("cItvStep", cDItvSelectedSrc.step);
                        setValue("cItvValue", cDItvSelectedSrc.value);

                        var submitNoConfirmCpt = dataList["cSubmitNoConfirm"];
                        if (submitNoConfirmCpt) setValue("cSubmitNoConfirm", cDItvSelectedSrc.step < 0);

                        if (componentData.functionManager.hideOption) {
                            if (cDItvSelectedSrc.step >= 0) componentData.functionManager.hideOption("step", "<", 0);
                            else componentData.functionManager.hideOption();
                        }
                    }

                    break;
                case "confirmPlanItv":
                    var currentDataPlan = altValue || getValues();
                    var newArgs = Object.assign({}, componentArgs);
                    if (value) {
                        /*var cDItvStatus = dataList[commonFunc.camelize("StatusID", true)];
                        if (cDItvStatus && cDItvStatus.functionManager) {
                            console.debug(cDItvStatus);

                            var cDItvTargetValue = cDItvStatus.functionManager.getValue();
                            console.debug(cDItvTargetValue);
                            var cDItvSelectedSrc = cDItvStatus.functionManager.getSrcData ? cDItvStatus.functionManager.getSrcData(cDItvTargetValue) : null;
                            if (cDItvSelectedSrc) {
                                if (cDItvSelectedSrc.step < 0) {
                                    newArgs.statusItv = 8;
                                }
                                else {
                                    newArgs.statusItv = 2;
                                }
                                if (cDItvSelectedSrc.step === 1 && cDItvSelectedSrc.value === 1) {
                                    newArgs.isValid = true;
                                }
                                else {
                                    newArgs.isValid = false;
                                }
                            }
                        }*/

                        if (currentDataPlan.cItvStep !== undefined && currentDataPlan.cItvValue !== undefined) {
                            if (currentDataPlan.cItvStep >= 0) {
                                newArgs.statusItv = 2;
                            }
                            else {
                                newArgs.statusItv = 8;
                            }
                            if (currentDataPlan.cItvStep > 0 || (currentDataPlan.cItvStep === 0 && currentDataPlan.cItvValue === 1)) {
                                newArgs.isValid = true;
                            }
                            else {
                                newArgs.isValid = false;
                            }
                        }
                        else {
                            newArgs.statusItv = 2;
                        }

                    }
                    else {
                        newArgs.statusItv = 2;
                    }

                    var actionTrigger = { trigger: "savePlanItv", altValue: currentDataPlan };
                    if (componentData.argumentsObj?.externalUnmount) {
                        actionTrigger.value = "closeItvDialog";
                        if (!componentData.onActionEvents) componentData.onActionEvents = {};
                        if (!componentData.onActionEvents.extrasActionEvent) componentData.onActionEvents.extrasActionEvent = {};
                        componentData.onActionEvents.extrasActionEvent["closeItvDialog"] = [{ trigger: "closeDialog" }];
                    }

                    onActionRequired(tag, actionTrigger, componentData, newArgs).then((responseLoad) => {
                        responseAction = responseLoad;
                        resolve(responseAction);
                    });
                    break;
                case "savePlanItv":

                    var currentData = altValue || getValues();
                    var statusID = ((componentArgs && componentArgs.statusItv) ? componentArgs.statusItv : loadedData.itv.statusID);

                    console.debug(currentData);

                    var itv = {};
                    //Récup data
                    /*itv.ReportItvID = loadedData.idReport;
                    itv.IsSet = true;
                    itv.ServiceID = loadedData.benefitID;
                    itv.StartDate = moment((loadedData.itv.startDate instanceof Date) ? loadedData.itv.startDate : commonFunc.restStringToDate(loadedData.itv.startDate)).utc(true).toDate();
                    itv.EndDate = commonFunc.addMinutes(itv.StartDate, 90);
                    itv.EmployeeID = loadedData.itv.employeeID;
                    itv.Name = loadedData.itv.employee.name + " " + loadedData.itv.employee.firstName;
                    itv.Title = loadedData.client.name + " [" + loadedData.refID + "]    " + loadedData.address.pc;
                    itv.Comments = loadedData.address.addressMain + " " + loadedData.address.addressPlus + " " + loadedData.address.addressPlus2 + " " + loadedData.address.pc + " " + loadedData.address.city;

                    itv.Phone = loadedData.employee.gsm;
                    itv.Email = "";
                    itv.Length = 1.5;
                    itv.Tel = loadedData.employee.tel;
                    itv.Email = "";
                    itv.Version = loadedData.refIDVersion;*/

                    //Récup partiel front (getValues)
                    //itv.reportItvID = loadedData.idReport;
                    itv.idEvent = loadedData.itv.idEvent;
                    itv.reportID = loadedData.idReport;
                    //itv.isSet = true;
                    itv.serviceID = currentData.itv.serviceID;
                    var sd = currentData.itv.startDate;
                    if (args?.lengthSystem || currentData.itv.length > 0) {
                        itv.length = currentData.itv.length || 1.5;//TEMP

                        if (commonFunc.isValidDate(sd)) {
                            itv.startDate = (sd instanceof Date) ? sd : commonFunc.restStringToDate(sd);
                            itv.endDate = commonFunc.addMinutes(itv.startDate, currentData.itv.length * 60);
                        }
                        else {
                            itv.startDate = moment("1970-01-01T00:00").toDate();
                            itv.endDate = currentData.itv.startDate;
                            itv.length = 0;
                        }
                    }
                    else {
                        itv.startDate = (sd instanceof Date) ? sd : commonFunc.restStringToDate(sd);
                        var ed = currentData.itv.endDate;
                        itv.endDate = (ed instanceof Date) ? ed : commonFunc.restStringToDate(ed);
                        if (commonFunc.isValidDate(itv.startDate) && commonFunc.isValidDate(itv.endDate)) {
                            itv.length = moment(itv.endDate).diff(moment(itv.startDate), 'hours', true);
                        }
                        else {
                            if (!commonFunc.isValidDate(itv.startDate)) itv.startDate = moment("1970-01-01T00:00").toDate();
                            if (!commonFunc.isValidDate(itv.endDate)) itv.endDate = moment("1970-01-01T00:00").toDate();
                            itv.length = 0;
                        }
                    }

                    itv.employeeID = currentData.itv.employeeID;
                    //itv.name = loadedData.itv.employee.name + " " + loadedData.itv.employee.firstName;
                    itv.title = loadedData.client.name + " [" + loadedData.refID + "]    " + loadedData.address.pc;//TODO : voir pour concatener les champs
                    itv.comments = loadedData.address.addressMain + " " + loadedData.address.addressPlus + " " + loadedData.address.addressPlus2 + " " + loadedData.address.pc + " " + loadedData.address.city;

                    //itv.phone = getValues("employee.gsm");//TODO ?
                    //itv.email = "";
                    //itv.tel = loadedData.employee.tel;
                    //itv.version = loadedData.refIDVersion;
                    itv.statusID = statusID;

                    if (currentData.statusID) {
                        itv.statusRequest = {};
                        itv.statusRequest.id = itv.reportID;
                        itv.statusRequest.newStatus = currentData.statusID;
                        itv.statusRequest.newStep = currentData.stepID;
                    }

                    
                    if (componentArgs && Object.keys(componentArgs).length) {
                        Object.keys(componentArgs).forEach((key) => {
                            var valueArgs = componentArgs[key];
                            if (valueArgs?.startsWith && valueArgs.startsWith("prop:")) itv[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                            else itv[key] = valueArgs;
                        });
                    }


                    if ((itv.employeeID > 0 && commonFunc.isValidDate(itv.startDate)) || itv.statusID === 8) {
                        Swal.fire({
                            title: 'Opération en cours...',
                            didOpen: () => { Swal.showLoading() },
                        });


                        var scheduleProcess = () => {
                            commonFunc.postMethod("../api/report/ScheduleItvReport", itv).then((response) => {
                                Swal.close();
                                var data = response.data;
                                if (data && data.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: t("gal_success"),
                                        html: "Assignation effectuée avec succès",
                                        didOpen: () => { Swal.hideLoading() },
                                    }).then((result) => {
                                        onActionRequired(tag, { trigger: "refreshElem" }, componentData, componentArgs).then((responseLoad) => {
                                            responseAction = responseLoad;
                                            resolve(responseAction);
                                        });

                                        chainEvents(componentData, value);
                                    });
                                    if (parentProps.autoClose) ref.current.submitForm("success");
                                } else {
                                    responseAction.errorMessage = "Echec de l'assignation : " + data.errorMessage;
                                    responseAction.forceMessage = true;
                                    resolve(responseAction);
                                    if (parentProps.autoClose) ref.current.submitForm("error");
                                }
                            });
                        };

                        if (loadedData?.status?.step >= 1) {// >= Envoyé

                            commonFunc.postMethod("../api/report/ModifySentItvReport", itv).then((response) => {
                                Swal.close();
                                var data = response.data;
                                if (data && data.isSuccess) {
                                    Swal.fire({
                                        icon: "success",
                                        title: t("gal_success"),
                                        html: "Modification effectuée avec succès",
                                        didOpen: () => { Swal.hideLoading() },
                                    }).then((result) => {
                                        onActionRequired(tag, { trigger: "refreshElem" }, componentData, componentArgs).then((responseLoad) => {
                                            responseAction = responseLoad;
                                            resolve(responseAction);
                                        });

                                        chainEvents(componentData, value);
                                    });
                                    if (parentProps.autoClose) ref.current.submitForm("success");
                                } else {
                                    responseAction.errorMessage = "Echec de la modification : " + data.errorMessage;
                                    responseAction.forceMessage = true;
                                    resolve(responseAction);
                                    if (parentProps.autoClose) ref.current.submitForm("error");
                                }
                            });

                            /*var argsCancel = { id: currentData.itv.idEvent, bindId: currentData.idReport };
                            commonFunc.postMethod("../api/report/CancelReport", argsCancel).then((response) => {
                                var removeResult = response.data;
                                if (removeResult && removeResult.isSuccess) {
                                    itv.idEvent = removeResult.result.idEvent;
                                    itv.reportID = removeResult.result.reportID;
                                    if (itv.statusRequest.id) itv.statusRequest.id = itv.reportID;
                                    scheduleProcess();
                                } else {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Echec',
                                        html: "Echec de désaffectation de l'intervention planning<p>" + removeResult.errorMessage + "</p>",
                                        didOpen: () => { Swal.hideLoading() }
                                    });
                                }

                            });*/
                        }
                        else scheduleProcess();

                    } else {
                        responseAction.errorMessage = "MAJ impossible. Données invalides";
                        resolve(responseAction);
                        if (parentProps.autoClose) ref.current.submitForm("error");
                    }
                    break;

                //TODO : test la fonction
                case "reportDlgEnableDates":
                    var active = value;
                    /*$("#consDlg_site_sd").prop("disabled", active);//startDate
                    $("#consDlg_site_sh").prop("disabled", active);
                    $("#aupdDlgRepLstEmp").prop("disabled", active);//itv.employeeId
                    $("#consDlg_site_drt").prop("disabled", active);//itv.length
                    $("#aupdDlgRepLstSvc").prop("disabled", active);//benefitID

                    $(".filter-period-trigger").prop("disabled", active);//variations startDate

                    if (!componentArgs.noButtons) $("#consDlg_site_dsfct, #consDlg_site_chgasgn").addClass("disabled hidden d-none").prop("disabled", !active);

                    if (componentArgs.resetFields) {
                        $("#aupdDlgRepLstEmp").val(0);//itv.employeeId
                        $("#consDlg_site_dsfct").data("targetId", -1);//itv.idEvent
                    }*/
                    dataList["startDate"].disabled = active;
                    //dataList["startDate_dateonly"].disabled = active;
                    dataList["itv.employeeId"].disabled = active;
                    dataList["itv.length"].disabled = active;
                    dataList["benefitID"].disabled = active;

                    //$(".filter-period-trigger").prop("disabled", active);//variations startDate

                    if (!componentArgs.noButtons) {
                        dataList["unassignButton"].hidden = !active;
                        dataList["unassignButton"].disabled = !active;
                        dataList["unassignButton"].functionManager.rerender();
                        dataList["chgassignButton"].hidden = !active;
                        dataList["chgassignButton"].disabled = !active;
                        dataList["chgassignButton"].functionManager.rerender();
                    }

                    if (componentArgs.resetFields) {
                        onActionRequired(tag, { trigger: "postGeneric", url: "api/report/UnscheduleItvReport" }, componentData, componentArgs).then((responseLoad) => {
                            if (responseLoad.isSuccess) {
                                var empData = dataList["itv.employeeId"];
                                if (empData && empData.functionManager && empData.functionManager.setValue) {
                                    empData.functionManager.setValue(-1, true);
                                }
                                var eventData = dataList["itv.idEvent"];
                                if (eventData && eventData.functionManager && eventData.functionManager.setValue) {
                                    eventData.functionManager.setValue(-1, true);
                                }
                            }
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    else {
                        dataList["itv.employeeId"].functionManager.rerender();
                    }

                    dataList["startDate"].functionManager.rerender();
                    //dataList["startDate_dateonly"].functionManager.rerender();
                    dataList["itv.length"].functionManager.rerender();
                    dataList["benefitID"].functionManager.rerender();
                    //$(".filter-period-trigger").prop("disabled", active);//variations startDate

                    break;

                case "updateReportStatus":
                    if (parentProps && parentProps.updateStatusElem && loadedData) {
                        var updStatusProcess = () => {
                            parentProps.updateStatusElem(value).then((responseLoad) => {
                                if (responseLoad.isSuccess && responseLoad.result !== "") {
                                    Swal.fire({
                                        icon: 'success',
                                        title: "Statut modifié avec Succès",
                                        confirmButtonText: "Fermer",
                                    });
                                }

                                responseAction = responseLoad;
                                resolve(responseAction);
                            });
                        };

                        var rptStatusStep = loadedData.status.step;

                        //Si on était en Envoyé, recréation du rapport et suppression de l'ancien
                        if (rptStatusStep === 1) {
                            //Recreate report
                            /*updateManualReport(function () {
                                //$("#frmDlgManualAdditv").submit();
                                $("#btnDlgAddItv").click();
                                //hideBsModal("dlgAddManualItvModal");

                                responseAction.isSuccess = true;
                                resolve(responseAction);
                            });*/

                            //TODO : recreate REPORT
                            Swal.fire({
                                icon: 'error',
                                title: 'Echec',
                                html: "TODO",
                            });
                            resolve(responseAction);
                        }
                        //Si passage en En attente et que planifié, Unassign
                        else if (parseInt(altValue) < 0 && loadedData.itv != null && loadedData.planItvID > 0) {
                            var argsUnassign = { id: loadedData.itv.idEvent || 0, bindId: loadedData.idReport };
                            commonFunc.postMethod("../api/report/UnscheduleItvReport", argsUnassign).then((response) => {
                                var data = response.data;
                                if (data && data.isSuccess) {
                                    updStatusProcess();
                                } else {
                                    Swal.fire({
                                        icon: "error",
                                        title: "Echec",
                                        html: "Echec de désaffection de l'intervenant<br/>" + data.errorMessage
                                    });
                                    responseAction = data;
                                    resolve(responseAction);
                                }
                            });
                        }
                        //Si passage en Planifié Non Envoyé et que pas de plannification
                        else if (parseInt(altValue) <= 0 && parseInt(targetValue) === 1 && !(loadedData.itv != null && loadedData.planItvID > 0)) {
                            Swal.fire({
                                icon: 'error',
                                title: 'Echec',
                                html: "MAJ impossible<br>Une planification est nécessaire",
                            });
                            responseAction.errorMessage = "MAJ impossible<br>Une planification est nécessaire";
                            resolve(responseAction);
                        }
                        else {
                            updStatusProcess();
                        }
                    }
                    else {
                        responseAction.errorMessage = "MAJ impossible";
                        resolve(responseAction);
                    }
                    break;



                case "loadReportActionStatus":
                    commonFunc.getMethod("../api/report/GetStatus", null).then((response) => {
                        var data = response.data;

                        if (data.isSuccess) {
                            if (useCache) {
                                setCacheValue(targetCache, data.result);
                            }

                            var newItems = [];
                            var curStep = (loadedData ? data.result.filter((st) => st.idStatus === loadedData.statusID) : []);
                            if (curStep.length) curStep = curStep[0].step;
                            data.result.forEach((status) => {
                                if (!status.isAutomatic && (!max || status.step < parseInt(max))) {
                                    newItems.push({
                                        name: "ReportItem",
                                        title: "Passer en <" + status.name + ">",
                                        objType: "button",
                                        ignoreParentDisabled: true,
                                        classSup: status.css.replace(/badge/g, "btn").replace("fa-", "untrigger") + " text-white",
                                        onActionEvents: { onClick: [{ trigger: "updateReportStatus", target: "", value: status.idStatus, altValue: status.step, targetValue: status.value }] },//updateStatusElem
                                        hideOnAction: [{ id: status.idStatus, trigger: "hideActionStatus", target: "", value: status.step, operatorTest: "!=", altValue: curStep, targetValue: (loadedData ? loadedData.statusID : 0) },//Cache tout les boutons de step différent du status actuel
                                            { id: status.idStatus, trigger: "showActionStatus", target: "", value: status.step, operatorTest: "=", altValue: (curStep < 1 ? -1 : null), targetValue: (loadedData ? loadedData.statusID : 0) },//Affiche tout les boutons step=-1 si status actuel à un step < 1
                                            { id: status.idStatus, trigger: "showActionStatus", target: "", value: status.step, operatorTest: "=", altValue: curStep + 1, targetValue: (loadedData ? loadedData.statusID : 0) }]//Affiche tout les boutons step+1
                                    });
                                }
                            });
                            targetData.items = newItems;
                            if (targetData.functionManager && targetData.functionManager.rerender) targetData.functionManager.rerender();


                            responseAction = data;
                            resolve(responseAction);

                        } else {
                            responseAction = data;
                            resolve(responseAction);
                        }
                    });
                    break;
                case "loadClientActionStatus":
                    commonFunc.getMethod("../api/client/GetStatus", null).then((response) => {
                        var data = response.data;

                        if (data.isSuccess) {
                            if (useCache) {
                                setCacheValue(targetCache, data.result);
                            }

                            var newItems = [];
                            var curStep = (loadedData ? data.result.filter((st) => st.idStatus === loadedData.statusID) : []);
                            if (curStep.length) curStep = curStep[0].step;
                            data.result.forEach((status) => {
                                if (!status.isAutomatic && (!max || status.step < parseInt(max))) {
                                    newItems.push({
                                        name: "ReportItem",
                                        title: "Passer en <" + status.name + ">",
                                        objType: "button",
                                        ignoreParentDisabled: true,
                                        classSup: status.css.replace(/badge/g, "btn").replace("fa-", "untrigger") + " text-white",
                                        onActionEvents: { onClick: [{ trigger: "updateStatusElem", target: "", value: status.idStatus }] },
                                        hideOnAction: [{ id: status.idStatus, trigger: "hideActionStatus", target: "", value: status.step, operatorTest: "=", altValue: curStep, targetValue: (loadedData ? loadedData.statusID : 0) }]
                                    });
                                }
                            });
                            targetData.items = newItems;
                            if (targetData.functionManager && targetData.functionManager.rerender) targetData.functionManager.rerender();

                            responseAction = data;
                            resolve(responseAction);

                        } else {
                            responseAction = data;
                            resolve(responseAction);
                        }
                    });
                    break;
                case "loadLeadActionStatus":
                    commonFunc.getMethod("../api/lead/GetStatus", null).then((response) => {//url
                        var data = response.data;

                        if (data.isSuccess) {
                            if (useCache) {
                                setCacheValue(targetCache, data.result);
                            }

                            var newItems = [];
                            var curStep = (loadedData ? data.result.filter((st) => st.idStatus === loadedData.statusID) : []);
                            if (curStep.length) curStep = curStep[0].step;
                            data.result.forEach((status) => {
                                if (!status.isAutomatic && (!max || status.step < parseInt(max))) {
                                    newItems.push({
                                        name: "ReportItem",
                                        title: "Passer en <" + status.name + ">",
                                        objType: "button",
                                        ignoreParentDisabled: true,
                                        classSup: status.css.replace(/badge/g, "btn").replace("fa-", "untrigger") + " text-white",
                                        onActionEvents: { onClick: [{ trigger: "updateStatusElem", target: "", value: status.idStatus, altValue: (value ? value : null) }] },
                                        hideOnAction: [{ id: status.idStatus, trigger: "hideActionStatus", target: "", value: status.step, operatorTest: "!=", altValue: curStep+1, targetValue: (loadedData ? loadedData.statusID : 0) }]
                                    });
                                }
                            });
                            targetData.items = newItems;
                            if (targetData.functionManager && targetData.functionManager.rerender) targetData.functionManager.rerender();

                            responseAction = data;
                            resolve(responseAction);

                        } else {
                            responseAction = data;
                            resolve(responseAction);
                        }
                    });
                    break;
                case "loadMaterialActionStatus":
                    commonFunc.getMethod("../api/material/GetStatus", null).then((response) => {
                        var data = response.data;

                        if (data.isSuccess) {
                            if (useCache) {
                                setCacheValue(targetCache, data.result);
                            }

                            var newItems = [];
                            var curStep = (loadedData ? data.result.filter((st) => st.idStatus === loadedData.statusID) : []);
                            if (curStep.length) curStep = curStep[0].step;
                            data.result.forEach((status) => {
                                if (!status.isAutomatic && (!max || status.step < parseInt(max))) {
                                    newItems.push({
                                        name: "ReportItem",
                                        title: "Passer en <" + status.name + ">",
                                        objType: "button",
                                        ignoreParentDisabled: true,
                                        classSup: status.css.replace(/badge/g, "btn").replace("fa-", "untrigger") + " text-white",
                                        onActionEvents: { onClick: [{ trigger: "updateStatusElem", target: "", value: status.idStatus }] },
                                        hideOnAction: [{ id: status.idStatus, trigger: "hideActionStatus", target: "", value: status.step, operatorTest: "=", altValue: curStep, targetValue: (loadedData ? loadedData.statusID : 0) }]
                                    });
                                }
                            });
                            targetData.items = newItems;
                            if (targetData.functionManager && targetData.functionManager.rerender) targetData.functionManager.rerender();

                            responseAction = data;
                            resolve(responseAction);

                        } else {
                            responseAction = data;
                            resolve(responseAction);
                        }
                    });
                    break;
                case "loadTicketActionStatus":
                    commonFunc.getMethod("../api/ticket/GetStatus", null).then((response) => {
                        var data = response.data;

                        if (data.isSuccess) {
                            if (useCache) {
                                setCacheValue(targetCache, data.result);
                            }

                            var newItems = [];
                            var curStep = (loadedData ? data.result.filter((st) => st.idStatus === loadedData.statusID) : []);
                            if (curStep.length) curStep = curStep[0].step;
                            data.result.forEach((status) => {
                                if (!status.isAutomatic && (!max || status.step < parseInt(max))) {
                                    newItems.push({
                                        name: "ReportItem",
                                        title: "Passer en <" + status.name + ">",
                                        objType: "button",
                                        ignoreParentDisabled: true,
                                        classSup: status.css.replace(/badge/g, "btn").replace("fa-", "untrigger") + " text-white",
                                        onActionEvents: { onClick: [{ trigger: "updateStatusElem", target: "", value: status.idStatus }] },
                                        hideOnAction: [{ id: status.idStatus, trigger: "hideActionStatus", target: "", value: status.step, operatorTest: "!=", altValue: curStep+1, targetValue: (loadedData ? loadedData.statusID : 0) }]
                                    });
                                }
                            });
                            targetData.items = newItems;
                            if (targetData.functionManager && targetData.functionManager.rerender) targetData.functionManager.rerender();

                            responseAction = data;
                            resolve(responseAction);

                        } else {
                            responseAction = data;
                            resolve(responseAction);
                        }
                    });
                    break;
                case "loadTicketRadioSubStatus":
                    commonFunc.getMethod("../api/ticket/GetStatus", { isSubStatus: true/*, level: curStep*/ }).then((response) => {//TODO : test avec level
                        var data = response.data;

                        if (data.isSuccess) {
                            if (useCache) {
                                setCacheValue(targetCache, data.result);
                            }

                            var newItems = [];
                            var itemOptions = [];
                            var loadedStepID = loadedData ? loadedData.stepID : 0;
                            var defaultStepID = 0;
                            var curStep = (loadedData && loadedData.status ? loadedData.status.step : []);
                            data.result.forEach((status) => {
                                if (!status.isAutomatic && (!max || status.step < parseInt(max))) {
                                    if (loadedStepID === status.idStatus) defaultStepID = status.idStatus;
                                    itemOptions.push({
                                        title: status.name, value: status.idStatus,
                                        hideOnAction: [{ id: status.idStatus, trigger: "hideActionStatus", target: "", value: status.step, operatorTest: "!=", altValue: curStep, targetValue: loadedStepID },
                                        { id: status.idStatus, trigger: "showActionStatus", target: "", value: status.step, operatorTest: "=", altValue: 0, targetValue: loadedStepID }]
                                    });//status.css
                                }
                            });
                            newItems.push({
                                name: "ReportItem",
                                title: "",
                                defaultValue: (defaultStepID || itemOptions[0]?.value),
                                bindPropResult: "cSubStatus",
                                objType: "radio",
                                isInput: true,
                                ignoreParentDisabled: true,
                                options: itemOptions,
                                customDesign: {
                                    design: { boxSize: "1" },
                                    designInput: { alignment: "horizontal" }
                                },
                                onActionEvents: { onChange: [{ trigger: "updateStatusElem", target: "", value: (loadedData ? loadedData.statusID : 0) }] }
                            });

                            targetData.items = newItems;
                            if (targetData.functionManager && targetData.functionManager.rerender) targetData.functionManager.rerender();

                            responseAction = data;
                            resolve(responseAction);

                        } else {
                            responseAction = data;
                            resolve(responseAction);
                        }
                    });
                    break;
                case "loadLeadRadioSubStatus":
                    commonFunc.getMethod("../api/lead/GetStatus", { isSubStatus: true/*, level: curStep*/ }).then((response) => {//TODO : test avec level
                        var data = response.data;

                        if (data.isSuccess) {
                            if (useCache) {
                                setCacheValue(targetCache, data.result);
                            }

                            var newItems = [];
                            var itemOptions = [];
                            var loadedStepID = loadedData ? loadedData.stepID : 0;
                            var defaultStepID = 0;
                            var curStep = (loadedData && loadedData.status ? loadedData.status.step : []);
                            data.result.forEach((status) => {
                                if (!status.isAutomatic && (!max || status.step < parseInt(max))) {
                                    if (loadedStepID === status.idStatus) defaultStepID = status.idStatus;
                                    itemOptions.push({
                                        title: status.name, value: status.idStatus,
                                        hideOnAction: [{ id: status.idStatus, trigger: "hideActionStatus", target: "", value: status.step, operatorTest: "!=", altValue: curStep, targetValue: loadedStepID },
                                            { id: status.idStatus, trigger: "showActionStatus", target: "", value: status.step, operatorTest: "=", altValue: 0, targetValue: loadedStepID }]
                                    });//status.css
                                }
                            });
                            newItems.push({
                                name: "ReportItem",
                                title: "",
                                defaultValue: (defaultStepID || itemOptions[0].value),
                                bindPropResult: "cSubStatus",
                                objType: "radio",
                                isInput: true,
                                ignoreParentDisabled: true,
                                options: itemOptions,
                                customDesign: {
                                    design: { boxSize: "1" },
                                    designInput: { alignment: "horizontal" }
                                },
                                onActionEvents: { onChange: [{ trigger: "updateStatusElem", target: "", value: (loadedData ? loadedData.statusID : 0) }] }
                            });

                            targetData.items = newItems;
                            if (targetData.functionManager && targetData.functionManager.rerender) targetData.functionManager.rerender();

                            responseAction = data;
                            resolve(responseAction);

                        } else {
                            responseAction = data;
                            resolve(responseAction);
                        }
                    });
                    break;

                case "triggerCacheRefresh":
                    setCacheValue(value, dataCache[value], altValue === "selfExcept" ? targetData : null);
                    break;

                case "removeFromCache":
                    if (targetCache) {
                        if (modelFctManager.rootCache) modelFctManager.rootCache[targetCache] = null;

                        chainEvents(componentData, value);
                    }
                    else {
                        responseAction.errorMessage = t("gal_invalidArgs");
                        resolve(responseAction);
                    }
                    break;
                case "loadDataFromCache"://loadfromcache
                    if (targetData?.functionManager?.setValue && value && dataCache[value]) {
                        var localTargetCache = dataCache[value];
                        var localTargetExtraCache = dataCache["extra" + value];

                        var valueFilter = getValues("cFilter");
                        if (valueFilter) {
                            localTargetCache = localTargetCache.filter((elem) => {
                                return elem["refName"] === valueFilter;
                            });
                            localTargetExtraCache = localTargetExtraCache.filter((elem) => {
                                return elem["refName"] === valueFilter;
                            });
                        }

                        var alteredCache = false;
                        var cacheValue;
                        if (localTargetCache?.length) {
                            if (targetValue?.startsWith("statsValidDate:")) {
                                setTimeout(() => {
                                    var keyCache = altValue;
                                    cacheValue = localTargetCache;
                                    if (Array.isArray(cacheValue)) {
                                        var targetDate;
                                        if (dataCache["SITEINFOS"]) {//TODO
                                            var extrasSite = dataCache["SITEINFOS"].extras;//TODO
                                            if (extrasSite?.length) {
                                                var extraSiteElem = extrasSite.filter(extra => extra.name === "validationDate");//TODO
                                                if (extraSiteElem.length) {
                                                    targetDate = extraSiteElem[0].value;
                                                }
                                            }
                                            if (targetDate && curDate) {
                                                var cumulDate = moment(targetDate)/*.year(moment(curDate).year())*/;

                                                var sumElem = JSON.parse(JSON.stringify(cacheValue[0]));
                                                if (altValue.startsWith("diff")) {
                                                    sumElem.prevValue = 0;
                                                    sumElem.totalValue = 0;
                                                    sumElem.objective = 0;
                                                }
                                                else if (altValue.startsWith("sum")) {
                                                    var targetsSplit = altValue.replace("sum:", "").split(";");
                                                    sumElem[targetsSplit[0]] = 0;
                                                    sumElem[targetsSplit[1]] = 0;
                                                }
                                                else {
                                                    sumElem[keyCache] = 0;
                                                }

                                                //STATSLIST_GROUP_MY
                                                if (value === "STATSLIST_GROUP_ASSO" || value === "STATSLIST_GROUP_M_ASSO") {
                                                    var monthGrpValues = localTargetCache;
                                                    var dataExtraCache = localTargetExtraCache;
                                                    if (!monthGrpValues[0].prevValue && dataExtraCache) {
                                                        monthGrpValues.forEach((elem) => {
                                                            var periodDate = moment(elem.period.split("-")[1], "YYYY-MM");
                                                            var cumulValue = 0;
                                                            dataExtraCache.forEach((extra) => {
                                                                var cumulDate = moment(extra.period.split("-")[1], "YYYY-MM");
                                                                if (cumulDate.isSame(periodDate) && extra.refName === elem.refName) {
                                                                    cumulValue += extra.totalValue;
                                                                }
                                                            });
                                                            elem.prevValue = cumulValue;
                                                        });
                                                    }
                                                    cacheValue = monthGrpValues.filter(mv => {
                                                        var mvFiltered = cacheValue.filter((asso) => asso.refName.indexOf(mv.refName) >= 0);
                                                        //mv >> ????-??
                                                        //cacheValue >> ????
                                                        /*mvFiltered.forEach((elem) => {
                                                            elem.objective += mv.objective;
                                                        });*/
                                                        /*if (mv.period.endsWith("-01")) {
                                                            mv.objective = (mvFiltered[0].objective || 0);
                                                        }
                                                        else mv.objective = 0;*/
                                                        return mvFiltered.length > 0;
                                                    });
                                                    /*console.debug(cacheValue);
                                                    console.debug(JSON.stringify(cacheValue[0]));
                                                    console.debug(monthGrpValues);*/
                                                }
                                                cacheValue.forEach((elem) => {
                                                    if (elem.period) {//TODO : check asso !!!
                                                        var periodDate = moment(elem.period, "YYYY-MM");
                                                        if (periodDate.isSameOrBefore(cumulDate)) {
                                                            if (altValue.startsWith("diff")) {
                                                                sumElem.prevValue += elem.prevValue;
                                                                sumElem.totalValue += elem.totalValue;
                                                                sumElem.objective += elem.objective;
                                                            }
                                                            else if (altValue.startsWith("sum")) {
                                                                var targetsSplit = altValue.replace("sum:", "").split(";");
                                                                if (contextType !== targetsSplit[0] || (contextType === targetsSplit[0] && (periodDate.isSame(cumulDate, 'month') || periodDate.get('month') === 11))) sumElem[targetsSplit[0]] += (elem[targetsSplit[0]] ? parseFloat(elem[targetsSplit[0]]) : 0);
                                                                if (contextType !== targetsSplit[1] || (contextType === targetsSplit[1] && (periodDate.isSame(cumulDate, 'month') || periodDate.get('month') === 11))) sumElem[targetsSplit[1]] += (elem[targetsSplit[1]] ? parseFloat(elem[targetsSplit[1]]) : 0);
                                                            }
                                                            else {
                                                                if (!contextType || (periodDate.isSame(cumulDate, 'month') || periodDate.get('month') === 11)) sumElem[keyCache] += (elem[keyCache] ? parseFloat(elem[keyCache]) : 0);
                                                            }
                                                        }
                                                    }
                                                });
                                                alteredCache = true;
                                                cacheValue = sumElem;
                                            }
                                        }
                                    }
                                    var curVal;
                                    if (altValue.startsWith("prev") && localTargetExtraCache?.length) {
                                        curVal = cacheValue[keyCache];
                                    }
                                    else if (altValue.startsWith("extras.")) {
                                        var extras = cacheValue.extras;
                                        if (extras?.length) {
                                            var extraElem = extras.filter(extra => extra.name === altValue.replace("extras.", ""));
                                            if (extraElem.length) {
                                                curVal = extraElem[0].value;
                                            }
                                        }
                                    }
                                    else if (altValue.startsWith("diff")) {//diff/diffPct   
                                        var targetsSplit = altValue.replace("diff:", "").replace("diffPct:", "").split(";");
                                        var value1 = cacheValue[targetsSplit[0]];
                                        var value2 = cacheValue[targetsSplit[1]];

                                        if (altValue.startsWith("diffPct")) {
                                            curVal = (((value1 - value2) / value2) * 100).toFixed(2);
                                            curVal = (curVal > 100 ? 100 : (!isNaN(curVal) ? curVal : 0)) + "%";
                                        }
                                        else {
                                            curVal = value1 - value2;
                                        }
                                    }
                                    else if (altValue.startsWith("sum")) {
                                        var targetsSplit = altValue.replace("sum:", "").split(";");
                                        var value1 = cacheValue[targetsSplit[0]];
                                        var value2 = cacheValue[targetsSplit[1]];

                                        curVal = value1 + value2;
                                    }
                                    else {
                                        curVal = cacheValue[keyCache];
                                    }
                                    //console.debug(cacheValue[altValue]);


                                    targetData.functionManager.setValue(curVal, true);
                                }, 1000);
                                return;
                            }
                            else if (targetValue) {
                                var splitTarget = targetValue.split(";");
                                if (splitTarget.length === 2) {
                                    var cacheFiltered = localTargetCache.filter(elem => elem[splitTarget[0]] == splitTarget[1]);
                                    if (cacheFiltered?.length) cacheValue = cacheFiltered[0];
                                }
                            }
                            else {
                                cacheValue = localTargetCache[0];
                            }
                        }
                        else {
                            cacheValue = localTargetCache;
                        }
                        /*console.debug(componentData.bindPropResult);
                        console.debug(altValue);
                        console.debug(cacheValue);*/
                        var keyCache = altValue;
                        var curVal;
                        if (altValue.startsWith("prev") && localTargetExtraCache?.length) {
                            /*console.debug(dataCache);
                            console.debug("extra" + value);
                            console.debug(localTargetExtraCache[0]);*/
                            if (!alteredCache) cacheValue[keyCache] = localTargetExtraCache[0].totalValue;
                            curVal = cacheValue[keyCache];
                        }
                        else if (altValue.startsWith("extras.")) {
                            var extras = cacheValue.extras;
                            if (extras?.length) {
                                var extraElem = extras.filter(extra => extra.name === altValue.replace("extras.", ""));
                                if (extraElem.length) {
                                    curVal = extraElem[0].value;
                                }
                            }
                        }
                        else if (altValue.startsWith("diff")) {//diff/diffPct
                            var targetsSplit = altValue.replace("diff:", "").replace("diffPct:", "").split(";");
                            var value1 = cacheValue[targetsSplit[0]];
                            var value2 = cacheValue[targetsSplit[1]];

                            if (altValue.startsWith("diffPct")) {
                                curVal = (((value1 - value2) / value2) * 100).toFixed(2);
                                curVal = (curVal > 100 ? 100 : (!isNaN(curVal) ? curVal : 0)) + "%";
                            }
                            else {
                                curVal = value1 - value2;
                            }
                        }
                        else {
                            curVal = cacheValue[keyCache];
                        }
                        //console.debug(cacheValue[altValue]);


                        targetData.functionManager.setValue(curVal, true);
                    }
                    else {
                        responseAction.errorMessage = t("gal_invalidArgs");
                        resolve(responseAction);
                    }
                    break;

                case "loadObjectives":
                    var rows = altValue;
                    if (!rows) {
                        if (targetValue) {
                            rows = modelFctManager.rootCache[targetValue];
                        }
                        else if (componentArgs.value) {
                            rows = componentArgs.value || [];
                        }
                        else if (targetData?.functionManager.getTableData) {
                            rows = targetData.functionManager.getTableData()?.data || [];
                        }
                    }

                    var loadProc = (siteObj) => {
                        rows?.forEach((row) => {
                            //console.debug(targetValue);
                            //console.debug(row.period);
                            /*if (targetValue === "STATSLIST_GLOBAL_MY") {
                                //TODO : somme des mois
                            }
                            else {*/
                                if (row.period.indexOf("-") >= 0) {
                                    var splitPeriod = row.period.split("-");

                                    var filteredValueM = siteObj.extras.filter(extra => {
                                        var targetName = row.refName;
                                        if (targetValue === "STATSLIST_GROUP_M_ASSO") {
                                            var splitName = targetName.split(" - ");
                                            targetName = targetName.replace(" - " + splitName[splitName.length - 1], "");
                                        }
                                        return extra.name === splitPeriod[0] + targetName;
                                    });//TODO : voir si refName OU id
                                    //console.debug(splitPeriod[0] + row.refName);
                                    if (filteredValueM.length && filteredValueM[0].value.startsWith("[")) {
                                        var tableObjM = JSON.parse(filteredValueM[0].value);
                                        if (tableObjM?.length) {
                                            var index = parseInt(splitPeriod[1]) - 1;
                                            row["objective" + splitPeriod[1]] = tableObjM[index];
                                            row.objective = tableObjM[index];
                                        }
                                        row.extraID = filteredValueM[0].idExtra;
                                    }
                                    //console.debug(row);
                                }
                                else {
                                    var targetName = row.refName;
                                    if (targetValue === "STATSLIST_GROUP_ASSO") {
                                        var splitName = targetName.split(" - ");
                                        targetName = targetName.replace(" - " + splitName[splitName.length - 1], "");
                                    }
                                    var filteredValue = siteObj.extras.filter(extra => extra.name === row.period + targetName);//TODO : voir si refName OU id
                                    //console.debug(row.period + row.refName);
                                    //console.debug(filteredValue);

                                    if (filteredValue.length && filteredValue[0].value.startsWith("[")) {
                                        var tableObj = JSON.parse(filteredValue[0].value);
                                        if (tableObj?.length) {
                                            row.objective01 = tableObj[0];
                                            row.objective02 = tableObj[1];
                                            row.objective03 = tableObj[2];
                                            row.objective04 = tableObj[3];
                                            row.objective05 = tableObj[4];
                                            row.objective06 = tableObj[5];
                                            row.objective07 = tableObj[6];
                                            row.objective08 = tableObj[7];
                                            row.objective09 = tableObj[8];
                                            row.objective10 = tableObj[9];
                                            row.objective11 = tableObj[10];
                                            row.objective12 = tableObj[11];
                                            row.objective = tableObj[12];
                                        }
                                        row.extraID = filteredValue[0].idExtra;
                                    }
                                    //console.debug(row);
                                }
                            //}
                        });

                        responseAction.isSuccess = true;
                        responseAction.result = siteObj;
                        resolve(responseAction);

                        if (targetValue) setCacheValue(targetValue, rows);

                        chainEvents(componentData, value);
                    };

                    if (!useCache || !modelFctManager.rootCache[targetCache]) {
                        //console.debug(modelFctManager);
                        //var userObj = modelFctManager.getUser();
                        var siteObj = appProps?.getSite();
                        commonFunc.getMethod("../api/site/GetSite", { id: (siteObj?.parentID > 0 ? siteObj?.parentID : siteObj?.idSite) }).then((response) => {
                            //commonFunc.getMethod("../api/employee/GetWithContractAsKeyItems", args).then((response) => {
                            var dataSite = response.data;
                            if (dataSite.isSuccess) {
                                if (useCache && !modelFctManager.rootCache[targetCache]) {
                                    setCacheValue(targetCache, dataSite.result);
                                }

                                loadProc(dataSite.result);
                            }
                            else {
                                responseAction = dataSite;
                                resolve(responseAction);
                            }
                        });
                    }
                    else {
                        loadProc(modelFctManager.rootCache[targetCache]);
                    }
                    break;

                case "loadOptionsFromCache":
                    if (targetData?.functionManager?.populateData) {
                        var tempOFC = {};
                        var newOptionsOFC = [];//{ title: "Aucun", value: -1 }
                        var cacheValueOFC = dataCache[value];

                        cacheValueOFC.forEach((item) => {
                            tempOFC[item[altValue]] = item[altValue];
                            //newOptionsOFC.push({ title: item.Name, value: item.Name.startsWith("HTML_GENDOC_") ? item.Name.replace("HTML_GENDOC_", "") : 0, srcData: item });
                        });
                        Object.keys(tempOFC).forEach((key) => {
                            var item = tempOFC[key];
                            newOptionsOFC.push({ title: item, value: item });
                        });
                        newOptionsOFC = newOptionsOFC?.sort((a, b) => a.title.localeCompare(b.title));
                        targetData.functionManager.populateData(newOptionsOFC, false).then((responseLoad) => {
                            responseAction = responseLoad;
                            resolve(responseAction);
                        });
                    }
                    break;

                case "dlgSaveData":
                    var altDlgData = altValue || getValues();
                    triggerOnSubmit(altDlgData, true);
                    break;

                case "saveObjectives":
                    if (targetData?.functionManager.getTableData) {
                        var table = targetData?.functionManager.getTable();
                        var tableObj = targetData?.functionManager.getTableData();
                        //console.debug(table);
                        //console.debug(tableObj);

                        if (tableObj.data?.length) {
                            var showProcessingSO = { flag: false };
                            var shouldConfirmProcessSO = { flag: false };
                            var showResultSO = { flag: false };

                            if (!componentArgs) componentArgs = componentData.argumentsObj;
                            if (componentArgs && Object.keys(componentArgs).length) {
                                showProcessingSO = { title: componentArgs.processingTitle || "", html: componentArgs.processingHtml || "", flag: (componentArgs.showProcessing ? true : false) };
                                shouldConfirmProcessSO = { title: componentArgs.confirmTitle || "", html: componentArgs.confirmHtml || "", flag: (componentArgs.confirmProcess ? true : false) };
                                if (componentArgs.confirmInputArgs) shouldConfirmProcessSO.inputArgs = componentArgs.confirmInputArgs;
                                showResultSO = { title: componentArgs.resultTitle || "", html: componentArgs.resultHtml || "", flag: (componentArgs.showResult ? true : false), errorTitle: componentArgs.resultErrorTitle || "", errorHtml: componentArgs.resultErrorHtml || "" };
                            }
                            var genericProcessSO = function (cbAltProcess, valueObj) {
                                if (showProcessingSO.flag) {
                                    Swal.fire({
                                        title: altT(showProcessingSO.title, args) || t("gal_processing", args),
                                        html: altT(showProcessingSO.html, args) || "",
                                        didOpen: () => { Swal.showLoading() },
                                        allowOutsideClick: false,
                                        allowEscapeKey: false,
                                        allowEnterKey: false,
                                    });
                                }


                                //resolve(responseAction); return;
                                var userObj = getUser();
                                commonFunc.getMethod("../api/site/GetSite", { id: userObj ? userObj.groupSId : -1 }).then((response) => {
                                    //commonFunc.getMethod("../api/employee/GetWithContractAsKeyItems", args).then((response) => {
                                    var dataSite = response.data?.result;
                                    if (response.data?.isSuccess) {


                                        //TODO : save en extras du site global (+ Ajouter un bouton dans le modele pour trigger le actionRequired)
                                        var period;
                                        if (!dataSite.extras) dataSite.extras = [];
                                        tableObj.data.forEach((tableRow) => {
                                            //if (parseInt(tableRow.objective || 0) > 0) {
                                                var tableValue = [tableRow.objective01 || 0, tableRow.objective02 || 0, tableRow.objective03 || 0, tableRow.objective04 || 0, tableRow.objective05 || 0, tableRow.objective06 || 0,
                                                    tableRow.objective07 || 0, tableRow.objective08 || 0, tableRow.objective09 || 0, tableRow.objective10 || 0, tableRow.objective11 || 0, tableRow.objective12 || 0, tableRow.objective || 0];
                                                if (tableRow.extraID) {
                                                    var filteredExtra = dataSite.extras.filter(extra => extra.idExtra === tableRow.extraID);
                                                    if (filteredExtra?.length) {
                                                        filteredExtra[0].value = JSON.stringify(tableValue);
                                                    }
                                                }
                                                else {
                                                    dataSite.extras.push({ idExtra: 0, name: tableRow.period + tableRow.refName, value: JSON.stringify(tableValue), siteID: (userObj ? userObj.groupSId : -1) });
                                            }
                                            period = tableRow.period;
                                            //}
                                        });

                                        if (componentData.argumentsObj.manageSum) {
                                            var footerValue = [];

                                            if (table.columns().footer()?.length) {
                                                table.columns().footer().each(footerNode => {
                                                    if (parseFloat(footerNode.innerHTML) > 0) {
                                                        footerValue.push(parseFloat(footerNode.innerHTML));
                                                    }
                                                });
                                            }

                                            var filteredExtra = dataSite.extras.filter(extra => extra.name === (period ? period : "") + componentData.argumentsObj.manageSum);
                                            if (filteredExtra?.length) {
                                                filteredExtra[0].value = JSON.stringify(footerValue);
                                            }
                                            else {
                                                dataSite.extras.push({ idExtra: 0, name: (period ? period : "") + componentData.argumentsObj.manageSum, value: JSON.stringify(footerValue), siteID: (userObj ? userObj.groupSId : -1) });
                                            }
                                        }

                                        if (getValues("manageValidationDate")) {
                                            //var validationDate = moment(getValues("manageValidationDate"))/*.utc()*/.toDate();
                                            //console.debug(getValues("manageValidationDate"));
                                            //console.debug(validationDate);
                                            var filterValidDate = dataSite.extras.filter(extra => extra.name === "validationDate");
                                            if (filterValidDate.length) {
                                                filterValidDate[0].value = getValues("manageValidationDate");
                                            }
                                            else {
                                                dataSite.extras.push({ idExtra: 0, name: "validationDate", value: getValues("manageValidationDate") });
                                            }
                                        }


                                        if (dataSite.extras?.length) {
                                            dataSite.extras.forEach((value, index) => {
                                                value.extraSiteID = dataSite.idSite;
                                            });
                                        }


                                        if (!dataSite.avoidMerge) {
                                            dataSite = commonFunc.mergeDeep({}, dataSite, dataSite);

                                            /*userSite.contacts = null;
                                            userSite.files = null;
                                            userSite.filesSite = null;
                                            userSite.groups = null;
                                            userSite.models = null;*/
                                            dataSite.parent = null;
                                        }

                                        if (dataSite.groups?.length) {
                                            dataSite.groups.forEach((group, index) => {
                                                if (group.groupSiteID !== dataSite.idSite) {
                                                    group.idSegment = 0;
                                                    group.groupSiteID = dataSite.idSite;
                                                }
                                            });
                                        }

                                        //console.debug(dataSite);
                                        //resolve(responseAction); return;
                                        return commonFunc.postMethod("../api/site/UpdateSite", dataSite).then((response) => {
                                            //commonFunc.getMethod("../api/employee/GetWithContractAsKeyItems", args).then((response) => {
                                            if (showProcessingSO.flag) Swal.close();

                                            var data = response.data;
                                            if (data.isSuccess) {

                                                /*var newOptions = data.result.map((employee) => {
                                                    return { title: employee.value, value: employee.id };
                                                });
                                                targetData.functionManager.populateData(newOptions, true).then((responseLoad) => {
                                                    responseAction = responseLoad;
                                                    resolve(responseAction);
                                                });*/
                                                responseAction = data;
                                                resolve(responseAction);

                                                if (showResultSO.flag) {
                                                    Swal.fire({
                                                        icon: "success",
                                                        title: altT(showResultSO.title, args) || t("gal_success", args),
                                                        html: altT(showResultSO.html, args) || "",
                                                        didOpen: () => { Swal.hideLoading() },
                                                    }).then(() => {
                                                        if (cbAltProcess) cbAltProcess(valueObj);
                                                        else chainEvents(componentData, value);
                                                    });
                                                }
                                                else {
                                                    if (cbAltProcess) cbAltProcess(valueObj);
                                                    else chainEvents(componentData, value);
                                                }
                                            }
                                            else {
                                                responseAction = data;
                                                responseAction.forceMessage = true;
                                                resolve(responseAction);

                                                if (showResultSO.flag) {
                                                    Swal.fire({
                                                        icon: "error",
                                                        title: altT(showResultSO.errorTitle, args) || t("gal_error", args),
                                                        html: (altT(showResultSO.errorHtml, args) || "") + ":<br/>" + response.data.errorMessage
                                                    });
                                                }
                                            }
                                        });
                                    }
                                    else {
                                        responseAction = dataSite;
                                        resolve(responseAction);
                                    }
                                });
                            };

                            if (shouldConfirmProcessSO.flag) {
                                var suppOpts = "";
                                if (shouldConfirmProcessSO.inputArgs) {
                                    switch (shouldConfirmProcessSO.inputArgs.type) {
                                        case "checkbox":
                                            suppOpts = ("<br><br><input id='swal-obj-correction' type='checkbox' /> <label for='swal-obj-correction'><i class='fa fa-paper-plane me-2'></i>" + shouldConfirmProcessSO.inputArgs.title + "</label>");
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                Swal.fire({
                                    icon: "question",
                                    title: altT(shouldConfirmProcessSO.title, args) || t("gal_confirmTitle", args),
                                    html: (altT(shouldConfirmProcessSO.html, args) || t("gal_confirmAction", args)) + suppOpts,
                                    showCancelButton: true,
                                    confirmButtonColor: "#28a745",
                                    cancelButtonColor: "#dc3545",
                                    confirmButtonText: t("gal_yes"),
                                    cancelButtonText: t("gal_no"),
                                    preConfirm: () => {
                                        var objElem = document.getElementById("swal-obj-correction");
                                        if (shouldConfirmProcessSO.inputArgs?.type === "checkbox") return { "value": (objElem?.checked || false) };
                                        else return { "value": objElem?.value };
                                    }
                                }).then((result) => {
                                    if (result.value) {
                                        console.debug(result.value?.value);
                                        if (result.value?.value) {

                                            genericProcessSO((srcValue) => {
                                                var altProcessArgs = {};
                                                altProcessArgs.entities = [];
                                                altProcessArgs.categ = shouldConfirmProcessSO.inputArgs?.categ || "STATS_NOTIF";
                                                //altProcessArgs.waitForCompletion = false;
                                                commonFunc.postMethod("../api/custom/RunCustomsListJob", altProcessArgs).then((response) => {
                                                    if (response.data?.isSuccess) {
                                                        Swal.fire({
                                                            icon: "success",
                                                            title: altT(shouldConfirmProcessSO.inputArgs.successTitle, args),
                                                            html: altT(shouldConfirmProcessSO.inputArgs.successHtml, args),
                                                            didOpen: () => { Swal.hideLoading() },
                                                        });
                                                    }
                                                    else {
                                                        Swal.fire({
                                                            icon: "error",
                                                            title: altT(shouldConfirmProcessSO.inputArgs.errorTitle, args),
                                                            html: altT(shouldConfirmProcessSO.inputArgs.errorHtml, args) + ":<br/>" + response.data.errorMessage
                                                        });
                                                    }
                                                    chainEvents(componentData, value);
                                                });
                                            }, result.value?.value);
                                        }
                                        else {
                                            genericProcessSO();
                                        }
                                    }
                                });
                            }
                            else {
                                genericProcessSO();
                            }

                        }
                        else {
                            responseAction.errorMessage = t("gal_invalidArgs");
                            resolve(responseAction);
                        }
                    }
                    else {
                        responseAction.errorMessage = t("gal_invalidArgs");
                        resolve(responseAction);
                    }
                    break;


                case "showRptBtn":
                    var valueTest1;
                    switch (targetValue) {
                        case "modelDisabled": valueTest1 = genModel.disabled; break;
                        case "modelEdition": /*preventAction = genModel.disabled;*/ valueTest1 = (isUpdateGen ? true : false); break;
                        default: valueTest1 = 0; break;
                    }

                    if (loadedData && valueTest1 === true) {
                        switch (value) {
                            case "sendPlanItv":
                                targetData.hidden = !(loadedData.itv != null && loadedData.planItvID > 0 && loadedData.status.step < 3 && loadedData.status.step !== 1 && loadedData.itv.employeeID > 0 && loadedData.itv.statusID <= 6);
                                targetData.disabled = targetData.hidden;
                                break;
                            case "updatePlanItv":
                                targetData.hidden = !(loadedData.itv != null && loadedData.planItvID > 0 && loadedData.status.step <= 1 && loadedData.itv.employeeID > 0 && loadedData.itv.statusID <= 6);
                                targetData.disabled = targetData.hidden;
                                break;
                            case "savePlanItv":
                                targetData.hidden = !(loadedData.itv == null || (/*loadedData.planItvID <= 0 &&*/ loadedData.status.step < 1 && loadedData.itv.statusID === 8));
                                targetData.disabled = targetData.hidden;
                                break;
                            case "removePlanItv":
                                //targetData.hidden = !(loadedData.itv != null && loadedData.planItvID > 0 && loadedData.status.step < 3 && loadedData.itv.employeeID > 0 && loadedData.itv.statusID <= 6);//statusID <= Créé+Modifier
                                targetData.hidden = !(loadedData.itv != null && loadedData.planItvID > 0 && loadedData.status.step < 1 && loadedData.itv.employeeID > 0 && loadedData.itv.statusID <= 6);//statusID <= Créé+Modifier
                                targetData.disabled = !(loadedData.itv != null && loadedData.planItvID > 0 && loadedData.status.step < 1);
                                break;
                            case "cancelReport":
                                targetData.hidden = !(loadedData.itv != null && loadedData.planItvID > 0 && loadedData.status.step === 1 && loadedData.itv.employeeID > 0 && loadedData.itv.statusID <= 6);//statusID <= Créé+Modifier
                                targetData.disabled = targetData.hidden;
                                break;
                            case "generatePackFiles":
                                targetData.hidden = !(loadedData.itv != null && loadedData.planItvID > 0 && loadedData.status.step < 3 && loadedData.filePackage);
                                targetData.disabled = !(loadedData.itv != null && loadedData.planItvID > 0 && loadedData.status.step < 1 && loadedData.filePackage);
                                break;
                            case "loadPreview":
                                targetData.hidden = (loadedData.status.step !== 2);
                                targetData.disabled = targetData.hidden;
                                break;

                            case "editFormElem":
                                targetData.hidden = (loadedData.status.step > 1);
                                targetData.disabled = targetData.hidden;
                                break;
                            case "sendSms":
                                targetData.hidden = (loadedData.status.step > 1);
                                targetData.disabled = targetData.hidden;
                                break;
                            default: break;
                        }
                    }
                    break;
                case "showElement":
                case "showElementOnly":
                case "hideElement":
                    var cNewValue4 = !(actionKey === "showElement" || actionKey === "showElementOnly");

                    var cptTargetE = targetData;
                    var flagNoRerender = false;
                    if (altValue === "currValue") {
                        if (componentArgs && (componentArgs.value || componentArgs.value === false)) {
                            altValue = componentArgs.value;
                        }
                        else {
                            altValue = componentData.defaultValue;
                        }
                    }
                    else if (altValue === "getValue") {
                        if (componentArgs && componentArgs.value) {
                            altValue = componentArgs.value;
                        }
                        else {
                            altValue = componentData.functionManager?.getValue ? componentData.functionManager?.getValue() : componentData.defaultValue;
                        }
                    }
                    else if (altValue === "targetValue") {
                        altValue = targetData.defaultValue;
                        cptTargetE = componentData;
                        flagNoRerender = true;
                    }
                    else if (altValue === "targetGetValue") {
                        altValue = targetData.functionManager?.getValue ? targetData.functionManager?.getValue() : targetData.defaultValue;
                        cptTargetE = componentData;
                        flagNoRerender = true;
                    }
                    else if (altValue === "targetGetValues") {
                        altValue = getValues(target);
                        cptTargetE = componentData;
                        flagNoRerender = true;
                    }

                    if (contextType === 'string') altValue = altValue?.toString();

                    //console.debug(cptTargetE);
                    //console.debug(value);
                    //console.debug(altValue);

                    var cFlag7 = false;
                    switch (operatorTest) {
                        case "=": cFlag7 = (value === altValue); break;
                        case "!=": cFlag7 = (value !== altValue); break;
                        case "<": cFlag7 = (value < altValue); break;
                        case "<=": cFlag7 = (value <= altValue); break;
                        case ">": cFlag7 = (value > altValue); break;
                        case ">=": cFlag7 = (value >= altValue); break;
                        default:
                            break;
                    }

                    if (cFlag7) {
                        /*if (actionKey !== "showElement")*/ cptTargetE.hidden = cNewValue4;
                        if (!flagNoRerender) cptTargetE.functionManager.rerender();
                    }
                    else {
                        if (actionKey === "showElement") cptTargetE.hidden = !cNewValue4;
                        if (!flagNoRerender) cptTargetE.functionManager.rerender();
                    }
                    break;
                case "hideWithCondition":
                    var cNewValueHWC = !(actionKey === "showElement" || actionKey === "hideWithCondition");

                    var cptTargetHWC = targetData;
                    var flagNoRerenderHWC = false;
                    var testValueHWC;
                    if (altValue === "currValue") {
                        if (componentArgs && componentArgs.value) {
                            testValueHWC = componentArgs.value;
                        }
                        else {
                            testValueHWC = componentData.defaultValue;
                        }
                    }
                    else if (altValue === "targetValue") {
                        testValueHWC = targetData.defaultValue;
                        cptTargetHWC = componentData;
                        flagNoRerenderHWC = true;
                    }
                    else if (!altValue && commonFunc.isBlank(altValue)) {
                        testValueHWC = componentArgs?.value;
                    }

                    //console.debug(cptTargetHWC);
                    //console.debug(value);
                    //console.debug(testValueHWC);

                    var cFlag6 = false;
                    switch (operatorTest) {
                        case "=": cFlag6 = (value === testValueHWC); break;
                        case "!=": cFlag6 = (value !== testValueHWC); break;
                        case "<": cFlag6 = (value < testValueHWC); break;
                        case "<=": cFlag6 = (value <= testValueHWC); break;
                        case ">": cFlag6 = (value > testValueHWC); break;
                        case ">=": cFlag6 = (value >= testValueHWC); break;
                        default:
                            break;
                    }

                    if (cFlag6) {
                        /*if (cNewValueHWC)*/ cptTargetHWC.hidden = cNewValueHWC;
                        if (!flagNoRerenderHWC) cptTargetHWC.functionManager.rerender();
                    }
                    else {
                        if (!cNewValueHWC) cptTargetHWC.hidden = !cNewValueHWC;
                        if (!flagNoRerenderHWC) cptTargetHWC.functionManager.rerender();
                    }
                    break;


                case "collapseTarget":
                    var newCValue;
                    if (componentData?.objType === "collapsable") {
                        newCValue = componentData.functionManager.getValue();
                        componentData.functionManager.setValue(!newCValue);
                        componentData.functionManager.rerender();
                    }
                    else {
                        newCValue = targetData.hidden;
                    }
                    //targetData.functionManager.setVisible(newCValue);
                    targetData.hidden = !newCValue;
                    targetData.functionManager.rerender();
                    break;

                case "destroyField":
                    //targetData.objType = "none";
                    //targetData.functionManager.getParentProps()?.parentData?.functionManager?.rerender();
                    break;


                case "clickTarget"://triggerclick
                    if (/*componentData?.objType === "button" && */componentData?.functionManager?.performClick) {
                        componentData.functionManager.performClick();
                    }
                    break;

                case "manipulateData":
                    if (targetValue) {
                        var cptTargetMD = targetData;
                        //var flagNoRerenderMD = false;
                        var testValueMD = altValue;
                        if (altValue === "currValue") {
                            if (componentArgs && componentArgs.value) {
                                testValueMD = componentArgs.value;
                            }
                            else {
                                testValueMD = componentData.defaultValue;
                            }
                        }
                        else if (altValue === "targetValue") {
                            testValueMD = targetData.defaultValue;
                            cptTargetMD = componentData;
                            //flagNoRerenderMD = true;
                        }
                        else if (!altValue && commonFunc.isBlank(altValue)) {
                            testValueMD = componentArgs?.value;
                        }

                        var cFlagMD = true;
                        if (operatorTest) {
                            cFlagMD = false;
                            switch (operatorTest) {
                                case "=": cFlagMD = (value === testValueMD); break;
                                case "!=": cFlagMD = (value !== testValueMD); break;
                                case "<": cFlagMD = (value < testValueMD); break;
                                case "<=": cFlagMD = (value <= testValueMD); break;
                                case ">": cFlagMD = (value > testValueMD); break;
                                case ">=": cFlagMD = (value >= testValueMD); break;
                                default:
                                    break;
                            }
                        }

                        if (cFlagMD) {
                            cptTargetMD[targetValue.key] = targetValue.value;
                        }
                        else {
                            cptTargetMD[targetValue.key] = targetValue.altValue;
                        }
                        cptTargetMD.functionManager.rerender();
                    }

                    break;



                    /*********** GESTION COMPTES ***********/

                case "loadAccessLst":

                    //TODO : Chargement de la liste de profils d'accès

                    break;
                case "loadTeamsLst":

                    //TODO : Chargement de la liste des équipes

                    break;

                case "togglePassword":
                    var isPassword = targetData.subType === "password";
                    if (targetData.functionManager) {
                        targetData.subType = (isPassword ? "" : "password");
                        if (targetData.functionManager.rerender) targetData.functionManager.rerender();
                    }

                    if (altValue) {
                        var iconBtnData = dataList[commonFunc.camelize(altValue, true)];
                        if (iconBtnData && iconBtnData.customDesign && iconBtnData.customDesign.designIcon) {
                            iconBtnData.customDesign.designIcon.icon = isPassword ? "fa_eye_slash" : "fa_eye";
                        }
                    }

                    break;
                case "createUserAccess":
                    var currentDataUA = altValue || getValues();

                    var infosPwd = currentDataUA.pwdStrength;
                    if (infosPwd.value >= 80) {

                        if (modalRoot) {
                            modalRoot.unmount();
                            modalRoot = null;
                        }

                        Swal.fire({
                            title: 'Création en cours...',
                            didOpen: () => { Swal.showLoading() },
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                        });

                        var userName = loadedData.name.toLowerCase() + "." + loadedData.firstName.toLowerCase();
                        var userEmail = currentDataUA.email;


                        //TEMP
                        var access = currentDataUA.roles || "";
                        var sites = {};
                        sites = sites.split ? sites : loadedData.siteID.toString();


                        //TODO : vérification sur le contenu de sites/access/teams + Email saisie
                        if (!commonFunc.isBlank(userEmail) && !commonFunc.isBlank(sites)) {

                            var asArgsCUA = {};
                            if (componentArgs && Object.keys(componentArgs).length && componentArgs.url && componentArgs.id) {
                                Object.keys(componentArgs).forEach((key) => {
                                    var valueArgs = componentArgs[key];
                                    if (valueArgs?.startsWith && valueArgs.startsWith("prop:")) asArgsCUA[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                                    else asArgsCUA[key] = valueArgs;
                                });

                                //aspnetusers >> ApplicationUser >> Compte principal
                                var accountUserObj = {};
                                accountUserObj.IDUser = 0;
                                accountUserObj.UserLogin = userEmail;//userName;
                                //accountUserObj.NormalizedUserName = userName;
                                accountUserObj.UserEmail = userEmail;
                                accountUserObj.UserPassword = commonFunc.parseBool(currentDataUA.useInvitation) ? "" : currentDataUA.userPwd;
                                accountUserObj.UseInvitation = commonFunc.parseBool(currentDataUA.useInvitation);
                                accountUserObj.EmailConfirmation = commonFunc.parseBool(currentDataUA.emailConfirmation);
                                //accountUserObj.NormalizedEmail = userEmail;
                                //EmailConfirmed
                                //PasswordHash
                                //SecurityStamp
                                //ConcurrencyStamp
                                //PhoneNumber
                                //PhoneNumberConfirmed
                                //accountUserObj.TwoFactorEnabled = false;
                                //accountUserObj.LockoutEnd = "";
                                //accountUserObj.LockoutEnabled = false;

                                accountUserObj.Status = true;
                                //accountUserObj.Connection = {};
                                //accountUserObj.UserLogin = "";
                                //accountUserObj.Provider = "";
                                //accountUserObj.ProviderKey = "";
                                //accountUserObj.ClientID = loadedData.siteID;
                                accountUserObj.UserPrimarySid = currentDataUA.customRightType;
                                accountUserObj.UserPrimaryGroupId = currentDataUA.customAccountType;
                                //accountUserObj.RegisteredOn = "";
                                //accountUserObj.Avatar = "";
                                //accountUserObj.TenantId = "";
                                //accountUserObj.TenantUserID = 0;
                                //accountUserObj.SubScriptionID = 1;
                                //accountUserObj.QuotaLimit = 1;
                                //accountUserObj.Telemetry = 1;
                                //accountUserObj.GroupSId = 0;
                                accountUserObj.MatchID = asArgsCUA.id;
                                accountUserObj.Roles = access.split(";");
                                //accountUserObj.Rights = {}; //flags/userID/siteID

                                if (true) {
                                    accountUserObj.UserAccessList = [];
                                    sites.split(";").forEach((siteValue) => {

                                        //gal_users >> TenantUser
                                        var employeeUserObj = {};
                                        employeeUserObj.IDTenantUser = 0;
                                        employeeUserObj.Name = userName;
                                        employeeUserObj.Acl = commonFunc.isBlank(currentDataUA.customGroupsRights) ? "%" : currentDataUA.customGroupsRights;//access //$("#aupd_accessList").val().join(';') + ';';
                                        //employeeUserObj.StartDate = "";
                                        //employeeUserObj.EndDate = "";
                                        if (asArgsCUA.url?.indexOf("Client")) {
                                            delete employeeUserObj.EmployeeID;
                                            employeeUserObj.ClientID = asArgsCUA.id;
                                        }
                                        else {
                                            delete employeeUserObj.ClientID;
                                            employeeUserObj.EmployeeID = asArgsCUA.id;
                                        }
                                        //employeeUserObj.ClientID = -1;
                                        //employeeUserObj.ProviderID = -1;
                                        employeeUserObj.PrimarySid = currentDataUA.customRightType;
                                        employeeUserObj.PrimaryGroupId = currentDataUA.customAccountType;
                                        employeeUserObj.IsActive = true;
                                        employeeUserObj.IsDefault = (loadedData.siteID === parseInt(siteValue));
                                        //employeeUserObj.IsReadOnly = false;
                                        //employeeUserObj.SubscriptionID = 1;

                                        //TenantID
                                        employeeUserObj.LocalUserID = 0;
                                        employeeUserObj.LocalSiteID = siteValue;
                                        //TenantUserAccessID

                                        console.debug(employeeUserObj);
                                        accountUserObj.UserAccessList.push(employeeUserObj);
                                        /*commonFunc.postMethod("../api/employee/CreateEmployeeAccess", args).then((response) => {
                                            var data = response.data;
                                            if (data && data.isSuccess) {
            
            
                                            } else {
                                                Swal.fire({
                                                    icon: 'error',
                                                    title: 'Echec',
                                                    html: "Echec de la création des accès <p>" + data.errorMessage + "</p>",
                                                    didOpen: () => { Swal.hideLoading() }
                                                });
                                            }
                                        });*/
                                    });
                                }
                                commonFunc.postMethod("../" + asArgsCUA.url, accountUserObj).then((response) => {
                                    var data = response.data;
                                    if (data && data.isSuccess) {

                                        //var infos = data.comments.split(';');
                                        Swal.fire({
                                            icon: 'success',
                                            title: 'Création du compte effectuée',
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            //html: "Utilisateur : " + infos[1] + "<br>Mot de passe : " + infos[2] + "<br>Email : " + infos[3],
                                            html: "Utilisateur : " + userName + "<br>Mot de passe : " + currentDataUA.userPwd + "<br>Email : " + userEmail,
                                            didOpen: () => { Swal.hideLoading() }
                                        }).then(function () {
                                            onActionRequired(tag, { trigger: "refreshElem" }, componentData, componentArgs).then((responseLoad) => {
                                                responseAction = responseLoad;
                                                resolve(responseAction);
                                            });

                                            chainEvents(componentData, value);
                                        });

                                    } else {
                                        Swal.fire({
                                            icon: 'error',
                                            title: 'Echec',
                                            html: "Echec de la création du compte <p>" + data.errorMessage + "</p>",
                                            didOpen: () => { Swal.hideLoading() }
                                        });
                                    }
                                });

                            }
                            else {
                                responseAction.errorMessage = "Impossible d'effectuer cette action : Erreur configuration";
                                resolve(responseAction);
                            }
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Echec',
                                html: "Mail/Sites non saisie",
                                didOpen: () => { Swal.hideLoading() }
                            });
                        }
                    }
                    else {
                        Swal.fire({
                            icon: 'warning',
                            title: t("gal_warning"),
                            html: t("register_errorPwdStrength"),
                        });
                    }
                    break;
                case "createAccess":

                    Swal.fire({
                        title: 'Création en cours...',
                        didOpen: () => { Swal.showLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    });

                    var sitesCA = getValues("sites");
                    var accessCA = getValues("access");
                    var teams = getValues("teams");

                    if (loadedData) {
                        var userNameCA = loadedData.name.toLowerCase() + "." + loadedData.firstName.toLowerCase();
                        var userEmailCA = loadedData.email;


                        //TEMP
                        sitesCA = sitesCA.split ? sitesCA : loadedData.siteID.toString();


                        //TODO : vérification sur le contenu de sites/access/teams + Email saisie
                        if (!commonFunc.isBlank(userEmailCA) && !commonFunc.isBlank(sitesCA)) {

                            var asArgsAC = {};
                            if (componentArgs && Object.keys(componentArgs).length && componentArgs.url && componentArgs.id) {
                                Object.keys(componentArgs).forEach((key) => {
                                    var valueArgs = componentArgs[key];
                                    if (valueArgs?.startsWith && valueArgs.startsWith("prop:")) asArgsAC[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                                    else asArgsAC[key] = valueArgs;
                                });

                                //aspnetusers >> ApplicationUser >> Compte principal
                                var accountUserObjCA = {};
                                accountUserObjCA.IDUser = 0;
                                accountUserObjCA.UserLogin = userNameCA;
                                //accountUserObjCA.NormalizedUserName = userNameCA;
                                accountUserObjCA.UserEmail = userEmailCA;
                                //accountUserObjCA.NormalizedEmail = userEmail;
                                //EmailConfirmed
                                //PasswordHash
                                //SecurityStamp
                                //ConcurrencyStamp
                                //PhoneNumber
                                //PhoneNumberConfirmed
                                //accountUserObjCA.TwoFactorEnabled = false;
                                //accountUserObjCA.LockoutEnd = "";
                                //accountUserObjCA.LockoutEnabled = false;

                                accountUserObjCA.Status = true;
                                //accountUserObjCA.Connection = {};
                                //accountUserObjCA.UserLogin = "";
                                //accountUserObjCA.Provider = "";
                                //accountUserObjCA.ProviderKey = "";
                                //accountUserObjCA.ClientID = loadedData.siteID;
                                accountUserObjCA.UserPrimarySid = 2;//rightsType.classic
                                accountUserObjCA.UserPrimaryGroupId = 1;//accountType.employee
                                //accountUserObjCA.RegisteredOn = "";
                                //accountUserObjCA.Avatar = "";
                                //accountUserObjCA.TenantId = "";
                                //accountUserObjCA.TenantUserID = 0;
                                //accountUserObjCA.SubScriptionID = 1;
                                accountUserObjCA.QuotaLimit = 1;
                                accountUserObjCA.Telemetry = 1;
                                //accountUserObjCA.GroupSId = 0;
                                accountUserObjCA.MatchID = asArgsAC.id;
                                accountUserObjCA.Roles = accessCA.split(";");
                                //accountUserObjCA.Rights = {}; //flags/userID/siteID

                                if (true) {
                                    accountUserObj.UserAccessList = [];
                                    sitesCA.split(";").forEach((siteValue) => {

                                        //gal_users >> TenantUser
                                        var employeeUserObj = {};
                                        employeeUserObj.IDTenantUser = 0;
                                        employeeUserObj.Name = userNameCA;
                                        employeeUserObj.Acl = teams || "%";//access //$("#aupd_accessList").val().join(';') + ';';
                                        //employeeUserObj.StartDate = "";
                                        //employeeUserObj.EndDate = "";
                                        employeeUserObj.EmployeeID = asArgsAC.id;
                                        //employeeUserObj.ClientID = -1;
                                        //employeeUserObj.ProviderID = -1;
                                        employeeUserObj.PrimarySid = 2;//rightsType.classic
                                        employeeUserObj.PrimaryGroupId = 1;//accountType.employee
                                        employeeUserObj.IsActive = true;
                                        employeeUserObj.IsDefault = (loadedData?.siteID === parseInt(siteValue));
                                        //employeeUserObj.IsReadOnly = false;
                                        //employeeUserObj.SubscriptionID = 1;

                                        //TenantID
                                        employeeUserObj.LocalUserID = 0;
                                        employeeUserObj.LocalSiteID = siteValue;
                                        //TenantUserAccessID

                                        console.debug(employeeUserObj);
                                        accountUserObjCA.UserAccessList.push(employeeUserObj);
                                        /*commonFunc.postMethod("../api/employee/CreateEmployeeAccess", args).then((response) => {
                                            var data = response.data;
                                            if (data && data.isSuccess) {
            
            
                                            } else {
                                                Swal.fire({
                                                    icon: 'error',
                                                    title: 'Echec',
                                                    html: "Echec de la création des accès <p>" + data.errorMessage + "</p>",
                                                    didOpen: () => { Swal.hideLoading() }
                                                });
                                            }
                                        });*/
                                    });
                                }
                                commonFunc.postMethod("../" + asArgsAC.url, accountUserObjCA).then((response) => {
                                    var data = response.data;
                                    if (data && data.isSuccess) {

                                        var infos = data.comments.split(';');
                                        Swal.fire({
                                            icon: 'success',
                                            title: 'Création du compte effectuée',
                                            allowOutsideClick: false,
                                            allowEscapeKey: false,
                                            html: "Utilisateur : " + infos[1] + "<br>Mot de passe : " + infos[2] + "<br>Email : " + infos[3],
                                            didOpen: () => { Swal.hideLoading() }
                                        }).then(function () {
                                            onActionRequired(tag, { trigger: "refreshElem" }, componentData, componentArgs).then((responseLoad) => {
                                                responseAction = responseLoad;
                                                resolve(responseAction);
                                            });

                                            chainEvents(componentData, value);
                                        });

                                    } else {
                                        Swal.fire({
                                            icon: 'error',
                                            title: 'Echec',
                                            html: "Echec de la création du compte <p>" + data.errorMessage + "</p>",
                                            didOpen: () => { Swal.hideLoading() }
                                        });
                                    }
                                });

                            }
                            else {
                                responseAction.errorMessage = "Impossible d'effectuer cette action : Erreur configuration";
                                resolve(responseAction);
                            }
                        }
                        else {
                            Swal.fire({
                                icon: 'error',
                                title: 'Echec',
                                html: "Mail/Sites non saisie",
                                didOpen: () => { Swal.hideLoading() }
                            });
                        }
                    }



                    /*var id = getDtSelID("lstData");
                    Swal.fire({
                        title: 'Création en cours...',
                        onOpen: () => { Swal.showLoading() },
                    });

                    var employeeUserObj = {};
                    employeeUserObj.AccessLst = $("#aupd_accessList").val().join(';') + ';';
                    employeeUserObj.userAccount = {};
                    employeeUserObj.userAccount.MatchID = id;

                    postMethod("../login/CreateEmployeeUser", employeeUserObj, function (data) {
                        if (data.isSuccess) {
                            var infos = data.comments.split(';');
                            Swal.fire({
                                type: 'success',
                                title: 'Création des accès effectuée',
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                html: "Utilisateur : " + infos[1] + "<br>Mot de passe : " + infos[2] + "<br>Email : " + infos[3],
                                onBeforeOpen: () => { Swal.hideLoading() }
                            }).then(function () {
                                $("#btnActDetailsRefresh").click();
                            });
                        }
                        else {
                            Swal.fire({
                                type: 'error',
                                title: 'Echec',
                                html: "Echec de la création des accès <p>" + data.errorMessage + "</p>",
                                onBeforeOpen: () => { Swal.hideLoading() }
                            });
                        }
                    });*/

                    break;
                case "generateAccess":

                    //TODO : Update des accès Sites / Roles / Teams

                    /*var sites = getValues("sites");
                    var access = getValues("access");
                    var teams = getValues("teams");



                    Swal.fire({
                        title: 'Mise à jour en cours...',
                        onOpen: () => { Swal.showLoading() },
                    });
                    var employeeUserObj = $("#btnClbUpdateAcc").data("accountObj");
                    employeeUserObj.AccessLst = $("#aupd_accessList").val().join(';') + ';';
                    var sites = $("#aupd_sitesList").val();
                    var newContracts = [];
                    $.each(sites, function (i, e) {
                        //TODO : récup ID contrat ?
                        newContracts.push({ id: 0, extId: parseInt(e) });
                    });
                    employeeUserObj.contracts = newContracts;

                    postMethod("../login/UpdateEmployeeUser", employeeUserObj, function (data) {
                        if (data.isSuccess) {
                            Swal.fire({
                                type: 'success',
                                title: 'Succès',
                                html: "Mise à jour des accès effectuée",
                                onBeforeOpen: () => { Swal.hideLoading() }
                            }).then(function () {
                                $("#btnActDetailsRefresh").click();
                            });
                        }
                        else {
                            Swal.fire({
                                type: 'error',
                                title: 'Echec',
                                html: "Echec de mise à jour des accès <p>" + data.errorMessage + "</p>",
                                onBeforeOpen: () => { Swal.hideLoading() }
                            });
                        }
                    });*/

                    break;
                case "resetPassword":
                    var asArgsRP = {};
                    if (componentArgs && Object.keys(componentArgs).length && componentArgs.url && componentArgs.id) {
                        Object.keys(componentArgs).forEach((key) => {
                            var valueArgs = componentArgs[key];
                            if (valueArgs?.startsWith && valueArgs.startsWith("prop:")) asArgsRP[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                            else asArgsRP[key] = valueArgs;
                        });

                        var cId = asArgsRP.bindID;
                        if (parseInt(cId) > 0) {
                            var title = loadedData?.firstName + " " + loadedData?.name;

                            Swal.fire({
                                icon: 'question',
                                title: 'Réinitialisation de mot de passe',
                                html: "Souhaitez-vous réinitialiser le mot de passe [" + title + "] ?",
                                showCancelButton: true,
                                confirmButtonColor: '#28a745',
                                cancelButtonColor: '#dc3545',
                                confirmButtonText: 'Confirmer',
                                cancelButtonText: 'Annuler'
                            }).then((result) => {
                                if (result.value) {
                                    Swal.fire({
                                        title: 'Réinitialisation en cours...',
                                        didOpen: () => { Swal.showLoading() },
                                    });

                                    commonFunc.postMethod("../" + asArgsRP.url, asArgsRP).then((response) => {
                                        var data = response.data;
                                        if (data && data.isSuccess) {
                                            Swal.fire({
                                                icon: 'success',
                                                title: 'Réinitialisation Mot de passe',
                                                html: "Mot de passe réinitialisé avec succès<p>[" + title + "] " + data.result + "</p>",
                                                allowOutsideClick: false,
                                                allowEscapeKey: false,
                                            }).then((result) => {
                                                onActionRequired(tag, { trigger: "refreshElem" }, componentData, componentArgs).then((responseLoad) => {
                                                    responseAction = responseLoad;
                                                    resolve(responseAction);
                                                });

                                                chainEvents(componentData, value);
                                            });
                                        } else {
                                            if (data.errorCode === 0) {
                                                Swal.fire({
                                                    icon: "warning",
                                                    title: "Attention",
                                                    text: data.errorMessage,
                                                    didOpen: () => { Swal.hideLoading() }
                                                });
                                            }
                                            else {
                                                Swal.fire({
                                                    icon: "error",
                                                    title: "Echec",
                                                    html: "Echec de réinitialisation,<p>" + data.errorMessage + "</p>",
                                                    didOpen: () => { Swal.hideLoading() }
                                                });
                                            }
                                        }
                                    });
                                }
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                text: "Aucun élement valide"
                            });
                        }
                    
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'effectuer cette action : Erreur configuration";
                        resolve(responseAction);
                    }

                    /*var id = getDtSelID("lstData");
                                if (parseInt(id) > 0) {
                                    var title = getDtValue("lstData", id, "Prenom") + " " + getDtValue("lstData", id, "Nom");

                                    Swal.fire({
                                        type: 'question',
                                        title: 'Changement de mot de passe',
                                        html: "Souhaitez-vous changer le mot de passe de ce collaborateur [" + title + "] ?",
                                        showCancelButton: true,
                                        confirmButtonColor: '#28a745',
                                        cancelButtonColor: '#dc3545',
                                        confirmButtonText: 'Confirmer',
                                        cancelButtonText: 'Annuler'
                                    }).then((result) => {
                                        if (result.value) {
                                            Swal.fire({
                                                title: 'Modification en cours...',
                                                onOpen: () => { swal.showLoading() },
                                            });

                                            var uid = $("#btnChangePwd").data("bindid");
                                            //alert(uid);
                                            postMethod("../login/ResetAccountPwd", { value: uid, id: id }, function (data) {
                                                if (data && data.isSuccess) {
                                                    loadTech(id);
                                                    Swal.fire({
                                                        type: 'success',
                                                        title: 'Reset Compte Utilisateur',
                                                        html: "Compte Reset avec succès<p>[" + title + "] " + data.result + "</p>",
                                                        allowOutsideClick: false,
                                                        allowEscapeKey: false,
                                                    });

                                                } else {
                                                    if (data.errorCode == 0) {
                                                        Swal.fire({
                                                            type: "warning",
                                                            title: "Attention",
                                                            text: data.errorMessage
                                                        });
                                                    }
                                                    else {
                                                        Swal.fire({
                                                            type: "error",
                                                            title: "Echec",
                                                            html: "Echec d'enregistrement,<p>" + data.errorMessage + "</p>"
                                                        });
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                                else {
                                    Swal.fire({
                                        type: "error",
                                        title: "Echec",
                                        text: "Aucun collaborateur n'est sélectionné"
                                    });
                                }*/
                    break;
                case "changePassword":
                    var currentDataCPWD = altValue || getValues();

                    var infosPwdCPWD = currentDataCPWD.pwdStrength;
                    if (infosPwdCPWD.value >= 80) {

                        //DEMANDE 14/11/24 : Ne pas dépendre de accountUser.employeeID
                        var employeeID = loadedData?.accountUser?.employeeID;
                        if (componentArgs && Object.keys(componentArgs).length && componentArgs.id) {
                            var asArgsCP = {};
                            Object.keys(componentArgs).forEach((key) => {
                                var valueArgs = componentArgs[key];
                                if (valueArgs?.startsWith && valueArgs.startsWith("prop:")) asArgsCP[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                                else asArgsCP[key] = valueArgs;
                            });
                            if (asArgsCP.id > 0) employeeID = asArgsCP.id;
                        }


                        currentDataCPWD.id = loadedData?.accountUser?.localUserID;//idTenantUser
                        currentDataCPWD.matchID = employeeID;
                        currentDataCPWD.primaryGroupId = loadedData?.accountUser?.primaryGroupId;
                        currentDataCPWD.primarySId = loadedData?.accountUser?.primarySid;

                        commonFunc.postMethod("../" + url, currentDataCPWD).then((response) => {
                            Swal.close();
                            var data = response.data;
                            if (data && data.isSuccess) {
                                Swal.fire({
                                    icon: "success",
                                    title: t("gal_success"),
                                    html: t("gal_successUpd"),
                                    didOpen: () => { Swal.hideLoading() },
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    allowEnterKey: false,
                                }).then((result) => {
                                    //Refresh ???
                                });

                                data.result.idResponse = data.result.idClient;
                                //resolve(data.result);

                                responseAction.isSuccess = true;
                                responseAction.result = true;
                            } else {
                                var supErrors = "";
                                if (data.errors && data.errors.length) {
                                    supErrors = data.errors.map((error) => {
                                        return "<br>" + error.desc + "(" + error.value + ")";
                                    });
                                }
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_fail"),
                                    html: t("gal_errorSave") + " :<br>" + data.errorMessage + supErrors
                                });
                                //resolve(data);
                            }
                            if (modalRoot) {
                                modalRoot.unmount();
                                modalRoot = null;
                            }
                            resolve(responseAction);
                        });
                    }
                    else {
                        Swal.fire({
                            icon: 'warning',
                            title: t("gal_warning"),
                            html: t("register_errorPwdStrength"),
                        });
                    }
                    break;

                case "disableAccount":

                    var asArgsDA = {};
                    if (componentArgs && Object.keys(componentArgs).length && componentArgs.url && componentArgs.id) {
                        Object.keys(componentArgs).forEach((key) => {
                            var valueArgs = componentArgs[key];
                            if (valueArgs?.startsWith && valueArgs.startsWith("prop:")) asArgsDA[key] = (dataList[commonFunc.camelize(valueArgs.replace("prop:", ""), true)] || {}).defaultValue;
                            else asArgsDA[key] = valueArgs;
                        });
                    
                        if (parseInt(asArgsDA.bindID) > 0) {
                            Swal.fire({
                                icon: 'warning',
                                title: 'Désactivation du compte',
                                html: "Voulez-vous désactiver les accès pour ce compte ?",
                                showCancelButton: true,
                                confirmButtonColor: '#28a745',
                                cancelButtonColor: '#dc3545',
                                confirmButtonText: 'Confirmer',
                                cancelButtonText: 'Annuler'
                            }).then((result) => {
                                if (result.value) {
                                    Swal.fire({
                                        title: 'Désactivation en cours...',
                                        didOpen: () => { Swal.showLoading() },
                                    });

                                    commonFunc.postMethod("../" + asArgsDA.url, asArgsDA).then((response) => {
                                        var data = response.data;
                                        if (data && data.isSuccess) {
                                            Swal.fire({
                                                icon: 'success',
                                                title: 'Succès',
                                                html: "Désactivation effectuée avec succès",
                                                didOpen: () => { Swal.hideLoading() }
                                            }).then((result) => {
                                                onActionRequired(tag, { trigger: "refreshElem" }, componentData, componentArgs).then((responseLoad) => {
                                                    responseAction = responseLoad;
                                                    resolve(responseAction);
                                                });

                                                chainEvents(componentData, value);
                                            });
                                        } else {
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Echec',
                                                html: "Echec de désactivation du compte <p>" + data.errorMessage + "</p>",
                                                didOpen: () => { Swal.hideLoading() }
                                            });
                                        }
                                    });
                                }
                            });
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: "Echec",
                                text: "Aucun élément valide"
                            });
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'effectuer cette action : Erreur configuration";
                        resolve(responseAction);
                    }


                    /*var id = getDtSelID("lstData");
                    var uid = $("#btnChangePwd").data("bindid");

                    Swal.fire({
                        type: 'warning',
                        title: 'Désactivation du compte',
                        html: "Voulez-vous désactiver les accès pour ce compte ?",
                        showCancelButton: true,
                        confirmButtonColor: '#28a745',
                        cancelButtonColor: '#dc3545',
                        confirmButtonText: 'Confirmer',
                        cancelButtonText: 'Annuler'
                    }).then((result) => {
                        if (result.value) {
                            Swal.fire({
                                title: 'Désactivation en cours...',
                                onOpen: () => { Swal.showLoading() },
                            });
                            //TODO
                            postMethod("../api/account/DisableAccount", { userID: uid, bindID: id }, function (data) {
                                Swal.close();
                                if (data && data.isSuccess) {
                                    Swal.fire({
                                        type: 'success',
                                        title: 'Succès',
                                        html: "Désactivation effectuée avec succès",
                                    });
                                    $("#btnActDetailsRefresh").click();
                                } else {
                                    Swal.fire({
                                        type: 'error',
                                        title: 'Echec',
                                        html: "Echec de désactivation du compte <p>" + data.errorMessage + "</p>",
                                    });
                                }
                            });
                        }
                    });*/
                    break;

                case "loadAccountStatus":
                    if (targetData && targetData.functionManager && targetData.functionManager.setValue) {
                        //if (!data.result.UserMatchAccountID > 0 || data.result.UserLocalDisable) {
                        if (loadedData?.accountID > 0 && loadedData?.accountUser != null) {
                            var emailTarget = dataList[commonFunc.camelize("CUserEmail", true)];
                            if (emailTarget && emailTarget.functionManager && emailTarget.functionManager.setValue) emailTarget.functionManager.setValue(loadedData.email);

                            if (!loadedData.accountUser.isActive /*|| loadedData.accountUser.employeeID <= 0*/) {//DEMANDE 14/11/24 : Enlever test sur employeeID
                                targetData.functionManager.setValue("Inactif");
                                if (targetData.functionManager.setBackground) targetData.functionManager.setBackground(altValue);
                            }
                            else {
                                targetData.functionManager.setValue("Actif");
                                if (targetData.functionManager.setBackground) targetData.functionManager.setBackground(value);
                            }
                        }
                    }
                    else {
                        responseAction.errorMessage = "Impossible d'affecter la valeur";
                        resolve(responseAction);
                    }
                    break;

                case "generatePwd":
                    if (targetData && targetData.functionManager && targetData.functionManager.setValue) {
                        var confirmPwdData;
                        if (altValue) {
                            confirmPwdData = dataList[commonFunc.camelize(altValue, true)];
                        }

                        clearErrors(commonFunc.camelize(targetData.bindPropResult, true));
                        if (confirmPwdData && confirmPwdData.functionManager) {
                            clearErrors(commonFunc.camelize(confirmPwdData.bindPropResult, true));
                        }
                        if (componentArgs.value) {
                            targetData.subType = "";
                            targetData.disabled = true;
                            targetData.functionManager.setValue("", true);
                            if (confirmPwdData) {
                                confirmPwdData.subType = "";
                                confirmPwdData.disabled = true;
                                if (confirmPwdData.functionManager) confirmPwdData.functionManager.setValue("", true);
                            }

                            //TEMP
                            /*targetData.functionManager.setValue("genPassword");
                            if (confirmPwdData && confirmPwdData.functionManager) {
                                confirmPwdData.functionManager.setValue("genPassword");
                            }*/


                            commonFunc.getMethod("../api/GeneratePassword", null).then((response) => {
                                var data = response.data;
                                if (data && data.isSuccess) {
                                    var genPwd = data.result.replace('\0', '');
                                    targetData.functionManager.setValue(genPwd);
                                    if (confirmPwdData && confirmPwdData.functionManager) {
                                        confirmPwdData.functionManager.setValue(genPwd);
                                    }
                                    modelFctManager.chainEvents(componentData, value);
                                } else {
                                    Swal.fire({
                                        icon: 'error',
                                        title: 'Echec',
                                        html: "Echec de récupération d'un mot de passe généré <p>" + data.errorMessage + "</p>",
                                        didOpen: () => { Swal.hideLoading() }
                                    });
                                }
                            });
                        }
                        else {
                            targetData.subType = "password";
                            targetData.disabled = false;
                            targetData.functionManager.setValue("", true);
                            if (confirmPwdData) {
                                confirmPwdData.subType = "password";
                                confirmPwdData.disabled = false;
                                if (confirmPwdData.functionManager) confirmPwdData.functionManager.setValue("", true);
                            }
                        }
                    }
                    break;

                /*********** FIN GESTION COMPTES ***********/


                /**************** MOBILE FCT ***************/
                case "showReportDetails":
                    Swal.fire({
                        icon: "info",
                        title: "Action",
                        text: "Action impossible en mode aperçu web"
                    });
                    break;
                case "removeParent":
                case "cloneComponent":
                    Swal.fire({
                        icon: "info",
                        title: "Action",
                        text: "Action à finaliser"
                    });
                    //chainEvents(componentData, value);
                    break;
                case "shouldConfirm":
                    Swal.fire({
                        icon: "info",
                        title: "Action",
                        text: "Action à finaliser"
                    });
                    //chainEvents(componentData, value);
                    break;
                case "submitReport":
                    //TODO : saveReport
                    break;



                /************* FIN MOBILE FCT **************/

                case "badgeStatus":
                    break;


                /************* DBT SPEC FCT **************/

                case "manageEncryptResult":
                    if (altValue) {
                        Object.keys(altValue).forEach(key => {
                            var resVal = altValue[key];
                            if (resVal.hasOwnProperty("id") || resVal.hasOwnProperty("tag") || resVal.hasOwnProperty("value")) {
                                if (commonFunc.isBlank(resVal.id)) altValue[key].id = 0;
                                if (commonFunc.isBlank(resVal.tag)) altValue[key].tag = "";
                                if (commonFunc.isBlank(resVal.value)) altValue[key].value = "";
                            }
                            else delete altValue[key];
                        });
                        if (value === "formSave") {
                            setValue(target, JSON.stringify(altValue));
                            var orgExtras = loadedData.orgExtras.filter(orgExtra => orgExtra.tag === target);
                            if (orgExtras?.length) {
                                orgExtras[0].format = "toEncrypt";
                                if (modalRoot) {
                                    modalRoot.unmount();
                                    modalRoot = null;
                                }
                                ref.current.submitForm(true);
                            }
                            else {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Echec',
                                    html: "Informations introuvables",
                                    didOpen: () => { Swal.hideLoading() }
                                });
                            }
                        }
                        else {
                            //TODO : manage orgExtras etc...
                            //commonFunc.setValue(loadedData, target, JSON.stringify(altValue));
                            chainEvents(componentData, value, loadedData);
                        }
                    }
                    break;


                case "keyHelperAction":
                    var keyContext = createRoot(document.createElement('div'));

                    var cbAccess = false;
                    var dataHelper = {};
                    var callbackKeyHelper = async function (type, itemValue) {
                        cbAccess = true;
                        if (type === "rsa") {
                            /*if (dataHelper.functionManager?.getPEM) {
                                dataHelper.functionManager.getPEM().then((pemArgs) => {
                                    console.debug(pemArgs);

                                    pemArgs.item = { name: "sensitiveInformations", value: loadedData?.extras?.sensitiveInformations };

                                    commonFunc.postMethod("../api/data/RefactorAesKeyWithRSA", pemArgs).then((response) => {
                                        var resPPR = response.data;
                                        if (resPPR.isSuccess) {
                                            console.debug(resPPR.result);//AES
                                            console.debug(resPPR.extraInfo);//Encrypted Value


                                            //TODO : decrypt resPPR.result pour decrypt resPPR.extraInfo

                                        }
                                    });

                                });
                            }*/

                            var targetValue = getValues(target);
                            //console.debug(getValues(target));
                            //console.debug(commonFunc.getValue(loadedData, target));
                            //console.debug(targetData?.functionManager?.getValue());
                            if (targetValue) {
                                console.debug("LAUNCH SINGLE");
                                dataHelper.functionManager.managerSingleField({ name: target.replace("extras.", ""), value: targetValue }).then(valueReturned => {
                                    if (valueReturned) chainEvents(componentData, value, valueReturned);
                                });
                            }
                            else {
                                console.debug("LAUNCH EMPTY");
                                chainEvents(componentData, value);
                            }
                        }
                        else {
                            //Si item.value decoded, go next
                            if (itemValue) {
                                //var decodedMsg = await dataHelper.functionManager.decryptAES(encodedItemValue);
                                //console.debug(decodedMsg);
                                chainEvents(componentData, value, JSON.parse(itemValue));
                            }
                            else {
                                console.debug("LAUNCH SINGLE AGAIN !?");
                                dataHelper.functionManager.managerSingleField({ name: "sensitiveInformations", value: loadedData?.extras?.sensitiveInformations }).then(valueReturned => {
                                    if (valueReturned) chainEvents(componentData, value, valueReturned);
                                });
                            }

                            /*if (dataHelper.functionManager?.encryptAES) {
                                var encodedMsg = dataHelper.functionManager.encryptAES("Test via AGenerateModel");
                                console.debug(encodedMsg);
                                if (encodedMsg) {
                                    console.debug("GO DECRYPT");
                                    var decodedMsg = dataHelper.functionManager.decryptAES("Test via AGenerateModel");
                                    console.debug(decodedMsg);
                                }
                            }*/

                            if (keyContext) {
                                keyContext.unmount();
                                keyContext = null;
                            }
                        }
                    };

                    //<AKeyHelperFrag data={{}} />
                    keyContext.render(<AKeyHelperFrag data={dataHelper} endCb={callbackKeyHelper} />);

                    setTimeout(() => {
                        if (!cbAccess && keyContext) {
                            keyContext.unmount();
                            keyContext = null;
                        }
                    }, 5000);
                    break;

                case "materialAutoEmpSite":
                    if (!commonFunc.isBlank(componentArgs.srcData?.extLink)) {
                        var substring = componentArgs.srcData?.extLink.substring(0, 3);
                        if (!commonFunc.isBlank(substring)) {
                            commonFunc.getMethod("../api/site/GetSite", { id: parseInt("53" + substring) }).then((response) => {
                                var dataSite = response.data;
                                if (dataSite.isSuccess) {

                                    var targetNameCpt = dataList[commonFunc.camelize(targetValue, true)];
                                    if (targetNameCpt?.functionManager && targetData?.functionManager && targetData !== componentData) {
                                        targetNameCpt.functionManager.setValue(dataSite.result.name);
                                        targetData.functionManager.setValue(dataSite.result.idSite);

                                        responseAction.isSuccess = true;
                                        responseAction.result = dataSite;
                                        resolve(responseAction);
                                    }
                                    else {
                                        responseAction = dataSite;
                                        resolve(responseAction);
                                    }
                                }
                                else {
                                    responseAction = dataSite;
                                    resolve(responseAction);
                                }
                            });
                        }
                        else {
                            responseAction.isSuccess = false;
                            responseAction.errorMessage = "Code Agence introuvable";
                            resolve(responseAction);
                        }
                    }
                    break;

                case "displayBackMatTicket":
                    if (loadedData) {
                        var showBack = false;
                        var buttonBack = dataList[commonFunc.camelize("cBackMatTicket", true)];

                        commonFunc.getMethod("../api/ticket/GetTickets", { materialId: loadedData.idMaterial, level: 1, state: 7000 }).then((response) => {
                            var dataTickets = response.data;
                            if (dataTickets.isSuccess) {

                                //Récupération Assignation en cours
                                var refExtID = 0;
                                var filteredMtnActive = loadedData.materialAssigns?.filter(assign => assign.service?.refExtID === "608" && assign.statusExt === "EC" && assign.endDate === "2099-12-31");
                                if (filteredMtnActive?.length) {
                                    refExtID = filteredMtnActive[0].idAssign;
                                }

                                if (refExtID) {
                                    console.debug(refExtID);
                                    var filteredTickets = dataTickets.result?.filter(ticket => ticket.extRef === ("MATMTN-" + refExtID));
                                    if (filteredTickets?.length) {
                                        //Cache le bouton retour mat.
                                        if (buttonBack) {
                                            buttonBack.hidden = true;
                                            if (buttonBack.functionManager?.rerender) buttonBack.functionManager.rerender();
                                        }

                                        //Affiche le bouton restitution mat.
                                        var buttonRestore = dataList[commonFunc.camelize("cRestoreMatTicket", true)];
                                        if (buttonRestore) {
                                            buttonRestore.hidden = false;
                                            if (buttonRestore.functionManager?.rerender) buttonRestore.functionManager.rerender();
                                        }

                                        //Affiche bloc ticket
                                        var ticketContainerCpt = dataList[commonFunc.camelize("cTicketContainer", true)];
                                        if (ticketContainerCpt) {
                                            ticketContainerCpt.hidden = false;
                                            if (ticketContainerCpt.functionManager?.rerender) ticketContainerCpt.functionManager.rerender();
                                        }

                                        var ticket = filteredTickets[0];


                                        var ticketIDCpt = dataList[commonFunc.camelize("cTicketID", true)];
                                        if (ticketIDCpt?.functionManager.setValue) ticketIDCpt.functionManager.setValue(ticket.idTicket);

                                        var ticketTitleCpt = dataList[commonFunc.camelize("cTicketTitle", true)];
                                        if (ticketTitleCpt?.functionManager.setValue) ticketTitleCpt.functionManager.setValue(ticket.title);

                                    }
                                    else {
                                        //responseAction.errorMessage = "Impossible d'effectuer cette action : Aucun ticket retrouvé";
                                        responseAction.isSuccess = true;
                                        resolve(responseAction);
                                        showBack = true;
                                    }
                                }
                                else {
                                    //responseAction.errorMessage = "Impossible d'effectuer cette action : Aucune référence retrouvé";
                                    responseAction.isSuccess = true;
                                    resolve(responseAction);
                                    showBack = true;
                                }
                            }
                            else {
                                responseAction = dataTickets;
                                resolve(responseAction);
                                showBack = true;
                            }

                            if (showBack) {
                                //Affiche le bouton retour mat.
                                if (buttonBack) {
                                    buttonBack.hidden = false;
                                    if (buttonBack.functionManager?.rerender) buttonBack.functionManager.rerender();
                                }
                            }
                        });
                    }
                    break;


                case "customReportDlg":
                    var reportModels = null;

                    Swal.fire({
                        title: "Chargement en cours...",
                        didOpen: () => { Swal.showLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                    });

                    commonFunc.getMethod("../api/report/GetReportModels", { id: -1 }).then((responseModels) => {
                        Swal.close();

                        var dataModels = responseModels.data;
                        if (dataModels.isSuccess) {

                            reportModels = {};
                            dataModels.result.models.forEach((model) => {
                                reportModels[model.extID] = JSON.parse(model.value);
                            });



                            var titleCustom = "Envoi des plannings";

                            var modalRoot;
                            if (modalRoot) {
                                modalRoot.unmount();
                                modalRoot = null;
                            }

                            //Traitement des informations retourné par le Dialog
                            var callbackModalCustom = function (data, isUpdate) {
                                return new Promise((resolve, reject) => {
                                    if (data) {
                                        console.debug(data);
                                        if (!(data.localFiles?.length > 0)) {
                                            Swal.fire({
                                                icon: "error",
                                                title: t("gal_fail"),
                                                html: t("gal_insufficientFiles")
                                            });
                                            resolve();
                                            return;
                                        }

                                        addReport(data, {}, isUpdate, { lengthSystem: true, translation: t, noSwal: true }).then((dataResponse) => {
                                            var dataResult = dataResponse.result;
                                            console.debug(dataResponse);

                                            if (dataResult?.idResponse) {
                                                Swal.fire({
                                                    title: t("gal_processing"),
                                                    didOpen: () => { Swal.showLoading() },
                                                    allowOutsideClick: false,
                                                    allowEscapeKey: false,
                                                    allowEnterKey: false,
                                                });

                                                commonFunc.getMethod("../api/report/GetReportFiles", { bindID: dataResult.idReport }).then((responseFiles) => {
                                                    var dataFiles = responseFiles.data;
                                                    if (dataFiles.isSuccess) {
                                                        var file = dataFiles.result[0];//TODO : filter etc.. ??

                                                        //Req CreateFileSummary
                                                        var req = { fileID: parseInt(file.idFile), fileTypeID: parseInt(file.fileTypeID), bindID: parseInt(file.bindID), bindType: "REPORT", OpName: "REPORT_JOB_SPLITPDF" };
                                                        commonFunc.postMethod("../api/report/CreateFileSplit", req).then((response) => {
                                                            Swal.close();
                                                            var data = response.data;
                                                            if (data?.isSuccess) {

                                                                console.debug("PROCESS DONE");

                                                                if (targetData?.functionManager?.loadList) {
                                                                    var newList = [];
                                                                    if (data.result?.length) {
                                                                        newList.push(...data.result.map((itemStr, index) => { return { idItem: index+1, title: itemStr, isSuccess: true }; }));
                                                                    }
                                                                    if (data.extraInfo?.length) {
                                                                        newList.push(...data.extraInfo.map((itemStr, index) => { return { idItem: index+1, title: itemStr, isSuccess: false }; }));
                                                                    }
                                                                    targetData.functionManager.loadList(newList);
                                                                }

                                                            } else {
                                                                //Error Job
                                                                Swal.fire({
                                                                    icon: "error",
                                                                    title: t("gal_error"),
                                                                    html: "Erreur lors du traitement :<br>" + data?.errorMessage
                                                                });
                                                            }
                                                        });


                                                        if (modalRoot) {
                                                            modalRoot.unmount();
                                                            modalRoot = null;
                                                        }
                                                    }
                                                    else {
                                                        Swal.close();
                                                        Swal.fire({
                                                            icon: "error",
                                                            title: t("gal_error"),
                                                            html: "Aucun fichier trouvé"
                                                        });
                                                    }
                                                });
                                            }
                                        });
                                    }
                                    else {
                                        modalRoot.unmount();
                                        resolve();
                                    }
                                });
                            };


                            if (reportModels["DLG_EMPHOURS_SENDMAIL"]) {
                                modalRoot = createRoot(document.createElement('div'));
                                modalRoot.render(<ReportModal parentContext={{ modalGenManager: modalGenManager, props: appProps }} title={titleCustom} configModel={reportModels["DLG_EMPHOURS_SENDMAIL"]} modelsList={reportModels} callback={callbackModalCustom} altSplitMode={true} customFilesTitle={"Téléchargement Planning pour envoi"}></ReportModal>);
                            }
                            else {
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_error"),
                                    html: "Configuration introuvable"
                                });
                            }
                        }
                        else {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_fail"),
                                html: t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                            });
                        }
                    });
                    break;


                /************* FIN SPEC FCT **************/

                default:
                    break;
            }
        });
    }

    function chainEvents(data, chainKey, cptValue) {
        if (!commonFunc.isBlank(chainKey)) {
            if (data.onActionEvents && data.onActionEvents.extrasActionEvent) {
                var args = data.onActionEvents.extrasActionEvent[chainKey];
                if (args) {
                    if (!Array.isArray(args)) args = [args]; //PATCH TEMP
                    args.forEach((triggerItem) => {
                        if (cptValue !== null && cptValue !== undefined) {
                            triggerItem.altValue = cptValue;
                        }
                        onActionRequired(data.name, triggerItem, data, data.argumentsObj).then(actionResponse => {
                            //console.debug("RESPONSE");
                            //console.debug(actionResponse);
                            if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_fail"),
                                    html: actionResponse.errorMessage
                                });
                            }
                            else if (triggerItem.trigger !== chainKey) {
                                modelFctManager.chainEvents(data, triggerItem.trigger);
                            }
                        });
                    });
                }
            }
        }
    }

    function commonRenderProc(data) {
        if (data.hideOnAction && data.hideOnAction.length) {
            data.hideOnAction.forEach((args, index) => {
                onActionRequired(data.name, args, data).then(actionResponse => {
                    //console.debug("RESPONSE");
                    //console.debug(actionResponse);
                    if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_fail"),
                            html: actionResponse.errorMessage
                        });
                    }
                });
            });
        }

        //Gestion après coup des watchers yup
        if (data.attributes?.watcher || data.attributes?.watcherInverse) {
            var labelFor = document.querySelector("[for='input" + commonFunc.camelize(data.bindPropResult, true) + "']");
            if (labelFor) {
                labelFor.classList.add("mandatory");
                labelFor.classList.add("mandatory-alt");
            }
            //console.debug(document.getElementById("input" + commonFunc.camelize(data.bindPropResult, true)));
        }

        if (data.argumentsObj?.connectedCache) modelFctManager.addConnectedCache(data, data.argumentsObj?.connectedCache);
    }

    function finalizeModel(wasRerender) {
        //console.debug("ALL ENDED " + wasRerender);

        var filesProcess = (newFiles) => {
            site.files = newFiles;

            var rerenderCpt = () => {
                if (waitingFilesCpt?.length) {
                    waitingFilesCpt.forEach((dataCpt) => {
                        dataCpt?.functionManager?.rerender();
                    });
                }
                else {
                    //if (genModel?.functionManager?.rerender) genModel.functionManager.rerender(true);
                }
            };


            if (needModuleFiles && parentProps) {
                var extrasType = parentProps.subType || parentProps.type;
                var primaryId = commonFunc.camelize("ID" + commonFunc.capitalize(extrasType), true);
                //var secondaryId = commonFunc.camelize(extrasType + "ID", true);
                var bindID = loadedData ? loadedData[primaryId] : -1;

                commonFunc.getMethod("../api/" + parentProps.type + "/Get" + parentProps.type + "Files", { filetypeID: parentProps.type.toUpperCase(), bindID: bindID, fileID: -1 }).then((responseModule) => {
                    var dataFiles = responseModule.data;

                    if (dataFiles.isSuccess) {
                                /*if (!dataCache.cSysFiles)*/ dataCache.cSysFiles = {};
                        dataCache.cSysFiles["mod" + bindID] = dataFiles.result;
                        rerenderCpt();
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_fail"),
                            html: t("gal_failLoadFiles") + dataFiles.errorMessage
                        });
                    }
                });
            }
            else {
                rerenderCpt();
            }
        };

        var site = appProps?.getSite();
        if (waitingFilesCpt?.length) {
            if (site.getFiles || site.files?.length) {
                if (site.getFiles) {
                    //Attente de la récupération des fichiers
                    setTimeout(() => {
                        finalizeModel(wasRerender);
                    }, 2000);
                    return;
                }
                else {
                    filesProcess(site.files);
                }
            }
            else {
                site.getFiles = true;
                commonFunc.getMethod("../api/site/GetSiteFiles", { filetypeID: "SITE", bindID: site.idSite, fileID: -1 }).then((response) => {
                    site.getFiles = false;
                    var dataFiles = response.data;

                    if (dataFiles.isSuccess) {
                        filesProcess(dataFiles.result);
                    }
                    else {
                        Swal.fire({
                            icon: "error",
                            title: t("gal_fail"),
                            html: t("site.failLoadFiles") + dataFiles.errorMessage
                        });
                    }

                    //Gestion interface après rendu

                    //ref.current.style.setProperty("--temp-img", "url(")
                    //data-backimage
                    var backgroundRequired = document.querySelectorAll("[data-backimage]");
                    backgroundRequired.forEach((node) => {
                        node.style.setProperty("--bg-image", node.getAttributeNode("data-backimage").value);
                        node.style.setProperty("--bg-opacity", node.getAttributeNode("data-imageopacity")?.value);
                    });
                });
                return;
            }
        }

        //Gestion interface après rendu

        //ref.current.style.setProperty("--temp-img", "url(")
        //data-backimage
        var backgroundRequired = document.querySelectorAll("[data-backimage]");
        backgroundRequired.forEach((node) => {
            node.style.setProperty("--bg-image", node.getAttributeNode("data-backimage").value);
            node.style.setProperty("--bg-opacity", node.getAttributeNode("data-imageopacity")?.value);
        });


        //var searchTag = "";
        var markClass = "";
        if (!commonFunc.isBlank(searchTag)) {//data.argumentsObj.cSearchParams
            searchTag = searchTag/*getValues(commonFunc.camelize(itemData.argumentsObj.cSearchParams, true))*/ || "";
            markClass = /*data.argumentsObj.cMarkClass ||*/ "text-danger fw-bold";

            var dialog = document.getElementsByClassName("modal-dialog");
            if (dialog?.length) {
                var targets = document.getElementsByClassName(curGenerateTag);
                if (!commonFunc.isBlank(searchTag) && targets.length) {
                    Array.from(targets).forEach((elemNode, index) => {
                        var markChild = elemNode.getElementsByTagName("mark");
                        if (markChild.length <= 0) {
                            const instance = new Mark(elemNode);
                            instance.mark(searchTag, { className: markClass });
                            instance.mark(searchTag.replace("*", ""), { className: markClass });
                        }
                    });
                }
            }
        }

        if (isStartDuplicate) prepareDuplicate();
    }

    function prepareDuplicate() {
        var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;
        Object.keys(dataList).forEach((key) => {
            var dataElem = dataList[key];
            if (dataElem?.hasOwnProperty("resetOnDuplicate") && dataElem.functionManager && dataElem.functionManager.setValue) {
                dataElem.functionManager.setValue(dataElem.resetOnDuplicate, true);
                if (dataElem.onActionEvents?.extrasActionEvent?.cAfterDuplicate) {
                    dataElem.onActionEvents?.extrasActionEvent?.cAfterDuplicate.forEach((triggerObj) => {
                        onActionRequired(dataElem.name, triggerObj, dataElem).then(actionResponse => {
                            //console.debug("RESPONSE");
                            //console.debug(actionResponse);
                            if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_fail"),
                                    html: actionResponse.errorMessage
                                });
                            }
                        });
                    });
                }
            }
        });
        genModel.templates?.forEach((template) => {
            if (template.onActionEvents?.extrasActionEvent?.cAfterDuplicate) {
                template.onActionEvents?.extrasActionEvent?.cAfterDuplicate.forEach((triggerObj) => {
                    onActionRequired(template.name, triggerObj, template).then(actionResponse => {
                        //console.debug("RESPONSE");
                        //console.debug(actionResponse);
                        if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_fail"),
                                html: actionResponse.errorMessage
                            });
                        }
                    });
                });
            }
        });
        forcedCreate = true;
    }

    function excludeFrag(bindProp, type) {
        if (bindProp) {
            if (bindProp.indexOf(".") >= 0) {
                var exParent = excludeFrag(bindProp.split(".")[0]);
                return bindProp.replace(bindProp.split(".")[0], exParent) + "_" + (type || "temp");
            }
            else {
                return bindProp + "_" + (type || "temp");
            }
        }
        else {
            return "";
        }
    }

    function componentTyped(element, parentElemProps) {
        if (!element.title) element.title = "";
        if (!element.baseConfig) element.baseConfig = {};

        element.key = element.key || cpt;
        element.required = element.attributes && (element.attributes.required !== undefined || (element.attributes.min && parseInt(element.attributes.min) > 0));
        if (!element.argumentsObj && element.arguments) {
            if (typeof element.arguments == "string") element.argumentsObj = JSON.parse(element.arguments);
            else { element.argumentsObj = element.arguments; }
        }

        //Préparation du bindPropResult + stockage dans la liste Composant
        var camelBindProp;
        var preventLoadedData = false;
        if (!commonFunc.isBlank(element.bindPropResult)) {
            if (element.bindPropResult.indexOf("{array}") >= 0) {
                camelBindProp = commonFunc.camelize(element.bindPropResult.replace("{array}", commonFunc.camelize(parentElemProps.parentData.isInfluencedBy || parentElemProps.parentData.bindPropResult, true) + (parentElemProps.parentData.isExcluded ? "_temp" : "") + "[" + parentElemProps.parentData.key + "]"), true);
                preventLoadedData = true;

                var srcListValue = commonFunc.getValue(loadedData, commonFunc.camelize(parentElemProps.parentData.isInfluencedBy || parentElemProps.parentData.bindPropResult, true));
                var srcValueArray = "";
                if (srcListValue?.length && !parentElemProps.parentData.isModel) {
                    var target = srcListValue.filter(elem => elem.cKey === parentElemProps.parentData.key);
                    if (target.length <= 0) target = srcListValue.filter(elem => !elem.cKey);
                    if (target.length) {
                        srcValueArray = commonFunc.getValue(target[0], commonFunc.camelize(element.bindPropResult.replace("{array}.", ""), true));
                        target[0].cKey = parentElemProps.parentData.key;
                    }
                }
                element.defaultValue = srcValueArray || element.defaultValue;
            }
            else {
                camelBindProp = commonFunc.camelize(element.bindPropResult, true);
            }
            curElementList[camelBindProp] = element;
            if (element.isExcluded) curElementList[excludeFrag(camelBindProp, element.subType)] = element;
        }
        else {
            camelBindProp = element.bindPropResult;
        }

        cpt++;

        if (!preventLoadedData && (loadedData && !commonFunc.isBlank(camelBindProp))) {
            if (!element.modalDefault) {
                element.modalDefaultValue = element.defaultValue;
                element.modalDefault = true;
            }
            //console.debug(loadedData);
            var srcValue = commonFunc.getValue(loadedData, camelBindProp);
            /*if (srcValue === undefined) {
                srcValue = commonFunc.getValue(loadedData, element.bindPropResult);
                if (srcValue !== undefined) element.overrideSavePath = element.bindPropResult;
            }*/
            if (element.objType === "picture") {
                if (typeof srcValue === 'object' && !Array.isArray(srcValue) && srcValue !== null) {
                    element.defaultValue = "";//TODO : Downloadfile valide
                }
                else {
                    element.defaultValue = ((srcValue !== null && srcValue !== undefined) ? srcValue : element.defaultValue);
                }
            }
            else {
                element.defaultValue = ((srcValue !== null && srcValue !== undefined) ? srcValue : element.defaultValue);
            }
            if (element.objType === "group" && element.propNameType === "array" && !getValues(camelBindProp)) {
                setValue(camelBindProp, element.defaultValue);
            }
        }

        //Gestion des extras sup collection
        if (!element.loaded && loadedData?.extras && element.objType === "collection" && !commonFunc.isBlank(element.bindPropResult)) {
            //register(camelBindProp + "_btn1");
            Object.keys(loadedData?.extras).forEach(extraKey => {
                if (!getValues("extras." + extraKey) && extraKey.startsWith(camelBindProp.replace("extras.", "") + "_")) {
                    //register("extras." + extraKey);
                    setValue("extras." + extraKey, loadedData?.extras[extraKey]);
                }
            });
        }

        var args = {
            key: element.key,
            data: element,
            formManager: formManager,
            parentDisabled: (parentElemProps ? parentElemProps.parentDisabled : false),
            parentProps: parentElemProps,
            modelFctManager: modelFctManager,
            bindPropResult: (element.isExcluded ? excludeFrag(camelBindProp, element.subType) : (element.overrideSavePath || camelBindProp)),
            tabIndex: parentElemProps?.tabIndex
        };
        switch (element.objType) {
            case "model": return <ReportTabFrag {...args} finalizeModel={finalizeModel} showActionBar={showActionBar} />;
            case "template": return <TabFrag {...args} />;
            case "category": return <CategoryFrag {...args} />;
            case "header": return <HeaderFrag {...args} />;
            case "group":
                /*if (element.groupSubName === "toolbar") {
                    console.debug("ADDTOOLBAR");
                    setToolbarCpts([...toolbarCpts, <GroupFrag {...args} />]);
                    return "";
                }
                else*/ return <GroupFrag {...args} />;
            case "itemsContainer": return <ItemsContainerFrag {...args} />;

            case "image": return <ImageFrag {...args} />;
            case "openFile": return <OpenFileFrag {...args} />;
            case "button": return <ButtonFrag {...args} />;
            case "text": return <EditTextFrag {...args} />;
            case "dropdown":
            case "select":
                return <SpinnerFrag {...args} />;
            case "checkbox": return <CheckboxFrag {...args} />;
            case "radio": return <RadioButtonsFrag {...args} />;
            case "picture": return <PictureFrag {...args} srcFileManager={{ className: curGenerateTag, showContextMenu: showContextMenu, hideAllMenu: hideAllMenu }} />;
            case "textview": return <TextViewFrag {...args} />;
            case "finder": return <FinderFrag {...args} />;
            case "canvas": return <CanvasFrag {...args} />;
            case "collapsable": return <CollapsableFrag {...args} />;
            case "progressBar": return <ProgressBarFrag {...args} />;
            case "chart": return <ChartFrag {...args} accessList={Object.keys(elementList).length > 0 ? elementList : curElementList} />;
            case "planning": return <PlanningFrag {...args} />;
            case "telegestion": return <TelegestionFrag {...args} />;

            case "gridStack": return <GridStackFrag {...args} accessList={Object.keys(elementList).length > 0 ? elementList : curElementList} />;
            case "autoAddress": return <AutoAddressFrag {...args} />;
            case "collection": return <CollectionFrag {...args} contextMenuManager={{ className: curGenerateTag, showContextMenu: showContextMenu, hideAllMenu: hideAllMenu }} />;
            case "gmaps": return <GmapsFrag {...args} />;
            case "addressUnit": return <AddressUnitFrag {...args}  />;
            case "simpleList": return <SimpleListGeneric {...args} accessList={Object.keys(elementList).length > 0 ? elementList : curElementList} />;
            case "widgetList": return <WidgetListGeneric {...args} accessList={Object.keys(elementList).length > 0 ? elementList : curElementList} />;

            case "chat": return <ChatFrag {...args} />;

            /*case "filesCustom":
                var filesSite = appProps?.getSite();

                var entity = "SITE";
                var targetArgs = "Anomalie";
                var fileCustomArgs = {
                    bindID: (filesSite?.idSite || 0), fileTypeID: "SITE",
                    minFiles: 2, maxFiles: 2, accept: { "text/csv": [".csv"] }, uploadAutoClose: true, resetAfterUpload: true, noUploads: false, defaultFileType: "CTG",
                    noChooseTypes: true, onlyUpload: true, badgeRendering: false, withFilters: false, hideSync: true, shouldRender: true, onlyDelete: true, disabled: false
                };
                if (element.argumentsObj) {
                    targetArgs = (element.argumentsObj.target || targetArgs);
                    entity = (element.argumentsObj.entity || entity);

                    if (element.argumentsObj.bindType === "SITE") fileCustomArgs.bindID = (filesSite?.idSite || 0);

                    fileCustomArgs.fileTypeID = (element.argumentsObj.fileTypeID || fileCustomArgs.fileTypeID);


                    fileCustomArgs.minFiles = (element.argumentsObj.minFiles || fileCustomArgs.minFiles);
                    fileCustomArgs.maxFiles = (element.argumentsObj.maxFiles || fileCustomArgs.maxFiles);

                    fileCustomArgs.accept = (element.argumentsObj.accept || fileCustomArgs.accept);
                    fileCustomArgs.defaultFileType = (element.argumentsObj.defaultFileType || fileCustomArgs.defaultFileType);

                    fileCustomArgs.waitForCompletion = ((fileUpReq) => { return fileUpReq.ftype === fileCustomArgs.defaultFileType; });
                    fileCustomArgs.title = (altT(element.argumentsObj.title) || t("gal_attachedFiles"));
                }

                // {...args}
                var files = [];
                return <Col><FilesCustom className="generateDlg-files" checkRights={modelFctManager.checkRights} src={null} srcName={""} files={files} setFiles={(compFiles) => {
                    console.debug(compFiles.length);
                    if (element.argumentsObj.altAction) {
                        var triggerArgs = {};
                        triggerArgs.trigger = element.argumentsObj.altAction;
                        triggerArgs.altValue = compFiles;
                        onActionRequired(element.name, triggerArgs, element).then(actionResponse => {
                            console.debug("RESPONSE");
                            console.debug(actionResponse);
                            if (actionResponse && !actionResponse.isSuccess && (!Swal.isVisible() || actionResponse.forceMessage)) {
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_fail"),
                                    html: actionResponse.errorMessage
                                });
                            }
                        });
                        //TODO : reset files/compFiles ???
                    }
                    else {
                        //Traitement des fichiers en liste
                        if (compFiles.length === 2) {
                            var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;
                            var target = targetArgs;
                            var targetData = (!commonFunc.isBlank(target) ? dataList[commonFunc.camelize(target, true)] : null);
                            if (targetData?.functionManager?.saveList) {
                                targetData.functionManager.saveList({ rowId: "id", data: compFiles.map((file) => { return { id: file.idFile, value: file.name, tag: file.extension }; }) });
                            }
                        }
                        else if (compFiles.length > 0) {
                            Swal.fire({
                                icon: "error",
                                title: t("gal_fail"),
                                html: t("gal_insufficientFiles")
                            });
                        }
                        files = [];
                        compFiles = [];
                    }
                }} altFilesTypes={"../api/" + entity + "/Get" + entity + "FilesType"} altUploadFilesUrl={"../api/" + entity + "/Upload" + entity + "Files"} {...fileCustomArgs} /></Col>;*/
            case "filesCustom":
                var filesSite = appProps?.getSite();
                // {...args}
                if (!element.files) element.files = [];
                return <Col key={args.key}><FilesCustom className="generateDlg-files" title={t("gal_attachedFiles")} bindID={(filesSite?.idSite || 0)} checkRights={modelFctManager.checkRights} fileTypeID={element.argumentsObj?.fileTypeID || "SITE"} src={null} srcName={""}
                    files={element.files} setFiles={(compFiles) => {
                        //console.debug(compFiles.length);
                        if (!element.argumentsObj?.fileType || element.argumentsObj?.fileType === "CTG") {
                            if (compFiles.length === 2) {
                                var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;
                                var target = element.argumentsObj?.targetProc || "Anomalie";
                                var targetData = (!commonFunc.isBlank(target) ? dataList[commonFunc.camelize(target, true)] : null);
                                if (targetData?.functionManager?.saveList) {
                                    targetData.functionManager.saveList({ rowId: "id", data: compFiles.map((file) => { return { id: file.idFile, value: file.name, tag: file.extension }; }) });
                                }
                            }
                            else if (compFiles.length > 0) {
                                Swal.fire({
                                    icon: "error",
                                    title: t("gal_fail"),
                                    html: t("gal_insufficientFiles")
                                });
                            }
                        }
                        else {
                            var dataList = Object.keys(elementList).length > 0 ? elementList : curElementList;
                            var target = element.argumentsObj?.targetProc || "Anomalie";
                            var targetData = (!commonFunc.isBlank(target) ? dataList[commonFunc.camelize(target, true)] : null);
                            if (targetData?.functionManager?.saveList) {
                                targetData.functionManager.saveList({ rowId: "id", data: compFiles.map((file) => { return { id: file.idFile, value: file.name, tag: file.extension }; }) });
                            }
                        }
                        if (element.argumentsObj?.fullFiles) {
                            element.files = compFiles;
                            //compFiles = [];
                            parentElemProps.parentData.functionManager.rerender();
                        }
                        else {
                            element.files = [];
                            compFiles = [];
                        }
                    }} altFilesTypes="../api/site/GetSiteFilesType" altUploadFilesUrl="../api/site/UploadSiteFiles" accept={element.argumentsObj?.accept || { "text/csv": [".csv"] }} noChooseTypes={true} minFiles={element.argumentsObj?.minFiles || 2} uploadAutoClose={true} resetAfterUpload={true}
                    noUploads={element.argumentsObj?.noUploads} onlyUpload={!element.argumentsObj?.fullFiles} badgeRendering={false} withFilters={false} hideSync={true} shouldRender={true} onlyDelete={true} disabled={false} defaultFileType={element.argumentsObj?.fileType || "CTG"} maxFiles={element.argumentsObj?.maxFiles || 2} /></Col>;

            case "files":
                return <FilesFrag {...args} />;

            default: return "";
        }
    }


    function renderData(cfg) {
        curElementList = {};

        var content = componentTyped(cfg);

        return <Form action="" className={`form needs-validation h-100 ${curGenerateTag}`} style={{ flex: 1 }} method="" onSubmit={handleSubmit((data) => { triggerOnSubmit(data, false) }, onError)} autoComplete="off" aria-autocomplete="none">
            {content}
            {children}
            {noButtons ? "" :
                (<><Button className="btn-round mb-3 float-sm-start" color="primary">{t("gal_create")}</Button>
                {isUpdateGen ? <Button className="btn-round mb-3 float-sm-start" color="primary" onClick={() => { handleSubmit((data) => { triggerOnSubmit(data, true) }, onError)() }}>{t("gal_edit")}</Button> : ""}</>)
            }
            <Menu id={`contextMenu-${curGenerateTag}`} onVisibilityChange={() => {/*console.debug(document.querySelector(".contexify") ? document.querySelector(".contexify").outerHTML : "")*/ }}>

                <Item hidden={isItemHidden.bind(this)} data="genFilePhoto" onClick={filePhoto.bind(this)}>
                    <i className="fa fa-camera" aria-hidden="true"></i>&nbsp;{t("gal_takePicture")}
                </Item>
                <Item hidden={isItemHidden.bind(this)} data="genFileDel" onClick={fileDel.bind(this)}>
                    <i className="fa fa-times" aria-hidden="true"></i>&nbsp;{t("gal_remove")}
                </Item>

                <Item hidden={isItemHidden.bind(this)} data="genItemEdit" onClick={editItem.bind(this)}>
                    <i className="fa fa-edit" aria-hidden="true"></i>&nbsp;{t("gal_edit")}
                </Item>
                <Item hidden={isItemHidden.bind(this)} data="genItemDel" onClick={removeItem.bind(this)}>
                    <i className="fa fa-times" aria-hidden="true"></i>&nbsp;{t("gal_remove")}
                </Item>
            </Menu>
        </Form>;
    }

    function prepareMergedDesign(data, designFragment, defaultDesignKey, forcedMerge) {
        if (forcedMerge || !data.mergedDesign) {
            var altDesign = modelFctManager.rootData?.customDesign?.extrasDesign;
            var targetDesign = (designFragment && !commonFunc.isBlank(designFragment.fromDesign)) ? designFragment.fromDesign : defaultDesignKey;
            var rootDesign = altDesign ? altDesign[targetDesign] : null;
            return getMergedDesign(data, designFragment, rootDesign, forcedMerge);
        }
        else {
            designFragment = forcedMerge ? designFragment : data.mergedDesign;
        }
        return designFragment;
    }



    /****** GESTION DATE (ToolbarDate) ******/

    function selPreviousPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().subtract(1, 'days');
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().startOf('isoWeek').subtract(7, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().startOf('month').subtract(1, 'days').startOf('month');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().startOf('year').subtract(1, 'days').startOf('year');
                break;
            default: break;
        }
        if (begin && (!minDate || begin.isSameOrAfter(minDate))) {
            //setCurDate(begin.startOf('day').format());
            var newDate = begin.utc(true).startOf('day').format();
            setCurDate(newDate);
            if (genModel.toolbarDateConfig?.triggerParent && parentGenArgs?.toolbarArgs?.date) {
                parentGenArgs.toolbarFctManager.setCurDate(newDate);
                if (genModel.toolbarDateConfig.waiting) {
                    Swal.fire({
                        title: t("gal_loading"),
                        didOpen: () => { Swal.showLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        timer: genModel.toolbarDateConfig.waiting
                    });
                }
            }
        }
    }

    function datepickerChange(date) {
        if (!date) date = moment(curDate);

        var newDate = date.format();
        setCurDate(newDate);
        if (genModel.toolbarDateConfig?.triggerParent && parentGenArgs?.toolbarArgs?.date) {
            parentGenArgs.toolbarFctManager.setCurDate(newDate);
            if (genModel.toolbarDateConfig.waiting) {
                Swal.fire({
                    title: t("gal_loading"),
                    didOpen: () => { Swal.showLoading() },
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    allowEnterKey: false,
                    timer: genModel.toolbarDateConfig.waiting
                });
            }
        }
    }

    function selNextPeriod() {
        var curMoment = new moment(curDate);
        var view = curPeriod;
        var begin;

        switch (view) {
            case "D": //JOUR
                begin = curMoment.clone().add(1, 'days')
                break;

            case "L": //SEMAINE 5J
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "W": //SEMAINE
                begin = curMoment.clone().endOf('isoWeek').add(1, 'days');
                break;

            case "M": //MOIS /JOURS
                begin = curMoment.clone().endOf('month').add(1, 'days');
                break;

            case "Y": //ANNEE
                begin = curMoment.clone().endOf('year').add(1, 'days');
                break;
            default: break;
        }
        if (begin && (!maxDate || begin.isSameOrBefore(maxDate))) {
            //setCurDate(begin.startOf('day').format());
            var newDate = begin.utc(true).startOf('day').format();
            setCurDate(newDate);
            if (genModel.toolbarDateConfig?.triggerParent && parentGenArgs?.toolbarArgs?.date) {
                parentGenArgs.toolbarFctManager.setCurDate(newDate);
                if (genModel.toolbarDateConfig.waiting) {
                    Swal.fire({
                        title: t("gal_loading"),
                        didOpen: () => { Swal.showLoading() },
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        allowEnterKey: false,
                        timer: genModel.toolbarDateConfig.waiting
                    });
                }
            }
        }
    }

    function getFormattedDate() {
        switch (curPeriod) {
            case "D": return moment(curDate).format("dddd DD MMMM YYYY");
            case "L": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').subtract(2, 'days').format("ddd DD MMMM YYYY [(S]W[)]");
            case "W": return moment(curDate).startOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]") + " au " + moment(curDate).endOf('isoWeek').format("ddd DD MMMM YYYY [(S]W[)]");
            //case "M": return moment(curDate).startOf('month').format("ddd DD MMMM YYYY") + " au " + moment(curDate).endOf('month').format("ddd DD MMMM YYYY");
            case "M": return moment(curDate).startOf('month').format("MMMM YYYY");
            case "Y": return "Année " + moment(curDate).startOf('year').format("YYYY");
            default: return "";
        }
    }

    /****** FIN GESTION DATE (ToolbarDate) ******/


    /*Notes :
        ReportItem :
            //Dictionnaire d'action (onChange/onLoad : évènement où l'appel va se faire | trigger : action à effectuer | target : cible de l'action | value : valeur a communiquer pour l'action)
            onActionEvents: { onChange: [{ trigger: "duplicateManualReport", target: "target1", value: "value" }], onLoad: [{ trigger: "setValue", target: "", value: "options" }] },
    
            
            defaultValue: "10",//Valeur initial du rapport
            rawValue: "2.1",//valeur brut avant formattage
            value: "2",//Valeur finale
            
            rightAccess: "MUPD",//Gestion des drotis d'accès
            isExcluded: true,//Exlusino de la récupération pour sauvegarde
            dataCache : {} //sous objet de gestion de chargement de l'item
                shouldLoadDefaultValue: true, //défini si il faut charger la valeur par défaut dans le ReportItem
                loadFromCache: true//défini si on doit charger les données depuis le cache
                loadWhenGenerating: true//défini si on doit charger les données à la génération du rapport
            schema: {} //objet basé sur GetSchemaModel


            temporary : true //Défini si il s'agit d'un ReportItem qui doit être supprimé si réinitialisation (un peu comme isCloned)
            isLoaded : true //Défini si les traitement ont déjà été effectué sur un fragment

            Design :
                Gérer une option no padding sur parent
                spacing : 1 //Gestion d'un espacement sur les enfants

    */



    var content = renderData(genModel);

    if (genModel.toolbarDateConfig && !genModel.toolbarDateConfig.internalRootRender) {
        //console.debug("GOO");
        //console.debug(toolbarCpts);
        //console.debug(toolbarCpts.length);
        content = <>
            <ToolbarDate customTitle={getFormattedDate()} hideRefresh={true}
                currentPeriod={curPeriod} updatePeriod={genModel.toolbarDateConfig?.updatePeriod === true ? setCurPeriod : false}
                dateLink={curDate}
                selPreviousPeriod={selPreviousPeriod}
                datepickerChange={datepickerChange}
                selNextPeriod={selNextPeriod}
                datepickerOpt={{ showWeeks: true, initialValue: moment(curDate).utc().toDate(), minDate: minDate?.toDate(), maxDate: maxDate?.toDate() }}
                customAddBtn={<><div className="d-none"></div>{""/*toolbarCpts.map(item => {
                    console.debug(item);
                    return item;
                })*/}</>}
                cPeriods={[
                    { bindid: "D", label: "Jour" },
                    { bindid: "L", label: "Sem. 5J" },
                    { bindid: "W", label: "Semaine" },
                    { bindid: "M", label: "Mois" },
                    { bindid: "Y", label: "Année" }
                ]}></ToolbarDate>
            {content}
        </>;
    }

    if (!(parentProps?.type?.toLowerCase().indexOf("crypt") >= 0 || parentProps?.subType?.toLowerCase().indexOf("crypt") >= 0)) {
        if (errors && Object.keys(errors).length) console.debug(errors);
        var values = getValues();
        if (values && Object.keys(values).length) console.debug(values);
    }


    return (content);

});

export default AGenerateModel;

export function getRgbaFromHex(hex) {
    if (hex.length === 9) {
        var alpha = parseInt(hex.slice(1, 3), 16) / 255;
        var hexN = commonFunc.hexToRgb(hex.substring(3));
        var rgba = "rgba(" + hexN + "," + alpha.toFixed(2) + ")";

        return rgba;
    } else {
        return commonFunc.hexToRgb(hex);
    }
}

export function convertWidthToGrid(widthPercent, withoutClass) {
    var gridValue = Math.round(widthPercent / 100 * 12);
    if (withoutClass) return gridValue;
    return " col-12 col-md-" + gridValue;
}

export function finalizeProcess(data, parentProps, containerGridM) {
    var childCount = parentProps?.parentData?.childCount || 1;
    var childLoaded = parentProps?.parentData?.childLoaded || 0;
    if (!data.loaded) {
        data.loaded = true;
        parentProps.parentData.childLoaded = childLoaded + 1;

        //console.debug("GO FINALIZE " + data.objType + " " + parentProps.parentData.childLoaded + "/" + childCount);

        if (parentProps.parentData.childLoaded >= childCount && !parentProps.parentData.loaded) {
            var parentSupProps = parentProps?.parentData?.functionManager?.getParentProps() || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()
                || parentProps?.parentData?.functionManager.getParentProps()?.parentData?.functionManager?.getParentProps()?.parentData?.functionManager?.getParentProps();
            if (parentSupProps) finalizeProcess(parentProps.parentData, parentSupProps);
            else if (parentProps.parentData.objType === "model") parentProps.parentData.functionManager.finalizeModel();
        }
    }
}

function getMergedDesign(data, designFragment, rootDesign, forcedMerge) {
    if ((forcedMerge || data.mergedDesign == null) /*&& (designFragment == null || !TextUtils.isEmpty(designFragment.fromDesign))*/) {
        if (designFragment == null) {
            designFragment = rootDesign;
        } else if (rootDesign != null) {
            designFragment = Object.assign({}, rootDesign, designFragment);
        }
    }
    else {
        designFragment = forcedMerge ? designFragment : data.mergedDesign;
    }
    return designFragment;
}

function SubGenModal({ t, title, configModel, dataCfg, appProps, checkRights, isSubmitNoCheck, getRoutes, genRef, genId, genType, subType, itemData, noScroll, size, dataElem, autoSave, noSubmit, defaultDisabled, callback }) {
    const altT = (label, args) => { return (label && label.startsWith("i18n:")) ? t(label.replace("i18n:", ""), args) : label };

    var supArgs = {};
    if (defaultDisabled) supArgs.formEditing = false;

    return (
        <Modal isOpen={true} className={`modal-${itemData.subType} ${noScroll ? "modal-noscroll" : ""}`} size={size ? size : "xxl"} scrollable keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2" style={{ overflowX: "hidden" }}>
                <AGenerateModel ref={genRef} noButtons onSubmit={(data, isUpdate, test) => callback(data, isUpdate, test)} appProps={appProps} checkRights={checkRights} getRoutes={getRoutes} parentProps={{ id: genId, type: genType, subType: subType, dataCfg: dataCfg }} keyMode={2} configModel={configModel} loadedData={dataElem} autoSave={autoSave} {...supArgs} />
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                {
                    Object.keys(itemData.argumentsObj).map((key) => {
                        var button = "";
                        if (key.startsWith("button:")) {
                            button = <Button className="px-3" color="primary" onClick={() => {
                                var generateModel = genRef.current;
                                if (generateModel && generateModel.submitForm) {
                                    generateModel.submitForm(itemData.argumentsObj[key]); 
                                }
                            }}><i className="fa fa-edit"></i>{altT(key.replace("button:", ""))}</Button>;
                        }
                        return button;
                    })
                }
                {(autoSave || noSubmit) ? "" :
                    (dataElem ? <Button className="px-3" color="primary" onClick={() => {
                        var generateModel = genRef.current;
                        if ((isSubmitNoCheck || generateModel?.getValues()?.cSubmitNoConfirm) && generateModel?.submitNoCheckForm) {
                            generateModel.submitNoCheckForm();
                        }
                        else {
                            if (generateModel && generateModel.submitForm) {
                                generateModel.submitForm();
                            }
                        }
                    }}><i className="fa fa-edit"></i>{t(subType + "_save")}</Button> : <Button className="px-3" color="success" onClick={() => {
                        var generateModel = genRef.current;
                        if ((isSubmitNoCheck || generateModel?.getValues()?.cSubmitNoConfirm) && generateModel?.submitNoCheckForm) {
                            generateModel.submitNoCheckForm();
                        }
                        else {
                            if (generateModel && generateModel.submitForm) {
                                generateModel.submitForm();
                            }
                        }
                    }}><i className="fa fa-plus"></i>{t(subType + "_add")}</Button>)
                }
                <Button className="px-3" color="danger" onClick={() => { callback(); }}><i className="fa fa-times"></i>{t(subType + "_cancel")}</Button>
            </ModalFooter>
        </Modal>
    );
}

function TakePhotoModal({ t, title, parentContext, callback }) {
    //console.debug("render modal");

    return (
        <Modal isOpen={true} className="modal-report" size="xl" keyboard={false} toggle={() => { callback(); }} backdrop="static" style={{ paddingTop: "0px" }}>
            <ModalHeader className="d-flex" toggle={() => { callback(); }}>{title}</ModalHeader>
            <ModalBody className="px-2">
                <TakePhoto callback={callback} />
            </ModalBody>
            <ModalFooter className="px-2 flex-nowrap">
                <Button className="px-3" color="secondary" onClick={() => { callback(); }}>{t("gal_close")}</Button>
            </ModalFooter>
        </Modal>
    );
}